import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Classification } from '../models/question/question-classification.model';

/**
 * This class has to be extended and overriden
 * on the application using formrenderer library.
 */
@Injectable({
  providedIn: 'root',
})
export class BaseClassificationService {
  // Den här property styr ifall man vill gå mot en riktig eller fake server
  // Det bor alltid checkas in som false
  private readonly FAKE_SERVER_ERROR_ON_UPLOAD = false;
  private readonly FAKE_SERVER_ERROR_ON_DELETE = false;

  public getAllClassification(typeId: string): Observable<Classification[]> {
    if (typeId === 'BO') {
      return of(classificationListBO);
    } else if (typeId === 'FO2011') return of(classificationListFO);
    else return of(classificationListPO);
  }
}
const classificationListBO: Classification[] = [
  {
    identifier: '1',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Arbetsmiljö',
    nameEng: 'Work environment',
    description:
      'Ska tillgodose vårt behov av en god miljö på arbetsplatsen, goda arbetsbetingelse och ett gott skydd mot yrkessjukdomar och yrkesskador.',
    descriptionEng:
      'Will satisfy our need for a good environment at the workplace, good working conditions and good protection against occupational diseases and occupational injuries.',
    level: 1,
  },
  {
    identifier: '2',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Boende',
    nameEng: 'Housing',
    description:
      'Ska tillgodose behovet av bostäder och en god boendemiljö fritt från onödigt buller i tätorter, regioner, landsbygd m.m. Här ingår t.ex. projekt inom byggindustrin, nya byggmaterial, förbättring av inomhusmiljö, etc.',
    descriptionEng:
      'Will satisfy the need for housing and a good living environment free from unnecessary noise in urban areas, regions, rural areas, etc. This includes projects in the construction industry, new building materials, improvement of the indoor environment, etc.',
    level: 1,
  },
  {
    identifier: '3',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Energiförsörjning',
    nameEng: 'Energy supply',
    description:
      'Ska tillgodose behovet av säker och effektiv produktion, distribution och lagring av värme, elektricitet, olja, drivmedel och naturgas. Här ingår bl.a. vindkraft, solceller, etc.',
    descriptionEng:
      'Will satisfy the need for safe and efficient production, distribution and storage of heat, electricity, oil, fuel and natural gas. This includes wind power, solar cells, etc.',
    level: 1,
  },
  {
    identifier: '4',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Hälsa (Hälso- och sjukvård)',
    nameEng: 'Health (healthcare)',
    description:
      'Ska tillgodose behovet av god hälsa genom en väl fungerande hälso- och sjukvård. Här ingår t.ex. prevention, utveckling av nya/förbättrade läkemedel, medicinsk utrustning, sjukvårdorganisation, etc.',
    descriptionEng:
      'Will satisfy the need for good health through well-functioning health and medical care. This includes prevention, development of new/improved medicines, medical equipment, healthcare organization, etc.',
    level: 1,
  },
  {
    identifier: '5',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Kommunikationer',
    nameEng: 'Communications (ICT)',
    description:
      'Ska tillgodose behovet av information, väl fungerande kommunikation, samt tillgängligheten till effektiva och säkra kommunikationstjänster och -utrustning.',
    descriptionEng:
      'Will satisfy the need for information, well-functioning communication, and the availability of efficient and secure communication services and equipment.',
    level: 1,
  },
  {
    identifier: '6',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Livsmedel (Näring)',
    nameEng: 'Food (nutrition)',
    description:
      'Ska tillgodose behovet av en god, rätt sammansatt och näringsriktig kost som är säker och giftfri.',
    descriptionEng:
      'Will satisfy the need for a good, properly composed and nutritious diet that is safe and non-toxic.',
    level: 1,
  },
  {
    identifier: '7',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Miljö',
    nameEng: 'Environment',
    description:
      'Ska leda till positiva miljöeffekter. Det ska tillgodose behovet av en oförstörd fysisk miljö, fri från luft-, vatten och markföroreningar. Här ingår även återvinning, rening, reningstekniker.',
    descriptionEng:
      'Will lead to positive environmental effects. It will satisfy the need for an unspoiled physical environment, free from air-, water- and soil-pollution. This also includes recycling, purification, purification techniques.',
    level: 1,
  },
  {
    identifier: '8',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Omsorg (Trygghet)',
    nameEng: 'Social and elderly care',
    description:
      'Ska tillgodose behovet av en god social miljö och sociala relationer, t ex socialvård, åldringsvård, barn- och ungdomsvård, handikappvård, människans trygghet inför arbetslöshet, sjukdom, ålderdom m.m.',
    descriptionEng:
      "Will satisfy the need for a good social environment and social relations, e.g. social care, elderly care, child and youth care, disability care, people's security in the face of unemployment, illness, old age, etc.",
    level: 1,
  },
  {
    identifier: '9',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Säkerhet',
    nameEng: 'Safety and security',
    description:
      'Ska tillgodose behovet av allmän ordning och säkerhet i samhället. Här ingår åtgärder eller utrustning som minskar sannolikheten för att olyckor eller andra oönskade händelser skall inträffa.',
    descriptionEng:
      'Will meet the need for public order and safety in society. This includes activities or equipment that reduce the likelihood of accidents or other unwanted events occurring.',
    level: 1,
  },
  {
    identifier: '10',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Transporter',
    nameEng: 'Transportation',
    description:
      'Ska tillgodose behovet av goda och säkra transporter av varor och människor till lands, till sjöss och i luften. Här ingår fordon/transportmedel och transportsystem, t.ex. vägar, järnvägar.',
    descriptionEng:
      'Will satisfy the need for good and safe transportation of goods and people on land, at sea and in the air. This includes vehicles/means of transport and transport systems, e.g. roads, railways.',
    level: 1,
  },
  {
    identifier: '11',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Underhållning',
    nameEng: 'Entertainment',
    description:
      'Ska tillgodose behovet av nöje, kultur (museer, bibliotek, teater, film, konst, musik, litteratur m.m. samt massmedia), sport och möjligheterna till fritidsaktiviteter (sport, motion, rekreation m.m.).',
    descriptionEng:
      'Will satisfy the need for entertainment, culture (museums, libraries, theatre, film, art, music, literature, etc. and mass media), sports and opportunities for leisure activities (sports, exercise, recreation, etc.).',
    level: 1,
  },
  {
    identifier: '12',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Utbildning (lärande)',
    nameEng: 'Education (learning)',
    description:
      'Ska tillgodose behovet av kunskapsutveckling och lärande på alla nivåer, oavsett undervisningsform.',
    descriptionEng:
      'Will satisfy the need for knowledge development and learning at all levels, regardless of the form of teaching.',
    level: 1,
  },
  {
    identifier: '13',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Vatten(försörjning)',
    nameEng: 'Water (supply)',
    description:
      'Ska tillgodose behovet av en säker och hållbar framställning, distribution och lagring av rent vatten.',
    descriptionEng:
      'Will satisfy the need for safe and sustainable production, distribution and storage of clean water.',
    level: 1,
  },
  {
    identifier: '14',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Affärsprocesser',
    nameEng: 'Business processes',
    description:
      'Ska tillgodose behovet av effektivisering och utveckling av affärsprocesser eller affärsmetoder, t.ex. utveckling och effektivisering av organisation, strategier, metoder och processer, nya sätt att leverera, digitalisering av tjänster, nya sätt att betala eller nya sätt att få kunder/användare.',
    descriptionEng:
      'Will meet the need for streamlining and development of business processes or business methods, e.g. development and streamlining of organsation, strategies, methods and processes, new ways of delivering, digitalisation of services, new ways of paying or new ways of getting customers/users.',
    level: 1,
  },
  {
    identifier: '15',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Arbetsorganisation och ledning',
    nameEng: 'Organisation and leadership',
    description:
      'Ska tillgodose behovet av att utveckla organisationers innovationsförmåga genom förnyelse av arbetsorganisation och ledningsformer för att tillvarata och utveckla mänskliga resurser. Det innefattar att tillgodose behovet av hållbara arbetsvillkor.',
    descriptionEng:
      "Will meet the need to develop organization's innovative capacity through renewal of work organization and forms of management in order to utilize and develop human resources. It includes meeting the need for sustainable working conditions.",
    level: 1,
  },
  {
    identifier: '16',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Produktionsprocesser',
    nameEng: 'Production processes',
    description:
      'Ska tillgodose behovet av effektivisering av produktions- och planeringsprocesser, t.ex. varuproduktion inom tillverkningsindustri och beredning inkl. stödsystem.',
    descriptionEng:
      'Will satisfy the need for streamlining production and planning processes, e.g. goods production within the manufacturing industry and preparation incl. support system.',
    level: 1,
  },
  {
    identifier: '17',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    name: 'Övrigt (inget av ovanstående)',
    nameEng: 'Miscellaneous (none of the above)',
    description:
      'Avser projekt där innehållet inte har någon relevant koppling till ovanstående kategorier.',
    descriptionEng:
      'For project where the content has no relevant connection to the above categories.',
    level: 1,
  },
];

const classificationListFO: Classification[] = [
  {
    identifier: '1',
    name: 'Naturvetenskap',
    nameEng: 'Natural Sciences',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '101',
    name: 'Matematik',
    nameEng: 'Mathematics',
    parentId: '1',
    level: 2,
  },
  {
    identifier: '10101',
    name: 'Matematisk analys',
    nameEng: 'Mathematical Analysis',
    parentId: '101',
    level: 3,
  },
  {
    identifier: '10102',
    name: 'Geometri',
    nameEng: 'Geometry',
    parentId: '101',
    level: 3,
  },
  {
    identifier: '10103',
    name: 'Algebra och logik',
    nameEng: 'Algebra and Logic',
    parentId: '101',
    level: 3,
  },
  {
    identifier: '10104',
    name: 'Diskret matematik',
    nameEng: 'Discrete Mathematics',
    parentId: '101',
    level: 3,
  },
  {
    identifier: '10105',
    name: 'Beräkningsmatematik',
    nameEng: 'Computational Mathematics',
    parentId: '101',
    level: 3,
  },
  {
    identifier: '10106',
    name: 'Sannolikhetsteori och statistik',
    nameEng: 'Probability Theory and Statistics',
    parentId: '101',
    level: 3,
  },
  {
    identifier: '10199',
    name: 'Annan matematik',
    nameEng: 'Other Mathematics',
    parentId: '101',
    level: 3,
  },
  {
    identifier: '102',
    name: 'Data- och informationsvetenskap (Datateknik)',
    nameEng: 'Computer and Information Sciences',
    parentId: '1',
    level: 2,
  },
  {
    identifier: '10201',
    name: 'Datavetenskap (datalogi)',
    nameEng: 'Computer Sciences',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10202',
    name: 'Systemvetenskap, informationssystem och informatik (samhällsvetenskaplig inriktning under 50804)',
    nameEng: 'Information Systems (Social aspects to be 50804)',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10203',
    name: 'Bioinformatik (beräkningsbiologi) (tillämpningar under 10610)',
    nameEng:
      'Bioinformatics (Computational Biology) (applications to be 10610)',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10204',
    name: 'Människa-datorinteraktion (interaktionsdesign) (Samhällsvetenskapliga aspekter under 50803)',
    nameEng: 'Human Computer Interaction (Social aspects to be 50803)',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10205',
    name: 'Programvaruteknik',
    nameEng: 'Software Engineering',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10206',
    name: 'Datorteknik',
    nameEng: 'Computer Engineering',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10207',
    name: 'Datorseende och robotik (autonoma system)',
    nameEng: 'Computer Vision and Robotics (Autonomous Systems)',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10208',
    name: 'Språkteknologi (språkvetenskaplig databehandling)',
    nameEng: 'Language Technology (Computational Linguistics)',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10209',
    name: 'Medieteknik',
    nameEng: 'Media and Communication Technology',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '10299',
    name: 'Annan data- och informationsvetenskap',
    nameEng: 'Other Computer and Information Science',
    parentId: '102',
    level: 3,
  },
  {
    identifier: '103',
    name: 'Fysik',
    nameEng: 'Physical Sciences',
    parentId: '1',
    level: 2,
  },
  {
    identifier: '10301',
    name: 'Subatomär fysik',
    nameEng: 'Subatomic Physics',
    parentId: '103',
    level: 3,
  },
  {
    identifier: '10302',
    name: 'Atom- och molekylfysik och optik',
    nameEng: 'Atom and Molecular Physics and Optics',
    parentId: '103',
    level: 3,
  },
  {
    identifier: '10303',
    name: 'Fusion, plasma och rymdfysik',
    nameEng: 'Fusion, Plasma and Space Physics',
    parentId: '103',
    level: 3,
  },
  {
    identifier: '10304',
    name: 'Den kondenserade materiens fysik',
    nameEng: 'Condensed Matter Physics',
    parentId: '103',
    level: 3,
  },
  {
    identifier: '10305',
    name: 'Astronomi, astrofysik och kosmologi',
    nameEng: 'Astronomy, Astrophysics and Cosmology',
    parentId: '103',
    level: 3,
  },
  {
    identifier: '10306',
    name: 'Acceleratorfysik och instrumentering',
    nameEng: 'Accelerator Physics and Instrumentation',
    parentId: '103',
    level: 3,
  },
  {
    identifier: '10399',
    name: 'Annan fysik',
    nameEng: 'Other Physics Topics',
    parentId: '103',
    level: 3,
  },
  {
    identifier: '104',
    name: 'Kemi',
    nameEng: 'Chemical Sciences',
    parentId: '1',
    level: 2,
  },
  {
    identifier: '10401',
    name: 'Analytisk kemi',
    nameEng: 'Analytical Chemistry',
    parentId: '104',
    level: 3,
  },
  {
    identifier: '10402',
    name: 'Fysikalisk kemi',
    nameEng: 'Physical Chemistry',
    parentId: '104',
    level: 3,
  },
  {
    identifier: '10403',
    name: 'Materialkemi',
    nameEng: 'Materials Chemistry',
    parentId: '104',
    level: 3,
  },
  {
    identifier: '10404',
    name: 'Oorganisk kemi',
    nameEng: 'Inorganic Chemistry',
    parentId: '104',
    level: 3,
  },
  {
    identifier: '10405',
    name: 'Organisk kemi',
    nameEng: 'Organic Chemistry',
    parentId: '104',
    level: 3,
  },
  {
    identifier: '10406',
    name: 'Polymerkemi',
    nameEng: 'Polymer Chemistry',
    parentId: '104',
    level: 3,
  },
  {
    identifier: '10407',
    name: 'Teoretisk kemi',
    nameEng: 'Theoretical Chemistry',
    parentId: '104',
    level: 3,
  },
  {
    identifier: '10499',
    name: 'Annan kemi',
    nameEng: 'Other Chemistry Topics',
    parentId: '104',
    level: 3,
  },
  {
    identifier: '105',
    name: 'Geovetenskap och miljövetenskap',
    nameEng: 'Earth and Related Environmental Sciences',
    parentId: '1',
    level: 2,
  },
  {
    identifier: '10501',
    name: 'Klimatforskning',
    nameEng: 'Climate Research',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10502',
    name: 'Miljövetenskap (Samhällsvetenskapliga aspekter under 507)',
    nameEng: 'Environmental Sciences (social aspects to be 507)',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10503',
    name: 'Multidisciplinär geovetenskap',
    nameEng: 'Geosciences, Multidisciplinary',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10504',
    name: 'Geologi',
    nameEng: 'Geology',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10505',
    name: 'Geofysik',
    nameEng: 'Geophysics',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10506',
    name: 'Geokemi',
    nameEng: 'Geochemistry',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10507',
    name: 'Fysisk geografi',
    nameEng: 'Physical Geography',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10508',
    name: 'Meteorologi och atmosfärforskning',
    nameEng: 'Meteorology and Atmospheric Sciences',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10509',
    name: 'Oceanografi, hydrologi och vattenresurser',
    nameEng: 'Oceanography, Hydrology and Water Resources',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '10599',
    name: 'Annan geovetenskap och miljövetenskap',
    nameEng: 'Other Earth and Related Environmental Sciences',
    parentId: '105',
    level: 3,
  },
  {
    identifier: '106',
    name: 'Biologi (Medicinska tillämpningar under 3 och lantbruksvetenskapliga under 4)',
    nameEng: 'Biological Sciences  (Medical to be 3 and Agricultural to be 4)',
    parentId: '1',
    level: 2,
  },
  {
    identifier: '10601',
    name: 'Strukturbiologi',
    nameEng: 'Structural Biology',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10602',
    name: 'Biokemi och molekylärbiologi',
    nameEng: 'Biochemistry and Molecular Biology',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10603',
    name: 'Biofysik',
    nameEng: 'Biophysics',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10604',
    name: 'Cellbiologi',
    nameEng: 'Cell Biology',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10605',
    name: 'Immunologi (medicinsk under 30110 och lantbruksvetenskaplig under 40302)',
    nameEng: 'Immunology (medical to be 30110 and agricultural to be 40302)',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10606',
    name: 'Mikrobiologi (medicinsk under 30109 och lantbruksvetenskaplig under 40302)',
    nameEng: 'Microbiology (medical to be 30109 and agricultural to be 40302)',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10607',
    name: 'Botanik',
    nameEng: 'Botany',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10608',
    name: 'Zoologi',
    nameEng: 'Zoology',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10609',
    name: 'Genetik (medicinsk under 30107 och lantbruksvetenskaplig under 40402)',
    nameEng: 'Genetics (medical to be 30107 and agricultural to be 40402)',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10610',
    name: 'Bioinformatik och systembiologi (metodutveckling under 10203)',
    nameEng:
      'Bioinformatics and Systems Biology (methods development to be 10203)',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10611',
    name: 'Ekologi',
    nameEng: 'Ecology',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10612',
    name: 'Biologisk systematik',
    nameEng: 'Biological Systematics',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10613',
    name: 'Etologi',
    nameEng: 'Behavioural Sciences Biology',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10614',
    name: 'Utvecklingsbiologi',
    nameEng: 'Developmental Biology',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10615',
    name: 'Evolutionsbiologi',
    nameEng: 'Evolutionary Biology',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '10699',
    name: 'Annan biologi',
    nameEng: 'Other Biological Topics',
    parentId: '106',
    level: 3,
  },
  {
    identifier: '107',
    name: 'Annan naturvetenskap',
    nameEng: 'Other Natural Sciences',
    parentId: '1',
    level: 2,
  },
  {
    identifier: '10799',
    name: 'Övrig annan naturvetenskap',
    nameEng: 'Other Natural Sciences not elsewhere specified',
    parentId: '107',
    level: 3,
  },
  {
    identifier: '2',
    name: 'Teknik',
    nameEng: 'Engineering and Technology',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '201',
    name: 'Samhällsbyggnadsteknik',
    nameEng: 'Civil Engineering',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20101',
    name: 'Arkitekturteknik',
    nameEng: 'Architectural Engineering',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '20102',
    name: 'Byggproduktion',
    nameEng: 'Construction Management',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '20103',
    name: 'Husbyggnad',
    nameEng: 'Building Technologies',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '20104',
    name: 'Infrastrukturteknik',
    nameEng: 'Infrastructure Engineering',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '20105',
    name: 'Transportteknik och logistik',
    nameEng: 'Transport Systems and Logistics',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '20106',
    name: 'Geoteknik',
    nameEng: 'Geotechnical Engineering',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '20107',
    name: 'Vattenteknik',
    nameEng: 'Water Engineering',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '20108',
    name: 'Miljöanalys och bygginformationsteknik',
    nameEng: 'Environmental Analysis and Construction Information Technology',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '20199',
    name: 'Annan samhällsbyggnadsteknik',
    nameEng: 'Other Civil Engineering',
    parentId: '201',
    level: 3,
  },
  {
    identifier: '202',
    name: 'Elektroteknik och elektronik',
    nameEng:
      'Electrical Engineering, Electronic Engineering, Information Engineering',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20201',
    name: 'Robotteknik och automation',
    nameEng: 'Robotics',
    parentId: '202',
    level: 3,
  },
  {
    identifier: '20202',
    name: 'Reglerteknik',
    nameEng: 'Control Engineering',
    parentId: '202',
    level: 3,
  },
  {
    identifier: '20203',
    name: 'Kommunikationssystem',
    nameEng: 'Communication Systems',
    parentId: '202',
    level: 3,
  },
  {
    identifier: '20204',
    name: 'Telekommunikation',
    nameEng: 'Telecommunications',
    parentId: '202',
    level: 3,
  },
  {
    identifier: '20205',
    name: 'Signalbehandling',
    nameEng: 'Signal Processing',
    parentId: '202',
    level: 3,
  },
  {
    identifier: '20206',
    name: 'Datorsystem',
    nameEng: 'Computer Systems',
    parentId: '202',
    level: 3,
  },
  {
    identifier: '20207',
    name: 'Inbäddad systemteknik',
    nameEng: 'Embedded Systems',
    parentId: '202',
    level: 3,
  },
  {
    identifier: '20299',
    name: 'Annan elektroteknik och elektronik',
    nameEng:
      'Other Electrical Engineering, Electronic Engineering, Information Engineering',
    parentId: '202',
    level: 3,
  },
  {
    identifier: '203',
    name: 'Maskinteknik',
    nameEng: 'Mechanical Engineering',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20301',
    name: 'Teknisk mekanik',
    nameEng: 'Applied Mechanics',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '20302',
    name: 'Rymd- och flygteknik',
    nameEng: 'Aerospace Engineering',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '20303',
    name: 'Farkostteknik',
    nameEng: 'Vehicle Engineering',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '20304',
    name: 'Energiteknik',
    nameEng: 'Energy Engineering',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '20305',
    name: 'Tillförlitlighets- och kvalitetsteknik',
    nameEng: 'Reliability and Maintenance',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '20306',
    name: 'Strömningsmekanik och akustik',
    nameEng: 'Fluid Mechanics and Acoustics',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '20307',
    name: 'Produktionsteknik, arbetsvetenskap och ergonomi',
    nameEng: 'Production Engineering, Human Work Science and Ergonomics',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '20308',
    name: 'Tribologi (ytteknik omfattande friktion, nötning och smörjning)',
    nameEng:
      'Tribology (interacting surfaces including Friction, Lubrication and Wear)',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '20399',
    name: 'Annan maskinteknik',
    nameEng: 'Other Mechanical Engineering',
    parentId: '203',
    level: 3,
  },
  {
    identifier: '204',
    name: 'Kemiteknik',
    nameEng: 'Chemical Engineering',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20401',
    name: 'Kemiska processer',
    nameEng: 'Chemical Process Engineering',
    parentId: '204',
    level: 3,
  },
  {
    identifier: '20402',
    name: 'Korrosionsteknik',
    nameEng: 'Corrosion Engineering',
    parentId: '204',
    level: 3,
  },
  {
    identifier: '20403',
    name: 'Polymerteknologi',
    nameEng: 'Polymer Technologies',
    parentId: '204',
    level: 3,
  },
  {
    identifier: '20404',
    name: 'Farmaceutisk synteskemi',
    nameEng: 'Pharmaceutical Chemistry',
    parentId: '204',
    level: 3,
  },
  {
    identifier: '20499',
    name: 'Annan kemiteknik',
    nameEng: 'Other Chemical Engineering',
    parentId: '204',
    level: 3,
  },
  {
    identifier: '205',
    name: 'Materialteknik',
    nameEng: 'Materials Engineering',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20501',
    name: 'Keramteknik',
    nameEng: 'Ceramics',
    parentId: '205',
    level: 3,
  },
  {
    identifier: '20502',
    name: 'Kompositmaterial och -teknik',
    nameEng: 'Composite Science and Engineering',
    parentId: '205',
    level: 3,
  },
  {
    identifier: '20503',
    name: 'Pappers-, massa- och fiberteknik',
    nameEng: 'Paper, Pulp and Fiber Technology',
    parentId: '205',
    level: 3,
  },
  {
    identifier: '20504',
    name: 'Textil-, gummi- och polymermaterial',
    nameEng: 'Textile, Rubber and Polymeric Materials',
    parentId: '205',
    level: 3,
  },
  {
    identifier: '20505',
    name: 'Bearbetnings-, yt- och fogningsteknik',
    nameEng: 'Manufacturing, Surface and Joining Technology',
    parentId: '205',
    level: 3,
  },
  {
    identifier: '20506',
    name: 'Metallurgi och metalliska material',
    nameEng: 'Metallurgy and Metallic Materials',
    parentId: '205',
    level: 3,
  },
  {
    identifier: '20599',
    name: 'Annan materialteknik',
    nameEng: 'Other Materials Engineering',
    parentId: '205',
    level: 3,
  },
  {
    identifier: '206',
    name: 'Medicinteknik',
    nameEng: 'Medical Engineering',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20601',
    name: 'Medicinsk laboratorie- och mätteknik',
    nameEng: 'Medical Laboratory and Measurements Technologies',
    parentId: '206',
    level: 3,
  },
  {
    identifier: '20602',
    name: 'Medicinsk material- och protesteknik',
    nameEng: 'Medical Materials',
    parentId: '206',
    level: 3,
  },
  {
    identifier: '20603',
    name: 'Medicinsk bildbehandling',
    nameEng: 'Medical Image Processing',
    parentId: '206',
    level: 3,
  },
  {
    identifier: '20604',
    name: 'Medicinsk apparatteknik',
    nameEng: 'Medical Equipment Engineering',
    parentId: '206',
    level: 3,
  },
  {
    identifier: '20605',
    name: 'Medicinsk ergonomi',
    nameEng: 'Medical Ergonomics',
    parentId: '206',
    level: 3,
  },
  {
    identifier: '20699',
    name: 'Annan medicinteknik',
    nameEng: 'Other Medical Engineering',
    parentId: '206',
    level: 3,
  },
  {
    identifier: '207',
    name: 'Naturresursteknik',
    nameEng: 'Environmental Engineering',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20701',
    name: 'Geofysisk teknik',
    nameEng: 'Geophysical Engineering',
    parentId: '207',
    level: 3,
  },
  {
    identifier: '20702',
    name: 'Energisystem',
    nameEng: 'Energy Systems',
    parentId: '207',
    level: 3,
  },
  {
    identifier: '20703',
    name: 'Fjärranalysteknik',
    nameEng: 'Remote Sensing',
    parentId: '207',
    level: 3,
  },
  {
    identifier: '20704',
    name: 'Mineral- och gruvteknik',
    nameEng: 'Mineral and Mine Engineering',
    parentId: '207',
    level: 3,
  },
  {
    identifier: '20705',
    name: 'Marin teknik',
    nameEng: 'Marine Engineering',
    parentId: '207',
    level: 3,
  },
  {
    identifier: '20706',
    name: 'Havs- och vattendragsteknik',
    nameEng: 'Ocean and River Engineering',
    parentId: '207',
    level: 3,
  },
  {
    identifier: '20707',
    name: 'Miljöledning',
    nameEng: 'Environmental Management',
    parentId: '207',
    level: 3,
  },
  {
    identifier: '20799',
    name: 'Annan naturresursteknik',
    nameEng: 'Other Environmental Engineering',
    parentId: '207',
    level: 3,
  },
  {
    identifier: '208',
    name: 'Miljöbioteknik',
    nameEng: 'Environmental Biotechnology',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20801',
    name: 'Biosanering',
    nameEng: 'Bioremediation',
    parentId: '208',
    level: 3,
  },
  {
    identifier: '20802',
    name: 'Diagnostisk bioteknologi',
    nameEng: 'Diagnostic Biotechnology',
    parentId: '208',
    level: 3,
  },
  {
    identifier: '20803',
    name: 'Vattenbehandling',
    nameEng: 'Water Treatment',
    parentId: '208',
    level: 3,
  },
  {
    identifier: '20804',
    name: 'Bioteknisk etik',
    nameEng: 'Bioethics',
    parentId: '208',
    level: 3,
  },
  {
    identifier: '20899',
    name: 'Annan miljöbioteknik',
    nameEng: 'Other Environmental Biotechnology',
    parentId: '208',
    level: 3,
  },
  {
    identifier: '209',
    name: 'Industriell bioteknik',
    nameEng: 'Industrial Biotechnology',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '20901',
    name: 'Bioprocessteknik',
    nameEng: 'Bioprocess Technology',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '20902',
    name: 'Biokemikalier',
    nameEng: 'Biochemicals',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '20903',
    name: 'Biomaterial',
    nameEng: 'Bio Materials',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '20904',
    name: 'Bioenergi',
    nameEng: 'Bioenergy',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '20905',
    name: 'Läkemedelsbioteknik',
    nameEng: 'Pharmaceutical Biotechnology',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '20906',
    name: 'Biokatalys och enzymteknik',
    nameEng: 'Biocatalysis and Enzyme Technology',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '20907',
    name: 'Bioteknisk apparatteknik',
    nameEng: 'Bioengineering Equipment',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '20908',
    name: 'Medicinsk bioteknik',
    nameEng: 'Medical Biotechnology',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '20999',
    name: 'Annan industriell bioteknik',
    nameEng: 'Other Industrial Biotechnology',
    parentId: '209',
    level: 3,
  },
  {
    identifier: '210',
    name: 'Nanoteknik',
    nameEng: 'Nano-technology',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '21001',
    name: 'Nanoteknik',
    nameEng: 'Nano-technology',
    parentId: '210',
    level: 3,
  },
  {
    identifier: '211',
    name: 'Annan teknik',
    nameEng: 'Other Engineering and Technologies',
    parentId: '2',
    level: 2,
  },
  {
    identifier: '21101',
    name: 'Livsmedelsteknik',
    nameEng: 'Food Engineering',
    parentId: '211',
    level: 3,
  },
  {
    identifier: '21102',
    name: 'Mediateknik',
    nameEng: 'Media Engineering',
    parentId: '211',
    level: 3,
  },
  {
    identifier: '21103',
    name: 'Interaktionsteknik',
    nameEng: 'Interaction Technologies',
    parentId: '211',
    level: 3,
  },
  {
    identifier: '21199',
    name: 'Övrig annan teknik',
    nameEng: 'Other Engineering and Technologies not elsewhere specified',
    parentId: '211',
    level: 3,
  },
  {
    identifier: '3',
    name: 'Medicin och hälsovetenskap',
    nameEng: 'Medical and Health Sciences',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '301',
    name: 'Medicinska och farmaceutiska grundvetenskaper',
    nameEng: 'Basic Medicine',
    parentId: '3',
    level: 2,
  },
  {
    identifier: '30101',
    name: 'Farmaceutiska vetenskaper',
    nameEng: 'Pharmaceutical Sciences',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30102',
    name: 'Farmakologi och toxikologi',
    nameEng: 'Pharmacology and Toxicology',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30103',
    name: 'Läkemedelskemi',
    nameEng: 'Medicinal Chemistry',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30104',
    name: 'Samhällsfarmaci och klinisk farmaci',
    nameEng: 'Social and Clinical Pharmacy',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30105',
    name: 'Neurovetenskaper',
    nameEng: 'Neurosciences',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30106',
    name: 'Fysiologi',
    nameEng: 'Physiology',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30107',
    name: 'Medicinsk genetik',
    nameEng: 'Medical Genetics',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30108',
    name: 'Cell- och molekylärbiologi',
    nameEng: 'Cell and Molecular Biology',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30109',
    name: 'Mikrobiologi inom det medicinska området',
    nameEng: 'Microbiology in the medical area',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30110',
    name: 'Immunologi inom det medicinska området',
    nameEng: 'Immunology in the medical area',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '30199',
    name: 'Andra medicinska och farmaceutiska grundvetenskaper',
    nameEng: 'Other Basic Medicine',
    parentId: '301',
    level: 3,
  },
  {
    identifier: '302',
    name: 'Klinisk medicin',
    nameEng: 'Clinical Medicine',
    parentId: '3',
    level: 2,
  },
  {
    identifier: '30201',
    name: 'Anestesi och intensivvård',
    nameEng: 'Anesthesiology and Intensive Care',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30202',
    name: 'Hematologi',
    nameEng: 'Hematology',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30203',
    name: 'Cancer och onkologi',
    nameEng: 'Cancer and Oncology',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30204',
    name: 'Dermatologi och venerologi',
    nameEng: 'Dermatology and Venereal Diseases',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30205',
    name: 'Endokrinologi och diabetes',
    nameEng: 'Endocrinology and Diabetes',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30206',
    name: 'Kardiologi',
    nameEng: 'Cardiac and Cardiovascular Systems',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30207',
    name: 'Neurologi',
    nameEng: 'Neurology',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30208',
    name: 'Radiologi och bildbehandling',
    nameEng: 'Radiology, Nuclear Medicine and Medical Imaging',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30209',
    name: 'Infektionsmedicin',
    nameEng: 'Infectious Medicine',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30210',
    name: 'Reumatologi och inflammation',
    nameEng: 'Rheumatology and Autoimmunity',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30211',
    name: 'Ortopedi',
    nameEng: 'Orthopaedics',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30212',
    name: 'Kirurgi',
    nameEng: 'Surgery',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30213',
    name: 'Gastroenterologi',
    nameEng: 'Gastroenterology and Hepatology',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30214',
    name: 'Urologi och njurmedicin',
    nameEng: 'Urology and Nephrology',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30215',
    name: 'Psykiatri',
    nameEng: 'Psychiatry',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30216',
    name: 'Odontologi',
    nameEng: 'Dentistry',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30217',
    name: 'Oftalmologi',
    nameEng: 'Ophthalmology',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30218',
    name: 'Oto-rino-laryngologi',
    nameEng: 'Otorhinolaryngology',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30219',
    name: 'Lungmedicin och allergi',
    nameEng: 'Respiratory Medicine and Allergy',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30220',
    name: 'Reproduktionsmedicin och gynekologi',
    nameEng: 'Obstetrics, Gynaecology and Reproductive Medicine',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30221',
    name: 'Pediatrik',
    nameEng: 'Pediatrics',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30222',
    name: 'Geriatrik',
    nameEng: 'Geriatrics',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30223',
    name: 'Klinisk laboratoriemedicin',
    nameEng: 'Clinical Laboratory Medicine',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30224',
    name: 'Allmän medicin',
    nameEng: 'General Medicine',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '30299',
    name: 'Annan klinisk medicin',
    nameEng: 'Other Clinical Medicine',
    parentId: '302',
    level: 3,
  },
  {
    identifier: '303',
    name: 'Hälsovetenskap',
    nameEng: 'Health Sciences',
    parentId: '3',
    level: 2,
  },
  {
    identifier: '30301',
    name: 'Hälso- och sjukvårdsorganisation, hälsopolitik och hälsoekonomi',
    nameEng:
      'Health Care Service and Management, Health Policy and Services and Health Economy',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30302',
    name: 'Folkhälsovetenskap, global hälsa, socialmedicin och epidemiologi',
    nameEng: 'Public Health, Global Health, Social Medicine and Epidemiology',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30303',
    name: 'Arbetsmedicin och miljömedicin',
    nameEng: 'Occupational Health and Environmental Health',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30304',
    name: 'Näringslära',
    nameEng: 'Nutrition and Dietetics',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30305',
    name: 'Omvårdnad',
    nameEng: 'Nursing',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30306',
    name: 'Arbetsterapi',
    nameEng: 'Occupational Therapy',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30307',
    name: 'Sjukgymnastik',
    nameEng: 'Physiotherapy',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30308',
    name: 'Idrottsvetenskap',
    nameEng: 'Sport and Fitness Sciences',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30309',
    name: 'Beroendelära',
    nameEng: 'Substance Abuse',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30310',
    name: 'Medicinsk etik',
    nameEng: 'Medical Ethics',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '30399',
    name: 'Annan hälsovetenskap',
    nameEng: 'Other Health Sciences',
    parentId: '303',
    level: 3,
  },
  {
    identifier: '304',
    name: 'Medicinsk bioteknologi',
    nameEng: 'Medical Biotechnology',
    parentId: '3',
    level: 2,
  },
  {
    identifier: '30401',
    name: 'Medicinsk bioteknologi (inriktn. mot cellbiologi (inkl. stamcellsbiologi), molekylärbiologi, mikrobiologi, biokemi eller biofarmaci)',
    nameEng:
      'Medical Biotechnology (focus on Cell Biology (incl. Stem Cell Biology), Molecular Biology, Microbiology, Biochemistry or Biopharmacy)',
    parentId: '304',
    level: 3,
  },
  {
    identifier: '30402',
    name: 'Biomedicinsk laboratorievetenskap/teknologi',
    nameEng: 'Biomedical Laboratory Science/Technology',
    parentId: '304',
    level: 3,
  },
  {
    identifier: '30403',
    name: 'Biomaterialvetenskap',
    nameEng: 'Biomaterials Science',
    parentId: '304',
    level: 3,
  },
  {
    identifier: '30499',
    name: 'Annan medicinsk bioteknologi',
    nameEng: 'Other Medical Biotechnology',
    parentId: '304',
    level: 3,
  },
  {
    identifier: '305',
    name: 'Annan medicin och hälsovetenskap',
    nameEng: 'Other Medical Sciences',
    parentId: '3',
    level: 2,
  },
  {
    identifier: '30501',
    name: 'Rättsmedicin',
    nameEng: 'Forensic Science',
    parentId: '305',
    level: 3,
  },
  {
    identifier: '30502',
    name: 'Gerontologi, medicinsk/hälsovetenskaplig inriktning (Samhällsvetenskaplig inriktn.under 50999)',
    nameEng:
      'Gerontology, specialising in Medical and Health Sciences (specialising in Social Sciences to be 50999)',
    parentId: '305',
    level: 3,
  },
  {
    identifier: '30599',
    name: 'Övrig annan medicin och hälsovetenskap',
    nameEng: 'Other Medical and Health Sciences not elsewhere specified',
    parentId: '305',
    level: 3,
  },
  {
    identifier: '4',
    name: 'Lantbruksvetenskap och veterinärmedicin',
    nameEng: 'Agricultural and Veterinary sciences',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '401',
    name: 'Lantbruksvetenskap, skogsbruk och fiske',
    nameEng: 'Agricultural, Forestry and Fisheries',
    parentId: '4',
    level: 2,
  },
  {
    identifier: '40101',
    name: 'Jordbruksvetenskap',
    nameEng: 'Agricultural Science',
    parentId: '401',
    level: 3,
  },
  {
    identifier: '40102',
    name: 'Trädgårdsvetenskap/hortikultur',
    nameEng: 'Horticulture',
    parentId: '401',
    level: 3,
  },
  {
    identifier: '40103',
    name: 'Livsmedelsvetenskap',
    nameEng: 'Food Science',
    parentId: '401',
    level: 3,
  },
  {
    identifier: '40104',
    name: 'Skogsvetenskap',
    nameEng: 'Forest Science',
    parentId: '401',
    level: 3,
  },
  {
    identifier: '40105',
    name: 'Trävetenskap',
    nameEng: 'Wood Science',
    parentId: '401',
    level: 3,
  },
  {
    identifier: '40106',
    name: 'Markvetenskap',
    nameEng: 'Soil Science',
    parentId: '401',
    level: 3,
  },
  {
    identifier: '40107',
    name: 'Fisk- och akvakulturforskning',
    nameEng: 'Fish and Aquacultural Science',
    parentId: '401',
    level: 3,
  },
  {
    identifier: '40108',
    name: 'Landskapsarkitektur',
    nameEng: 'Landscape Architecture',
    parentId: '401',
    level: 3,
  },
  {
    identifier: '402',
    name: 'Husdjursvetenskap',
    nameEng: 'Animal and Dairy Sience',
    parentId: '4',
    level: 2,
  },
  {
    identifier: '40201',
    name: 'Husdjursvetenskap',
    nameEng: 'Animal and Dairy Science.',
    parentId: '402',
    level: 3,
  },
  {
    identifier: '403',
    name: 'Veterinärmedicin',
    nameEng: 'Veterinary Science',
    parentId: '4',
    level: 2,
  },
  {
    identifier: '40301',
    name: 'Medicinsk biovetenskap',
    nameEng: 'Medical Bioscience',
    parentId: '403',
    level: 3,
  },
  {
    identifier: '40302',
    name: 'Patobiologi',
    nameEng: 'Pathobiology',
    parentId: '403',
    level: 3,
  },
  {
    identifier: '40303',
    name: 'Klinisk vetenskap',
    nameEng: 'Clinical Science',
    parentId: '403',
    level: 3,
  },
  {
    identifier: '40304',
    name: 'Annan vetrinärmedicin',
    nameEng: 'Other Veterinary Science',
    parentId: '403',
    level: 3,
  },
  {
    identifier: '404',
    name: 'Bioteknologi med applikationer på växter och djur',
    nameEng: 'Agricultural Biotechnology',
    parentId: '4',
    level: 2,
  },
  {
    identifier: '40401',
    name: 'Växtbioteknologi',
    nameEng: 'Plant Biotechnology',
    parentId: '404',
    level: 3,
  },
  {
    identifier: '40402',
    name: 'Genetik och förädling inom lantbruksvetenskap',
    nameEng: 'Genetics and Breeding in Agricultural Sciences',
    parentId: '404',
    level: 3,
  },
  {
    identifier: '405',
    name: 'Annan lantbruksvetenskap',
    nameEng: 'Other Agricultural Sciences',
    parentId: '4',
    level: 2,
  },
  {
    identifier: '40501',
    name: 'Förnyelsebar bioenergi',
    nameEng: 'Renewable Bioenergy Research',
    parentId: '405',
    level: 3,
  },
  {
    identifier: '40502',
    name: 'Vilt- och fiskeförvaltning',
    nameEng: 'Fish and Wildlife Management',
    parentId: '405',
    level: 3,
  },
  {
    identifier: '40503',
    name: 'Lantbrukets arbetsmiljö och säkerhet',
    nameEng: 'Agricultural Occupational Health and Safety',
    parentId: '405',
    level: 3,
  },
  {
    identifier: '40504',
    name: 'Miljö- och naturvårdsvetenskap',
    nameEng: 'Environmental Sciences related to Agriculture and Land-use',
    parentId: '405',
    level: 3,
  },
  {
    identifier: '40599',
    name: 'Övrig annan lantbruksvetenskap',
    nameEng: 'Other Agricultural Sciences not elsewhere specified',
    parentId: '405',
    level: 3,
  },
  {
    identifier: '5',
    name: 'Samhällsvetenskap',
    nameEng: 'Social Sciences',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '501',
    name: 'Psykologi',
    nameEng: 'Psychology',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50101',
    name: 'Psykologi (exklusive tillämpad psykologi)',
    nameEng: 'Psychology (excluding Applied Psychology)',
    parentId: '501',
    level: 3,
  },
  {
    identifier: '50102',
    name: 'Tillämpad psykologi',
    nameEng: 'Applied Psychology',
    parentId: '501',
    level: 3,
  },
  {
    identifier: '502',
    name: 'Ekonomi och näringsliv',
    nameEng: 'Economics and Business',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50201',
    name: 'Nationalekonomi',
    nameEng: 'Economics',
    parentId: '502',
    level: 3,
  },
  {
    identifier: '50202',
    name: 'Företagsekonomi',
    nameEng: 'Business Administration',
    parentId: '502',
    level: 3,
  },
  {
    identifier: '50203',
    name: 'Ekonomisk historia',
    nameEng: 'Economic History',
    parentId: '502',
    level: 3,
  },
  {
    identifier: '503',
    name: 'Utbildningsvetenskap',
    nameEng: 'Educational Sciences',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50301',
    name: 'Pedagogik',
    nameEng: 'Pedagogy',
    parentId: '503',
    level: 3,
  },
  {
    identifier: '50302',
    name: 'Didaktik',
    nameEng: 'Didactics',
    parentId: '503',
    level: 3,
  },
  {
    identifier: '50303',
    name: 'Lärande',
    nameEng: 'Learning',
    parentId: '503',
    level: 3,
  },
  {
    identifier: '50304',
    name: 'Pedagogiskt arbete',
    nameEng: 'Pedagogical Work',
    parentId: '503',
    level: 3,
  },
  {
    identifier: '504',
    name: 'Sociologi',
    nameEng: 'Sociology',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50401',
    name: 'Sociologi (exklusive socialt arbete, socialpsykologi och socialantropologi)',
    nameEng:
      'Sociology (excluding Social Work, Social Psychology and Social Anthropology)',
    parentId: '504',
    level: 3,
  },
  {
    identifier: '50402',
    name: 'Socialt arbete',
    nameEng: 'Social Work',
    parentId: '504',
    level: 3,
  },
  {
    identifier: '50403',
    name: 'Socialpsykologi',
    nameEng: 'Social Psychology',
    parentId: '504',
    level: 3,
  },
  {
    identifier: '50404',
    name: 'Socialantropologi',
    nameEng: 'Social Anthropology',
    parentId: '504',
    level: 3,
  },
  {
    identifier: '505',
    name: 'Juridik',
    nameEng: 'Law',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50501',
    name: 'Juridik (exklusive juridik och samhälle)',
    nameEng: 'Law (excluding Law and Society)',
    parentId: '505',
    level: 3,
  },
  {
    identifier: '50502',
    name: 'Juridik och samhälle',
    nameEng: 'Law and Society',
    parentId: '505',
    level: 3,
  },
  {
    identifier: '506',
    name: 'Statsvetenskap',
    nameEng: 'Political Science',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50601',
    name: 'Statsvetenskap (exklusive studier av offentlig förvaltning och globaliseringsstudier)',
    nameEng:
      'Political Science (excluding Public Administration Studies and Globalisation Studies)',
    parentId: '506',
    level: 3,
  },
  {
    identifier: '50602',
    name: 'Studier av offentlig förvaltning',
    nameEng: 'Public Administration Studies',
    parentId: '506',
    level: 3,
  },
  {
    identifier: '50603',
    name: 'Globaliseringsstudier',
    nameEng: 'Globalisation Studies',
    parentId: '506',
    level: 3,
  },
  {
    identifier: '507',
    name: 'Social och ekonomisk geografi',
    nameEng: 'Social and Economic Geography',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50701',
    name: 'Kulturgeografi',
    nameEng: 'Human Geography',
    parentId: '507',
    level: 3,
  },
  {
    identifier: '50702',
    name: '"Ekonomisk geografi"',
    nameEng: 'Economic Geography',
    parentId: '507',
    level: 3,
  },
  {
    identifier: '508',
    name: 'Medie- och kommunikationsvetenskap',
    nameEng: 'Media and Communications',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50801',
    name: 'Medievetenskap',
    nameEng: 'Media Studies',
    parentId: '508',
    level: 3,
  },
  {
    identifier: '50802',
    name: 'Kommunikationsvetenskap',
    nameEng: 'Communication Studies',
    parentId: '508',
    level: 3,
  },
  {
    identifier: '50803',
    name: 'Mänsklig interaktion med IKT',
    nameEng: 'Human Aspects of ICT',
    parentId: '508',
    level: 3,
  },
  {
    identifier: '50804',
    name: 'Systemvetenskap, informationssystem och informatik med samhällsvetenskaplig inriktning',
    nameEng: 'Information Systems, Social aspects',
    parentId: '508',
    level: 3,
  },
  {
    identifier: '50805',
    name: 'Biblioteks- och informationsvetenskap',
    nameEng: 'Information Studies',
    parentId: '508',
    level: 3,
  },
  {
    identifier: '509',
    name: 'Annan samhällsvetenskap',
    nameEng: 'Other Social Sciences',
    parentId: '5',
    level: 2,
  },
  {
    identifier: '50901',
    name: 'Tvärvetenskapliga studier inom samhällsvetenskap',
    nameEng: 'Social Sciences Interdisciplinary',
    parentId: '509',
    level: 3,
  },
  {
    identifier: '50902',
    name: 'Genusstudier',
    nameEng: 'Gender Studies',
    parentId: '509',
    level: 3,
  },
  {
    identifier: '50903',
    name: 'Arbetslivsstudier',
    nameEng: 'Work Sciences',
    parentId: '509',
    level: 3,
  },
  {
    identifier: '50904',
    name: 'Internationell migration och etniska relationer (IMER)',
    nameEng: 'International Migration and Ethnic Relations',
    parentId: '509',
    level: 3,
  },
  {
    identifier: '50999',
    name: 'Övrig annan samhällsvetenskap',
    nameEng: 'Other Social Sciences not elsewhere specified',
    parentId: '509',
    level: 3,
  },
  {
    identifier: '6',
    name: 'Humaniora och konst',
    nameEng: 'Humanities and the Arts',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '601',
    name: 'Historia och arkeologi',
    nameEng: 'History and Archaeology',
    parentId: '6',
    level: 2,
  },
  {
    identifier: '60101',
    name: 'Historia',
    nameEng: 'History',
    parentId: '601',
    level: 3,
  },
  {
    identifier: '60102',
    name: 'Teknikhistoria',
    nameEng: 'History of Technology',
    parentId: '601',
    level: 3,
  },
  {
    identifier: '60103',
    name: 'Arkeologi',
    nameEng: 'Archaeology',
    parentId: '601',
    level: 3,
  },
  {
    identifier: '602',
    name: 'Språk och litteratur',
    nameEng: 'Languages and Literature',
    parentId: '6',
    level: 2,
  },
  {
    identifier: '60201',
    name: 'Jämförande språkvetenskap och lingvistik',
    nameEng: 'General Language Studies and Linguistics',
    parentId: '602',
    level: 3,
  },
  {
    identifier: '60202',
    name: 'Språkstudier',
    nameEng: 'Specific Languages',
    parentId: '602',
    level: 3,
  },
  {
    identifier: '60203',
    name: 'Litteraturvetenskap',
    nameEng: 'General Literary studies',
    parentId: '602',
    level: 3,
  },
  {
    identifier: '60204',
    name: 'Litteraturstudier',
    nameEng: 'Specific Literatures',
    parentId: '602',
    level: 3,
  },
  {
    identifier: '603',
    name: 'Filosofi, etik och religion',
    nameEng: 'Philosophy, Ethics and Religion',
    parentId: '6',
    level: 2,
  },
  {
    identifier: '60301',
    name: 'Filosofi',
    nameEng: 'Philosophy',
    parentId: '603',
    level: 3,
  },
  {
    identifier: '60302',
    name: 'Etik',
    nameEng: 'Ethics',
    parentId: '603',
    level: 3,
  },
  {
    identifier: '60303',
    name: 'Religionsvetenskap',
    nameEng: 'Religious Studies',
    parentId: '603',
    level: 3,
  },
  {
    identifier: '60304',
    name: 'Religionshistoria',
    nameEng: 'History of Religions',
    parentId: '603',
    level: 3,
  },
  {
    identifier: '60305',
    name: 'Idé- och lärdomshistoria',
    nameEng: 'History of Ideas',
    parentId: '603',
    level: 3,
  },
  {
    identifier: '604',
    name: 'Konst',
    nameEng: 'Arts',
    parentId: '6',
    level: 2,
  },
  {
    identifier: '60401',
    name: 'Bildkonst',
    nameEng: 'Visual Arts',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60402',
    name: 'Musik',
    nameEng: 'Music',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60403',
    name: 'Litterär gestaltning',
    nameEng: 'Literary Composition',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60404',
    name: 'Scenkonst',
    nameEng: 'Performing Arts',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60405',
    name: 'Arkitektur',
    nameEng: 'Architecture',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60406',
    name: 'Design',
    nameEng: 'Design',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60407',
    name: 'Konstvetenskap',
    nameEng: 'Art History',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60408',
    name: 'Musikvetenskap',
    nameEng: 'Musicology',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60409',
    name: 'Teatervetenskap',
    nameEng: 'Performing Art Studies',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '60410',
    name: 'Filmvetenskap',
    nameEng: 'Studies on Film',
    parentId: '604',
    level: 3,
  },
  {
    identifier: '605',
    name: 'Annan humaniora',
    nameEng: 'Other Humanities',
    parentId: '6',
    level: 2,
  },
  {
    identifier: '60501',
    name: 'Antikvetenskap',
    nameEng: 'Classical Archaeology and Ancient History',
    parentId: '605',
    level: 3,
  },
  {
    identifier: '60502',
    name: 'Kulturstudier',
    nameEng: 'Cultural Studies',
    parentId: '605',
    level: 3,
  },
  {
    identifier: '60503',
    name: 'Etnologi',
    nameEng: 'Ethnology',
    parentId: '605',
    level: 3,
  },
  {
    identifier: '60599',
    name: 'Övrig annan humaniora',
    nameEng: 'Other Humanities not elsewhere specified',
    parentId: '605',
    level: 3,
  },
];

const classificationListPO: Classification[] = [
  {
    identifier: 'A',
    name: 'PRODUKTER FRÅN JORDBRUK, SKOGSBRUK OCH FISKE',
    nameEng: 'Products of agriculture, forestry and fishing',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '01',
    name: 'Jordbruks- och jaktprodukter och tjänster i anslutning härtill',
    nameEng: 'Products of agriculture, hunting and related services',
    parentId: 'A',
    level: 2,
  },
  {
    identifier: '01.1',
    name: 'Ett- och tvååriga växter',
    nameEng: 'Non-perennial crops',
    parentId: '01',
    level: 3,
  },
  {
    identifier: '01.11',
    name: 'Spannmål (utom ris), baljväxter och oljeväxter',
    nameEng: 'Cereals (except rice), leguminous crops and oil seeds',
    parentId: '01.1',
    level: 4,
  },
  {
    identifier: '01.12',
    name: 'Ris, med ytterskal',
    nameEng: 'Rice, not husked',
    parentId: '01.1',
    level: 4,
  },
  {
    identifier: '01.13',
    name: 'Grönsaker och meloner, rotfrukter och stam- eller rotknölar',
    nameEng: 'Vegetables and melons, roots and tubers',
    parentId: '01.1',
    level: 4,
  },
  {
    identifier: '01.14',
    name: 'Sockerrör',
    nameEng: 'Sugar cane',
    parentId: '01.1',
    level: 4,
  },
  {
    identifier: '01.15',
    name: 'Råtobak',
    nameEng: 'Unmanufactured tobacco',
    parentId: '01.1',
    level: 4,
  },
  {
    identifier: '01.16',
    name: 'Fiberväxter',
    nameEng: 'Fibre crops',
    parentId: '01.1',
    level: 4,
  },
  {
    identifier: '01.19',
    name: 'Andra ett- och tvååriga växter',
    nameEng: 'Other non-perennial crops',
    parentId: '01.1',
    level: 4,
  },
  {
    identifier: '01.2',
    name: 'Fleråriga växter',
    nameEng: 'Perennial crops',
    parentId: '01',
    level: 3,
  },
  {
    identifier: '01.21',
    name: 'Vindruvor',
    nameEng: 'Grapes',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.22',
    name: 'Tropiska och subtropiska frukter',
    nameEng: 'Tropical and subtropical fruits',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.23',
    name: 'Citrusfrukter',
    nameEng: 'Citrus fruits',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.24',
    name: 'Kärnfrukter och stenfrukter',
    nameEng: 'Pome fruits and stone fruits',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.25',
    name: 'Andra frukter, bär samt nötter',
    nameEng: 'Other tree and bush fruits and nuts',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.26',
    name: 'Oljehaltiga frukter',
    nameEng: 'Oleaginous fruits',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.27',
    name: 'Kaffe, te, mate, kakao och humle',
    nameEng: 'Beverage crops',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.28',
    name: 'Kryddväxter, drog- och medicinalväxter',
    nameEng: 'Spices, aromatic, drug and pharmaceutical crops',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.29',
    name: 'Andra fleråriga växter',
    nameEng: 'Other perennial crops',
    parentId: '01.2',
    level: 4,
  },
  {
    identifier: '01.3',
    name: 'Plantmaterial: levande växter, lökar, stam- och rotknölar, sticklingar och ympkvistar; svampmycelium',
    nameEng:
      'Planting material: live plants, bulbs, tubers and roots, cuttings and slips; mushroom spawn',
    parentId: '01',
    level: 3,
  },
  {
    identifier: '01.30',
    name: 'Plantmaterial: levande växter, lökar, stam- och rotknölar, sticklingar och ympkvistar; svampmycelium',
    nameEng:
      'Planting material: live plants, bulbs, tubers and roots, cuttings and slips; mushroom spawn',
    parentId: '01.3',
    level: 4,
  },
  {
    identifier: '01.4',
    name: 'Levande djur samt produkter från dessa',
    nameEng: 'Live animals and animal products',
    parentId: '01',
    level: 3,
  },
  {
    identifier: '01.41',
    name: 'Levande nötkreatur av mjölkras och obearbetad mjölk från dessa',
    nameEng: 'Dairy cattle, live and raw milk from dairy cattle',
    parentId: '01.4',
    level: 4,
  },
  {
    identifier: '01.42',
    name: 'Andra levande nötkreatur och andra oxdjur samt sperma från dessa djur',
    nameEng: 'Other cattle and buffaloes, live and their semen',
    parentId: '01.4',
    level: 4,
  },
  {
    identifier: '01.43',
    name: 'Levande hästar och andra hästdjur',
    nameEng: 'Horses and other equines, live',
    parentId: '01.4',
    level: 4,
  },
  {
    identifier: '01.44',
    name: 'Levande kameler och kameldjur',
    nameEng: 'Camels and camelids, live',
    parentId: '01.4',
    level: 4,
  },
  {
    identifier: '01.45',
    name: 'Levande får och getter; obearbetad mjölk och klippt ull av får och getter',
    nameEng:
      'Sheep and goats, live; raw milk and shorn wool from sheep and goats',
    parentId: '01.4',
    level: 4,
  },
  {
    identifier: '01.46',
    name: 'Levande svin',
    nameEng: 'Swine, live',
    parentId: '01.4',
    level: 4,
  },
  {
    identifier: '01.47',
    name: 'Levande fjäderfä och ägg från dessa',
    nameEng: 'Poultry, live and eggs',
    parentId: '01.4',
    level: 4,
  },
  {
    identifier: '01.49',
    name: 'Andra produktionsdjur samt produkter från dessa',
    nameEng: 'Other farmed animals and animal products',
    parentId: '01.4',
    level: 4,
  },
  {
    identifier: '01.6',
    name: 'Stödtjänster till jordbruk och djurskötsel, utom veterinärtjänster',
    nameEng:
      'Agricultural and animal husbandry services (except veterinary services)',
    parentId: '01',
    level: 3,
  },
  {
    identifier: '01.61',
    name: 'Stödtjänster till växtodling',
    nameEng: 'Support services to crop production',
    parentId: '01.6',
    level: 4,
  },
  {
    identifier: '01.62',
    name: 'Stödtjänster till husdjursskötsel',
    nameEng: 'Support services to animal production',
    parentId: '01.6',
    level: 4,
  },
  {
    identifier: '01.63',
    name: 'Bearbetningstjänster avseende skördade växter',
    nameEng: 'Post-harvest crop services',
    parentId: '01.6',
    level: 4,
  },
  {
    identifier: '01.64',
    name: 'Bearbetningstjänster avseende utsäde',
    nameEng: 'Seed processing services for propagation',
    parentId: '01.6',
    level: 4,
  },
  {
    identifier: '01.7',
    name: 'Jakt och tjänster i anslutning härtill',
    nameEng: 'Hunting and trapping and related services',
    parentId: '01',
    level: 3,
  },
  {
    identifier: '01.70',
    name: 'Jakt och tjänster i anslutning härtill',
    nameEng: 'Hunting and trapping and related services',
    parentId: '01.7',
    level: 4,
  },
  {
    identifier: '02',
    name: 'Skogsbruksprodukter och tjänster i anslutning till skogsbruk',
    nameEng: 'Products of forestry, logging and related services',
    parentId: 'A',
    level: 2,
  },
  {
    identifier: '02.1',
    name: 'Tjänster i anslutning till skogsträd och skogsodlingsmaterial',
    nameEng: 'Forest trees and nursery services',
    parentId: '02',
    level: 3,
  },
  {
    identifier: '02.10',
    name: 'Tjänster i anslutning till skogsträd och skogsodlingsmaterial',
    nameEng: 'Forest trees and nursery services',
    parentId: '02.1',
    level: 4,
  },
  {
    identifier: '02.2',
    name: 'Obearbetat virke',
    nameEng: 'Wood in the rough',
    parentId: '02',
    level: 3,
  },
  {
    identifier: '02.20',
    name: 'Obearbetat virke',
    nameEng: 'Wood in the rough',
    parentId: '02.2',
    level: 4,
  },
  {
    identifier: '02.3',
    name: 'Annat vilt växande skogsmaterial än trä',
    nameEng: 'Wild growing non-wood products',
    parentId: '02',
    level: 3,
  },
  {
    identifier: '02.30',
    name: 'Annat vilt växande skogsmaterial än trä',
    nameEng: 'Wild growing non-wood products',
    parentId: '02.3',
    level: 4,
  },
  {
    identifier: '02.4',
    name: 'Stödtjänster till skogsbruk',
    nameEng: 'Support services to forestry',
    parentId: '02',
    level: 3,
  },
  {
    identifier: '02.40',
    name: 'Stödtjänster till skogsbruk',
    nameEng: 'Support services to forestry',
    parentId: '02.4',
    level: 4,
  },
  {
    identifier: '03',
    name: 'Fisk och andra fiskeriprodukter; vattenbruksprodukter; stödtjänster till fiske',
    nameEng:
      'Fish and other fishing products; aquaculture products; support services to fishing',
    parentId: 'A',
    level: 2,
  },
  {
    identifier: '03.0',
    name: 'Fisk och andra fiskeriprodukter; vattenbruksprodukter; stödtjänster till fiske',
    nameEng:
      'Fish and other fishing products; aquaculture products; support services to fishing',
    parentId: '03',
    level: 3,
  },
  {
    identifier: '03.00',
    name: 'Fisk och andra fiskeriprodukter; vattenbruksprodukter; stödtjänster till fiske',
    nameEng:
      'Fish and other fishing products; aquaculture products; support services to fishing',
    parentId: '03.0',
    level: 4,
  },
  {
    identifier: 'B',
    name: 'PRODUKTER FRÅN UTVINNING AV MINERAL',
    nameEng: 'Mining and quarrying',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '05',
    name: 'Stenkol och brunkol',
    nameEng: 'Coal and lignite',
    parentId: 'B',
    level: 2,
  },
  {
    identifier: '05.1',
    name: 'Stenkol',
    nameEng: 'Hard coal',
    parentId: '05',
    level: 3,
  },
  {
    identifier: '05.10',
    name: 'Stenkol',
    nameEng: 'Hard coal',
    parentId: '05.1',
    level: 4,
  },
  {
    identifier: '05.2',
    name: 'Brunkol',
    nameEng: 'Lignite',
    parentId: '05',
    level: 3,
  },
  {
    identifier: '05.20',
    name: 'Brunkol',
    nameEng: 'Lignite',
    parentId: '05.2',
    level: 4,
  },
  {
    identifier: '06',
    name: 'Råpetroleum och naturgas',
    nameEng: 'Crude petroleum and natural gas',
    parentId: 'B',
    level: 2,
  },
  {
    identifier: '06.1',
    name: 'Råpetroleum',
    nameEng: 'Crude petroleum',
    parentId: '06',
    level: 3,
  },
  {
    identifier: '06.10',
    name: 'Råpetroleum',
    nameEng: 'Crude petroleum',
    parentId: '06.1',
    level: 4,
  },
  {
    identifier: '06.2',
    name: 'Naturgas, förtätad till vätska eller i gasform',
    nameEng: 'Natural gas, liquefied or in gaseous state',
    parentId: '06',
    level: 3,
  },
  {
    identifier: '06.20',
    name: 'Naturgas, förtätad till vätska eller i gasform',
    nameEng: 'Natural gas, liquefied or in gaseous state',
    parentId: '06.2',
    level: 4,
  },
  {
    identifier: '07',
    name: 'Metallmalmer',
    nameEng: 'Metal ores',
    parentId: 'B',
    level: 2,
  },
  {
    identifier: '07.1',
    name: 'Järnmalm',
    nameEng: 'Iron ores',
    parentId: '07',
    level: 3,
  },
  {
    identifier: '07.10',
    name: 'Järnmalm',
    nameEng: 'Iron ores',
    parentId: '07.1',
    level: 4,
  },
  {
    identifier: '07.2',
    name: 'Icke-järnmalm',
    nameEng: 'Non-ferrous metal ores',
    parentId: '07',
    level: 3,
  },
  {
    identifier: '07.21',
    name: 'Uranmalm och toriummalm',
    nameEng: 'Uranium and thorium ores',
    parentId: '07.2',
    level: 4,
  },
  {
    identifier: '07.29',
    name: 'Annan icke-järnmalm, även anrikad',
    nameEng: 'Other non-ferrous metal ores and concentrates',
    parentId: '07.2',
    level: 4,
  },
  {
    identifier: '08',
    name: 'Andra produkter från utvinning av mineral',
    nameEng: 'Other mining and quarrying products',
    parentId: 'B',
    level: 2,
  },
  {
    identifier: '08.1',
    name: 'Sten, sand och lera',
    nameEng: 'Stone, sand and clay',
    parentId: '08',
    level: 3,
  },
  {
    identifier: '08.11',
    name: 'Natursten, kalk- och gipssten, krita och skiffer',
    nameEng:
      'Ornamental and building stone, limestone, gypsum, chalk and slate',
    parentId: '08.1',
    level: 4,
  },
  {
    identifier: '08.12',
    name: 'Grus, sand, lera och kaolin',
    nameEng: 'Gravel, sand, clays and kaolin',
    parentId: '08.1',
    level: 4,
  },
  {
    identifier: '08.9',
    name: 'Övriga produkter från utvinning av malmer och mineral',
    nameEng: 'Mining and quarrying products n.e.c.',
    parentId: '08',
    level: 3,
  },
  {
    identifier: '08.91',
    name: 'Mineral för framställning av kemikalier och gödselmedel',
    nameEng: 'Chemical and fertiliser minerals',
    parentId: '08.9',
    level: 4,
  },
  {
    identifier: '08.92',
    name: 'Torv',
    nameEng: 'Peat',
    parentId: '08.9',
    level: 4,
  },
  {
    identifier: '08.93',
    name: 'Salt och ren natriumklorid; havsvatten',
    nameEng: 'Salt and pure sodium chloride; sea water',
    parentId: '08.9',
    level: 4,
  },
  {
    identifier: '08.99',
    name: 'Diverse andra produkter från utvinning av malmer och mineral',
    nameEng: 'Other mining and quarrying products n.e.c.',
    parentId: '08.9',
    level: 4,
  },
  {
    identifier: '09',
    name: 'Stödtjänster till utvinning',
    nameEng: 'Mining support services',
    parentId: 'B',
    level: 2,
  },
  {
    identifier: '09.1',
    name: 'Stödtjänster till råpetroleum- och naturgasutvinning',
    nameEng: 'Support services to petroleum and natural gas extraction',
    parentId: '09',
    level: 3,
  },
  {
    identifier: '09.10',
    name: 'Stödtjänster till råpetroleum- och naturgasutvinning',
    nameEng: 'Support services to petroleum and natural gas extraction',
    parentId: '09.1',
    level: 4,
  },
  {
    identifier: '09.9',
    name: 'Stödtjänster till annan utvinning',
    nameEng: 'Support services to other mining and quarrying',
    parentId: '09',
    level: 3,
  },
  {
    identifier: '09.90',
    name: 'Stödtjänster till annan utvinning',
    nameEng: 'Support services to other mining and quarrying',
    parentId: '09.9',
    level: 4,
  },
  {
    identifier: 'C',
    name: 'TILLVERKADE VAROR',
    nameEng: 'Manufactured products',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '10',
    name: 'Livsmedel',
    nameEng: 'Food products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '10.1',
    name: 'Hållbarhetsbehandlat kött och köttprodukter',
    nameEng: 'Preserved meat and meat products',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.11',
    name: 'Berett och hållbarhetsbehandlat kött',
    nameEng: 'Processed and preserved meat',
    parentId: '10.1',
    level: 4,
  },
  {
    identifier: '10.12',
    name: 'Berett och hållbarhetsbehandlat fjäderfäkött',
    nameEng: 'Processed and preserved poultry meat',
    parentId: '10.1',
    level: 4,
  },
  {
    identifier: '10.13',
    name: 'Köttvaror',
    nameEng: 'Meat and poultry meat products',
    parentId: '10.1',
    level: 4,
  },
  {
    identifier: '10.2',
    name: 'Beredd och hållbarhetsbehandlad fisk, kräftdjur och blötdjur',
    nameEng: 'Processed and preserved fish, crustaceans and molluscs',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.20',
    name: 'Beredd och hållbarhetsbehandlad fisk, kräftdjur och blötdjur',
    nameEng: 'Processed and preserved fish, crustaceans and molluscs',
    parentId: '10.2',
    level: 4,
  },
  {
    identifier: '10.3',
    name: 'Beredda och hållbarhetsbehandlade frukter, bär och köksväxter',
    nameEng: 'Processed and preserved fruit and vegetables',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.31',
    name: 'Beredd och hållbarhetsbehandlad potatis',
    nameEng: 'Processed and preserved potatoes',
    parentId: '10.3',
    level: 4,
  },
  {
    identifier: '10.32',
    name: 'Frukt-, bär- och grönsakssaft',
    nameEng: 'Fruit and vegetable juices',
    parentId: '10.3',
    level: 4,
  },
  {
    identifier: '10.39',
    name: 'Andra beredda och hållbarhetsbehandlade frukter, bär och köksväxter',
    nameEng: 'Other processed and preserved fruit and vegetables',
    parentId: '10.3',
    level: 4,
  },
  {
    identifier: '10.4',
    name: 'Vegetabiliska och animaliska oljor och fetter',
    nameEng: 'Vegetable and animal oils and fats',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.41',
    name: 'Oljor och fetter',
    nameEng: 'Oils and fats',
    parentId: '10.4',
    level: 4,
  },
  {
    identifier: '10.42',
    name: 'Margarin och liknande beredningar',
    nameEng: 'Margarine and similar edible fats',
    parentId: '10.4',
    level: 4,
  },
  {
    identifier: '10.5',
    name: 'Mejeriprodukter och glass',
    nameEng: 'Dairy products',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.51',
    name: 'Mejeriprodukter',
    nameEng: 'Dairy and cheese products',
    parentId: '10.5',
    level: 4,
  },
  {
    identifier: '10.52',
    name: 'Glass',
    nameEng: 'Ice cream',
    parentId: '10.5',
    level: 4,
  },
  {
    identifier: '10.6',
    name: 'Kvarnprodukter, stärkelse och stärkelseprodukter',
    nameEng: 'Grain mill products, starches and starch products',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.61',
    name: 'Kvarnprodukter',
    nameEng: 'Grain mill products',
    parentId: '10.6',
    level: 4,
  },
  {
    identifier: '10.62',
    name: 'Stärkelse och stärkelseprodukter',
    nameEng: 'Starches and starch products',
    parentId: '10.6',
    level: 4,
  },
  {
    identifier: '10.7',
    name: 'Bageri- och mjölprodukter',
    nameEng: 'Bakery and farinaceous products',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.71',
    name: 'Bröd; färska bakverk',
    nameEng: 'Bread; fresh pastry goods and cakes',
    parentId: '10.7',
    level: 4,
  },
  {
    identifier: '10.72',
    name: 'Knäckebröd, kex och hållbarhetsbehandlade bakverk',
    nameEng: 'Rusks and biscuits; preserved pastry goods and cakes',
    parentId: '10.7',
    level: 4,
  },
  {
    identifier: '10.73',
    name: 'Pastaprodukter',
    nameEng: 'Macaroni, noodles, couscous and similar farinaceous products',
    parentId: '10.7',
    level: 4,
  },
  {
    identifier: '10.8',
    name: 'Andra livsmedel',
    nameEng: 'Other food products',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.81',
    name: 'Socker',
    nameEng: 'Sugar',
    parentId: '10.8',
    level: 4,
  },
  {
    identifier: '10.82',
    name: 'Kakao, choklad och sockerkonfektyrer',
    nameEng: 'Cocoa, chocolate and sugar confectionery',
    parentId: '10.8',
    level: 4,
  },
  {
    identifier: '10.83',
    name: 'Kaffe och te',
    nameEng: 'Processed tea and coffee',
    parentId: '10.8',
    level: 4,
  },
  {
    identifier: '10.84',
    name: 'Senap, ketchup, kryddor, såser och andra smaksättningsmedel',
    nameEng: 'Condiments and seasonings',
    parentId: '10.8',
    level: 4,
  },
  {
    identifier: '10.85',
    name: 'Lagad mat och färdigrätter',
    nameEng: 'Prepared meals and dishes',
    parentId: '10.8',
    level: 4,
  },
  {
    identifier: '10.86',
    name: 'Homogeniserade livsmedelspreparat inklusive dietmat',
    nameEng: 'Homogenised food preparations and dietetic food',
    parentId: '10.8',
    level: 4,
  },
  {
    identifier: '10.89',
    name: 'Andra livsmedel',
    nameEng: 'Other food products n.e.c.',
    parentId: '10.8',
    level: 4,
  },
  {
    identifier: '10.9',
    name: 'Beredda djurfoder',
    nameEng: 'Prepared animal feeds',
    parentId: '10',
    level: 3,
  },
  {
    identifier: '10.91',
    name: 'Beredda fodermedel',
    nameEng: 'Prepared feeds for farm animals',
    parentId: '10.9',
    level: 4,
  },
  {
    identifier: '10.92',
    name: 'Mat till sällskapsdjur',
    nameEng: 'Prepared pet foods',
    parentId: '10.9',
    level: 4,
  },
  {
    identifier: '11',
    name: 'Drycker',
    nameEng: 'Beverages',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '11.0',
    name: 'Drycker',
    nameEng: 'Beverages',
    parentId: '11',
    level: 3,
  },
  {
    identifier: '11.01',
    name: 'Destillerade, alkoholhaltiga drycker',
    nameEng: 'Distilled alcoholic beverages',
    parentId: '11.0',
    level: 4,
  },
  {
    identifier: '11.02',
    name: 'Vin från druvor',
    nameEng: 'Wine from grape',
    parentId: '11.0',
    level: 4,
  },
  {
    identifier: '11.03',
    name: 'Cider och andra fruktviner',
    nameEng: 'Cider and other fruit wines',
    parentId: '11.0',
    level: 4,
  },
  {
    identifier: '11.04',
    name: 'Andra icke-destillerade jästa drycker',
    nameEng: 'Other non-distilled fermented beverages',
    parentId: '11.0',
    level: 4,
  },
  {
    identifier: '11.05',
    name: 'Öl',
    nameEng: 'Beer',
    parentId: '11.0',
    level: 4,
  },
  {
    identifier: '11.06',
    name: 'Malt',
    nameEng: 'Malt',
    parentId: '11.0',
    level: 4,
  },
  {
    identifier: '11.07',
    name: 'Läskedrycker, mineralvatten och annat vatten på flaska',
    nameEng: 'Soft drinks; mineral waters and other bottled waters',
    parentId: '11.0',
    level: 4,
  },
  {
    identifier: '12',
    name: 'Tobaksvaror',
    nameEng: 'Tobacco products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '12.0',
    name: 'Tobaksvaror',
    nameEng: 'Tobacco products',
    parentId: '12',
    level: 3,
  },
  {
    identifier: '12.00',
    name: 'Tobaksvaror',
    nameEng: 'Tobacco products',
    parentId: '12.0',
    level: 4,
  },
  {
    identifier: '13',
    name: 'Textilvaror',
    nameEng: 'Textiles',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '13.1',
    name: 'Garn och tråd',
    nameEng: 'Textile yarn and thread',
    parentId: '13',
    level: 3,
  },
  {
    identifier: '13.10',
    name: 'Garn och tråd',
    nameEng: 'Textile yarn and thread',
    parentId: '13.1',
    level: 4,
  },
  {
    identifier: '13.2',
    name: 'Textilvävnader',
    nameEng: 'Woven textiles',
    parentId: '13',
    level: 3,
  },
  {
    identifier: '13.20',
    name: 'Textilvävnader',
    nameEng: 'Woven textiles',
    parentId: '13.2',
    level: 4,
  },
  {
    identifier: '13.3',
    name: 'Tjänster avseende textilberedning',
    nameEng: 'Textile finishing services',
    parentId: '13',
    level: 3,
  },
  {
    identifier: '13.30',
    name: 'Tjänster avseende textilberedning',
    nameEng: 'Textile finishing services',
    parentId: '13.3',
    level: 4,
  },
  {
    identifier: '13.9',
    name: 'Andra textilier',
    nameEng: 'Other textiles',
    parentId: '13',
    level: 3,
  },
  {
    identifier: '13.91',
    name: 'Trikåväv',
    nameEng: 'Knitted and crocheted fabrics',
    parentId: '13.9',
    level: 4,
  },
  {
    identifier: '13.92',
    name: 'Sydda textilvaror, utom beklädnadsvaror',
    nameEng: 'Made-up textile articles, except apparel',
    parentId: '13.9',
    level: 4,
  },
  {
    identifier: '13.93',
    name: 'Mattor',
    nameEng: 'Carpets and rugs',
    parentId: '13.9',
    level: 4,
  },
  {
    identifier: '13.94',
    name: 'Tågvirke och bindgarn',
    nameEng: 'Cordage, rope, twine and netting',
    parentId: '13.9',
    level: 4,
  },
  {
    identifier: '13.95',
    name: 'Bondad duk och varor av bondad duk, utom beklädnadsvaror',
    nameEng: 'Non-wovens and articles made from non-wovens, except apparel',
    parentId: '13.9',
    level: 4,
  },
  {
    identifier: '13.96',
    name: 'Andra tekniska textilier och industritextilier',
    nameEng: 'Other technical and industrial textiles',
    parentId: '13.9',
    level: 4,
  },
  {
    identifier: '13.99',
    name: 'Övriga textilier',
    nameEng: 'Other textiles n.e.c.',
    parentId: '13.9',
    level: 4,
  },
  {
    identifier: '14',
    name: 'Kläder',
    nameEng: 'Wearing apparel',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '14.1',
    name: 'Kläder, utom pälsvaror',
    nameEng: 'Wearing apparel, except fur apparel',
    parentId: '14',
    level: 3,
  },
  {
    identifier: '14.11',
    name: 'Läder- och skinnkläder',
    nameEng: 'Leather clothes',
    parentId: '14.1',
    level: 4,
  },
  {
    identifier: '14.12',
    name: 'Arbetskläder',
    nameEng: 'Workwear',
    parentId: '14.1',
    level: 4,
  },
  {
    identifier: '14.13',
    name: 'Andra gång- och ytterkläder',
    nameEng: 'Other outerwear',
    parentId: '14.1',
    level: 4,
  },
  {
    identifier: '14.14',
    name: 'Skjortor, blusar och underkläder',
    nameEng: 'Underwear',
    parentId: '14.1',
    level: 4,
  },
  {
    identifier: '14.19',
    name: 'Andra kläder och tillbehör',
    nameEng: 'Other wearing apparel and accessories',
    parentId: '14.1',
    level: 4,
  },
  {
    identifier: '14.2',
    name: 'Pälsvaror',
    nameEng: 'Articles of fur',
    parentId: '14',
    level: 3,
  },
  {
    identifier: '14.20',
    name: 'Pälsvaror',
    nameEng: 'Articles of fur',
    parentId: '14.2',
    level: 4,
  },
  {
    identifier: '14.3',
    name: 'Trikåvaror',
    nameEng: 'Knitted and crocheted apparel',
    parentId: '14',
    level: 3,
  },
  {
    identifier: '14.31',
    name: 'Strumpor av trikå',
    nameEng: 'Knitted and crocheted hosiery',
    parentId: '14.3',
    level: 4,
  },
  {
    identifier: '14.39',
    name: 'Andra trikåvaror',
    nameEng: 'Other knitted and crocheted apparel',
    parentId: '14.3',
    level: 4,
  },
  {
    identifier: '15',
    name: 'Läder, läder- och skinnvaror m.m.',
    nameEng: 'Leather and related products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '15.1',
    name: 'Garvat och på annat sätt berett läder; reseffekter, handväskor, sadel- och seldon; beredd och färgad päls',
    nameEng:
      'Tanned and dressed leather; luggage, handbags, saddlery and harness; dressed and dyed fur',
    parentId: '15',
    level: 3,
  },
  {
    identifier: '15.11',
    name: 'Garvat och på annat sätt berett läder; beredd och färgad päls',
    nameEng: 'Tanned and dressed leather; dressed and dyed fur',
    parentId: '15.1',
    level: 4,
  },
  {
    identifier: '15.12',
    name: 'Reseffekter, handväskor, sadel- och seldon m.m.',
    nameEng: 'Luggage, handbags and the like, saddlery and harness',
    parentId: '15.1',
    level: 4,
  },
  {
    identifier: '15.2',
    name: 'Skodon',
    nameEng: 'Footwear',
    parentId: '15',
    level: 3,
  },
  {
    identifier: '15.20',
    name: 'Skodon',
    nameEng: 'Footwear',
    parentId: '15.2',
    level: 4,
  },
  {
    identifier: '16',
    name: 'Trä och varor av trä och kork (utom möbler); varor av halm, rotting o.d.',
    nameEng:
      'Wood and of products of wood and cork, except furniture; articles of straw and plaiting materials',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '16.1',
    name: 'Trä, sågat och hyvlat',
    nameEng: 'Wood, sawn and planed',
    parentId: '16',
    level: 3,
  },
  {
    identifier: '16.10',
    name: 'Trä, sågat och hyvlat',
    nameEng: 'Wood, sawn and planed',
    parentId: '16.1',
    level: 4,
  },
  {
    identifier: '16.2',
    name: 'Varor av trä, kork, halm, rotting o.d.',
    nameEng: 'Products of wood, cork, straw and plaiting materials',
    parentId: '16',
    level: 3,
  },
  {
    identifier: '16.21',
    name: 'Faner och träbaserade skivor',
    nameEng: 'Veneer sheets and wood-based panels',
    parentId: '16.2',
    level: 4,
  },
  {
    identifier: '16.22',
    name: 'Sammansatta parkettgolv',
    nameEng: 'Assembled parquet floors',
    parentId: '16.2',
    level: 4,
  },
  {
    identifier: '16.23',
    name: 'Andra byggnads- och inredningssnickerier',
    nameEng: "Other builders' carpentry and joinery",
    parentId: '16.2',
    level: 4,
  },
  {
    identifier: '16.24',
    name: 'Förpackningar av trä',
    nameEng: 'Wooden containers',
    parentId: '16.2',
    level: 4,
  },
  {
    identifier: '16.29',
    name: 'Andra trävaror; varor av kork, halm, rotting o.d.',
    nameEng:
      'Other products of wood; articles of cork, straw and plaiting materials',
    parentId: '16.2',
    level: 4,
  },
  {
    identifier: '17',
    name: 'Papper och pappersvaror',
    nameEng: 'Paper and paper products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '17.1',
    name: 'Massa, papper och papp',
    nameEng: 'Pulp, paper and paperboard',
    parentId: '17',
    level: 3,
  },
  {
    identifier: '17.11',
    name: 'Massa',
    nameEng: 'Pulp',
    parentId: '17.1',
    level: 4,
  },
  {
    identifier: '17.12',
    name: 'Papper och papp',
    nameEng: 'Paper and paperboard',
    parentId: '17.1',
    level: 4,
  },
  {
    identifier: '17.2',
    name: 'Varor av papper eller papp',
    nameEng: 'Articles of paper and paperboard',
    parentId: '17',
    level: 3,
  },
  {
    identifier: '17.21',
    name: 'Vågpapper och wellpapp, och pappers- och pappförpackningar',
    nameEng:
      'Corrugated paper and paperboard and containers of paper and paperboard',
    parentId: '17.2',
    level: 4,
  },
  {
    identifier: '17.22',
    name: 'Hushålls- och hygienartiklar av papper',
    nameEng: 'Household and sanitary goods and toilet requisites',
    parentId: '17.2',
    level: 4,
  },
  {
    identifier: '17.23',
    name: 'Skrivpapper, kuvert o.d.',
    nameEng: 'Paper stationery',
    parentId: '17.2',
    level: 4,
  },
  {
    identifier: '17.24',
    name: 'Tapeter',
    nameEng: 'Wallpaper',
    parentId: '17.2',
    level: 4,
  },
  {
    identifier: '17.29',
    name: 'Andra varor av papper eller papp',
    nameEng: 'Other articles of paper and paperboard',
    parentId: '17.2',
    level: 4,
  },
  {
    identifier: '18',
    name: 'Grafiska tjänster och tjänster avseende reproduktion av inspelningar',
    nameEng: 'Printing and reproduction services of recorded media',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '18.1',
    name: 'Grafiska tjänster',
    nameEng: 'Printing services and services related to printing',
    parentId: '18',
    level: 3,
  },
  {
    identifier: '18.11',
    name: 'Tjänster avseende tryckning av dagstidningar',
    nameEng: 'Newspaper printing services',
    parentId: '18.1',
    level: 4,
  },
  {
    identifier: '18.12',
    name: 'Tjänster avseende annan tryckning',
    nameEng: 'Other printing services',
    parentId: '18.1',
    level: 4,
  },
  {
    identifier: '18.13',
    name: 'Grafiska tjänster före tryckning (prepress/premedia)',
    nameEng: 'Pre-press and pre-media services',
    parentId: '18.1',
    level: 4,
  },
  {
    identifier: '18.14',
    name: 'Bokbindning och andra tjänster i samband med tryckning',
    nameEng: 'Binding and related services',
    parentId: '18.1',
    level: 4,
  },
  {
    identifier: '18.2',
    name: 'Tjänster avseende reproduktion av inspelningar',
    nameEng: 'Reproduction services of recorded media',
    parentId: '18',
    level: 3,
  },
  {
    identifier: '18.20',
    name: 'Tjänster avseende reproduktion av inspelningar',
    nameEng: 'Reproduction services of recorded media',
    parentId: '18.2',
    level: 4,
  },
  {
    identifier: '19',
    name: 'Stenkolsprodukter och raffinerade petroleumprodukter',
    nameEng: 'Coke and refined petroleum products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '19.1',
    name: 'Stenkolsprodukter',
    nameEng: 'Coke oven products',
    parentId: '19',
    level: 3,
  },
  {
    identifier: '19.10',
    name: 'Stenkolsprodukter',
    nameEng: 'Coke oven products',
    parentId: '19.1',
    level: 4,
  },
  {
    identifier: '19.2',
    name: 'Raffinerade petroleumprodukter',
    nameEng: 'Refined petroleum products',
    parentId: '19',
    level: 3,
  },
  {
    identifier: '19.20',
    name: 'Raffinerade petroleumprodukter',
    nameEng: 'Refined petroleum products',
    parentId: '19.2',
    level: 4,
  },
  {
    identifier: '20',
    name: 'Kemikalier och kemiska produkter',
    nameEng: 'Chemicals and chemical products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '20.1',
    name: 'Baskemikalier, gödselmedel och kväveprodukter, plaster och syntetgummi i obearbetad form',
    nameEng:
      'Basic chemicals, fertilisers and nitrogen compounds, plastics and synthetic rubber in primary forms',
    parentId: '20',
    level: 3,
  },
  {
    identifier: '20.11',
    name: 'Industrigaser',
    nameEng: 'Industrial gases',
    parentId: '20.1',
    level: 4,
  },
  {
    identifier: '20.12',
    name: 'Färgämnen',
    nameEng: 'Dyes and pigments',
    parentId: '20.1',
    level: 4,
  },
  {
    identifier: '20.13',
    name: 'Andra oorganiska baskemikalier',
    nameEng: 'Other inorganic basic chemicals',
    parentId: '20.1',
    level: 4,
  },
  {
    identifier: '20.14',
    name: 'Andra organiska baskemikalier',
    nameEng: 'Other organic basic chemicals',
    parentId: '20.1',
    level: 4,
  },
  {
    identifier: '20.15',
    name: 'Gödselmedel och kväveprodukter',
    nameEng: 'Fertilisers and nitrogen compounds',
    parentId: '20.1',
    level: 4,
  },
  {
    identifier: '20.16',
    name: 'Plaster i obearbetad form',
    nameEng: 'Plastics in primary forms',
    parentId: '20.1',
    level: 4,
  },
  {
    identifier: '20.17',
    name: 'Syntetgummi i obearbetad form',
    nameEng: 'Synthetic rubber in primary forms',
    parentId: '20.1',
    level: 4,
  },
  {
    identifier: '20.2',
    name: 'Bekämpningsmedel och andra lantbrukskemiska produkter',
    nameEng: 'Pesticides and other agrochemical products',
    parentId: '20',
    level: 3,
  },
  {
    identifier: '20.20',
    name: 'Bekämpningsmedel och andra lantbrukskemiska produkter',
    nameEng: 'Pesticides and other agrochemical products',
    parentId: '20.2',
    level: 4,
  },
  {
    identifier: '20.3',
    name: 'Lacker och andra målningsfärger, tryckfärger samt tätnings- och utfyllningsmedel',
    nameEng: 'Paints, varnishes and similar coatings, printing ink and mastics',
    parentId: '20',
    level: 3,
  },
  {
    identifier: '20.30',
    name: 'Lacker och andra målningsfärger, tryckfärger samt tätnings- och utfyllningsmedel',
    nameEng: 'Paints, varnishes and similar coatings, printing ink and mastics',
    parentId: '20.3',
    level: 4,
  },
  {
    identifier: '20.4',
    name: 'Tvål och såpa, rengöringsmedel, parfym och toalettartiklar',
    nameEng:
      'Soap and detergents, cleaning and polishing preparations, perfumes and toilet preparations',
    parentId: '20',
    level: 3,
  },
  {
    identifier: '20.41',
    name: 'Tvål och såpa, tvättmedel, rengöringsmedel och polermedel',
    nameEng: 'Soap and detergents, cleaning and polishing preparations',
    parentId: '20.4',
    level: 4,
  },
  {
    identifier: '20.42',
    name: 'Parfymeringsmedel och toalettartiklar',
    nameEng: 'Perfumes and toilet preparations',
    parentId: '20.4',
    level: 4,
  },
  {
    identifier: '20.5',
    name: 'Andra kemiska produkter',
    nameEng: 'Other chemical products',
    parentId: '20',
    level: 3,
  },
  {
    identifier: '20.51',
    name: 'Sprängämnen',
    nameEng: 'Explosives',
    parentId: '20.5',
    level: 4,
  },
  {
    identifier: '20.52',
    name: 'Lim och klister',
    nameEng: 'Glues',
    parentId: '20.5',
    level: 4,
  },
  {
    identifier: '20.53',
    name: 'Eteriska oljor',
    nameEng: 'Essential oils',
    parentId: '20.5',
    level: 4,
  },
  {
    identifier: '20.59',
    name: 'Övriga kemiska produkter',
    nameEng: 'Other chemical products n.e.c.',
    parentId: '20.5',
    level: 4,
  },
  {
    identifier: '20.6',
    name: 'Konstfibrer',
    nameEng: 'Man-made fibres',
    parentId: '20',
    level: 3,
  },
  {
    identifier: '20.60',
    name: 'Konstfibrer',
    nameEng: 'Man-made fibres',
    parentId: '20.6',
    level: 4,
  },
  {
    identifier: '21',
    name: 'Farmaceutiska basprodukter och läkemedel',
    nameEng: 'Basic pharmaceutical products and pharmaceutical preparations',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '21.1',
    name: 'Farmaceutiska basprodukter',
    nameEng: 'Basic pharmaceutical products',
    parentId: '21',
    level: 3,
  },
  {
    identifier: '21.10',
    name: 'Farmaceutiska basprodukter',
    nameEng: 'Basic pharmaceutical products',
    parentId: '21.1',
    level: 4,
  },
  {
    identifier: '21.2',
    name: 'Läkemedel; andra farmaceutiska produkter',
    nameEng: 'Pharmaceutical preparations',
    parentId: '21',
    level: 3,
  },
  {
    identifier: '21.20',
    name: 'Läkemedel; andra farmaceutiska produkter',
    nameEng: 'Pharmaceutical preparations',
    parentId: '21.2',
    level: 4,
  },
  {
    identifier: '22',
    name: 'Gummi- och plastvaror',
    nameEng: 'Rubber and plastic products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '22.1',
    name: 'Gummivaror',
    nameEng: 'Rubber products',
    parentId: '22',
    level: 3,
  },
  {
    identifier: '22.11',
    name: 'Däck och slangar; regummering',
    nameEng:
      'Rubber tyres and tubes; retreading and rebuilding of rubber tyres',
    parentId: '22.1',
    level: 4,
  },
  {
    identifier: '22.19',
    name: 'Andra gummivaror',
    nameEng: 'Other rubber products',
    parentId: '22.1',
    level: 4,
  },
  {
    identifier: '22.2',
    name: 'Plastvaror',
    nameEng: 'Plastic products',
    parentId: '22',
    level: 3,
  },
  {
    identifier: '22.21',
    name: 'Plattor, duk, rör och profilerade stänger och strängar, av plast',
    nameEng: 'Plastic plates, sheets, tubes and profiles',
    parentId: '22.2',
    level: 4,
  },
  {
    identifier: '22.22',
    name: 'Förpackningar av plast',
    nameEng: 'Plastic packing goods',
    parentId: '22.2',
    level: 4,
  },
  {
    identifier: '22.23',
    name: 'Byggplastvaror',
    nameEng: "Builders' ware of plastic",
    parentId: '22.2',
    level: 4,
  },
  {
    identifier: '22.29',
    name: 'Andra plastvaror',
    nameEng: 'Other plastic products',
    parentId: '22.2',
    level: 4,
  },
  {
    identifier: '23',
    name: 'Andra icke-metalliska mineraliska produkter',
    nameEng: 'Other non-metallic mineral products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '23.1',
    name: 'Glas- och glasprodukter',
    nameEng: 'Glass and glass products',
    parentId: '23',
    level: 3,
  },
  {
    identifier: '23.11',
    name: 'Planglas',
    nameEng: 'Flat glass',
    parentId: '23.1',
    level: 4,
  },
  {
    identifier: '23.12',
    name: 'Format och bearbetat planglas',
    nameEng: 'Shaped and processed flat glass',
    parentId: '23.1',
    level: 4,
  },
  {
    identifier: '23.13',
    name: 'Buteljer, glasförpackningar och husgeråd av glas',
    nameEng: 'Hollow glass',
    parentId: '23.1',
    level: 4,
  },
  {
    identifier: '23.14',
    name: 'Glasfiber',
    nameEng: 'Glass fibres',
    parentId: '23.1',
    level: 4,
  },
  {
    identifier: '23.19',
    name: 'Andra glasvaror, inklusive tekniska glasvaror',
    nameEng: 'Other processed glass, including technical glassware',
    parentId: '23.1',
    level: 4,
  },
  {
    identifier: '23.2',
    name: 'Eldfasta produkter',
    nameEng: 'Refractory products',
    parentId: '23',
    level: 3,
  },
  {
    identifier: '23.20',
    name: 'Eldfasta produkter',
    nameEng: 'Refractory products',
    parentId: '23.2',
    level: 4,
  },
  {
    identifier: '23.3',
    name: 'Byggmaterial av lergods',
    nameEng: 'Clay building materials',
    parentId: '23',
    level: 3,
  },
  {
    identifier: '23.31',
    name: 'Keramiska golv- och väggplattor',
    nameEng: 'Ceramic tiles and flags',
    parentId: '23.3',
    level: 4,
  },
  {
    identifier: '23.32',
    name: 'Murtegel, takpannor och andra byggvaror av tegel',
    nameEng: 'Bricks, tiles and construction products, in baked clay',
    parentId: '23.3',
    level: 4,
  },
  {
    identifier: '23.4',
    name: 'Andra porslinsprodukter och keramiska produkter',
    nameEng: 'Other porcelain and ceramic products',
    parentId: '23',
    level: 3,
  },
  {
    identifier: '23.41',
    name: 'Keramiska hushålls- och prydnadsartiklar',
    nameEng: 'Ceramic household and ornamental articles',
    parentId: '23.4',
    level: 4,
  },
  {
    identifier: '23.42',
    name: 'Sanitetsporslin',
    nameEng: 'Ceramic sanitary fixtures',
    parentId: '23.4',
    level: 4,
  },
  {
    identifier: '23.43',
    name: 'Keramiska isolatorer o.d.',
    nameEng: 'Ceramic insulators and insulating fittings',
    parentId: '23.4',
    level: 4,
  },
  {
    identifier: '23.44',
    name: 'Andra tekniska keramiska produkter',
    nameEng: 'Other technical ceramic products',
    parentId: '23.4',
    level: 4,
  },
  {
    identifier: '23.49',
    name: 'Andra keramiska produkter',
    nameEng: 'Other ceramic products',
    parentId: '23.4',
    level: 4,
  },
  {
    identifier: '23.5',
    name: 'Cement, kalk och gips',
    nameEng: 'Cement, lime and plaster',
    parentId: '23',
    level: 3,
  },
  {
    identifier: '23.51',
    name: 'Cement',
    nameEng: 'Cement',
    parentId: '23.5',
    level: 4,
  },
  {
    identifier: '23.52',
    name: 'Kalk och gips',
    nameEng: 'Lime and plaster',
    parentId: '23.5',
    level: 4,
  },
  {
    identifier: '23.6',
    name: 'Varor av betong, cement och gips',
    nameEng: 'Articles of concrete, cement and plaster',
    parentId: '23',
    level: 3,
  },
  {
    identifier: '23.61',
    name: 'Betongvaror för byggändamål',
    nameEng: 'Concrete products for construction purposes',
    parentId: '23.6',
    level: 4,
  },
  {
    identifier: '23.62',
    name: 'Gipsvaror för byggändamål',
    nameEng: 'Plaster products for construction purposes',
    parentId: '23.6',
    level: 4,
  },
  {
    identifier: '23.63',
    name: 'Fabriksblandad betong',
    nameEng: 'Ready-mixed concrete',
    parentId: '23.6',
    level: 4,
  },
  {
    identifier: '23.64',
    name: 'Murbruk',
    nameEng: 'Mortars',
    parentId: '23.6',
    level: 4,
  },
  {
    identifier: '23.65',
    name: 'Fibercement',
    nameEng: 'Fibre cement',
    parentId: '23.6',
    level: 4,
  },
  {
    identifier: '23.69',
    name: 'Andra varor av betong, gips och cement',
    nameEng: 'Other articles of concrete, plaster and cement',
    parentId: '23.6',
    level: 4,
  },
  {
    identifier: '23.7',
    name: 'Huggen, formad och slutbearbetad sten',
    nameEng: 'Cut, shaped and finished stone',
    parentId: '23',
    level: 3,
  },
  {
    identifier: '23.70',
    name: 'Huggen, formad och slutbearbetad sten',
    nameEng: 'Cut, shaped and finished stone',
    parentId: '23.7',
    level: 4,
  },
  {
    identifier: '23.9',
    name: 'Slipmedel och övriga icke-metalliska mineraliska produkter',
    nameEng: 'Other non-metallic mineral products',
    parentId: '23',
    level: 3,
  },
  {
    identifier: '23.91',
    name: 'Slipmedel',
    nameEng: 'Abrasive products',
    parentId: '23.9',
    level: 4,
  },
  {
    identifier: '23.99',
    name: 'Övriga icke-metalliska mineraliska produkter',
    nameEng: 'Other non-metallic mineral products n.e.c.',
    parentId: '23.9',
    level: 4,
  },
  {
    identifier: '24',
    name: 'Metaller',
    nameEng: 'Basic metals',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '24.1',
    name: 'Järn och stål samt ferrolegeringar',
    nameEng: 'Basic iron and steel and ferro-alloys',
    parentId: '24',
    level: 3,
  },
  {
    identifier: '24.10',
    name: 'Järn och stål samt ferrolegeringar',
    nameEng: 'Basic iron and steel and ferro-alloys',
    parentId: '24.1',
    level: 4,
  },
  {
    identifier: '24.2',
    name: 'Rör, ledningar, ihåliga profiler och tillbehör av stål',
    nameEng: 'Tubes, pipes, hollow profiles and related fittings, of steel',
    parentId: '24',
    level: 3,
  },
  {
    identifier: '24.20',
    name: 'Rör, ledningar, ihåliga profiler och tillbehör av stål',
    nameEng: 'Tubes, pipes, hollow profiles and related fittings, of steel',
    parentId: '24.2',
    level: 4,
  },
  {
    identifier: '24.3',
    name: 'Andra produkter av primärbearbetat stål',
    nameEng: 'Other products of the first processing of steel',
    parentId: '24',
    level: 3,
  },
  {
    identifier: '24.31',
    name: 'Kalldragna stänger',
    nameEng: 'Cold drawn bars',
    parentId: '24.3',
    level: 4,
  },
  {
    identifier: '24.32',
    name: 'Kallvalsade stålband',
    nameEng: 'Cold rolled narrow strip',
    parentId: '24.3',
    level: 4,
  },
  {
    identifier: '24.33',
    name: 'Produkter av stål som tillformats eller färdigbehandlats i kallt tillstånd',
    nameEng: 'Cold formed or folded products',
    parentId: '24.3',
    level: 4,
  },
  {
    identifier: '24.34',
    name: 'Kalldragen tråd av stål',
    nameEng: 'Cold drawn wire',
    parentId: '24.3',
    level: 4,
  },
  {
    identifier: '24.4',
    name: 'Andra metaller än järn',
    nameEng: 'Basic precious and other non-ferrous metals',
    parentId: '24',
    level: 3,
  },
  {
    identifier: '24.41',
    name: 'Ädelmetaller',
    nameEng: 'Precious metals',
    parentId: '24.4',
    level: 4,
  },
  {
    identifier: '24.42',
    name: 'Aluminium',
    nameEng: 'Aluminium',
    parentId: '24.4',
    level: 4,
  },
  {
    identifier: '24.43',
    name: 'Bly, zink och tenn',
    nameEng: 'Lead, zinc and tin',
    parentId: '24.4',
    level: 4,
  },
  {
    identifier: '24.44',
    name: 'Koppar',
    nameEng: 'Copper',
    parentId: '24.4',
    level: 4,
  },
  {
    identifier: '24.45',
    name: 'Andra metaller',
    nameEng: 'Other non-ferrous metal',
    parentId: '24.4',
    level: 4,
  },
  {
    identifier: '24.46',
    name: 'Kärnbränslematerial',
    nameEng: 'Processed nuclear fuel',
    parentId: '24.4',
    level: 4,
  },
  {
    identifier: '24.5',
    name: 'Tjänster avseende gjutning av metall',
    nameEng: 'Casting services of metals',
    parentId: '24',
    level: 3,
  },
  {
    identifier: '24.51',
    name: 'Tjänster avseende gjutning av järn',
    nameEng: 'Casting services of iron',
    parentId: '24.5',
    level: 4,
  },
  {
    identifier: '24.52',
    name: 'Tjänster avseende gjutning av stål',
    nameEng: 'Casting services of steel',
    parentId: '24.5',
    level: 4,
  },
  {
    identifier: '24.53',
    name: 'Tjänster avseende gjutning av lättmetaller',
    nameEng: 'Casting services of light metals',
    parentId: '24.5',
    level: 4,
  },
  {
    identifier: '24.54',
    name: 'Tjänster avseende gjutning av andra metaller',
    nameEng: 'Casting services of other non-ferrous metals',
    parentId: '24.5',
    level: 4,
  },
  {
    identifier: '25',
    name: 'Metallvaror, utom maskiner och apparater',
    nameEng: 'Fabricated metal products, except machinery and equipment',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '25.1',
    name: 'Byggnadsmetallvaror',
    nameEng: 'Structural metal products',
    parentId: '25',
    level: 3,
  },
  {
    identifier: '25.11',
    name: 'Metallstommar och delar därav',
    nameEng: 'Metal structures and parts of structures',
    parentId: '25.1',
    level: 4,
  },
  {
    identifier: '25.12',
    name: 'Dörrar och fönster av metall',
    nameEng: 'Doors and windows of metal',
    parentId: '25.1',
    level: 4,
  },
  {
    identifier: '25.2',
    name: 'Cisterner, tankar, kar och andra behållare av metall',
    nameEng: 'Tanks, reservoirs and containers of metal',
    parentId: '25',
    level: 3,
  },
  {
    identifier: '25.21',
    name: 'Radiatorer och pannor för centraluppvärmning',
    nameEng: 'Central heating radiators and boilers',
    parentId: '25.2',
    level: 4,
  },
  {
    identifier: '25.29',
    name: 'Andra cisterner, tankar, kar och andra behållare av metall',
    nameEng: 'Other tanks, reservoirs and containers of metal',
    parentId: '25.2',
    level: 4,
  },
  {
    identifier: '25.3',
    name: 'Ånggeneratorer utom varmvattenpannor för centraluppvärmning',
    nameEng: 'Steam generators, except central heating hot water boilers',
    parentId: '25',
    level: 3,
  },
  {
    identifier: '25.30',
    name: 'Ånggeneratorer utom varmvattenpannor för centraluppvärmning',
    nameEng: 'Steam generators, except central heating hot water boilers',
    parentId: '25.3',
    level: 4,
  },
  {
    identifier: '25.4',
    name: 'Vapen och ammunition',
    nameEng: 'Weapons and ammunition',
    parentId: '25',
    level: 3,
  },
  {
    identifier: '25.40',
    name: 'Vapen och ammunition',
    nameEng: 'Weapons and ammunition',
    parentId: '25.4',
    level: 4,
  },
  {
    identifier: '25.5',
    name: 'Tjänster avseende smidning, pressning, prägling och valsning av metall; pulvermetallurgi',
    nameEng:
      'Forging, pressing, stamping and roll-forming services of metal; powder metallurgy',
    parentId: '25',
    level: 3,
  },
  {
    identifier: '25.50',
    name: 'Tjänster avseende smidning, pressning, prägling och valsning av metall; pulvermetallurgi',
    nameEng:
      'Forging, pressing, stamping and roll-forming services of metal; powder metallurgy',
    parentId: '25.5',
    level: 4,
  },
  {
    identifier: '25.6',
    name: 'Tjänster avseende beläggning och överdragning av metall; metallegoarbeten',
    nameEng: 'Treatment and coating services of metals; machining',
    parentId: '25',
    level: 3,
  },
  {
    identifier: '25.61',
    name: 'Tjänster avseende beläggning och överdragning av metall',
    nameEng: 'Treatment and coating services of metals',
    parentId: '25.6',
    level: 4,
  },
  {
    identifier: '25.62',
    name: 'Metallegotjänster',
    nameEng: 'Machining services',
    parentId: '25.6',
    level: 4,
  },
  {
    identifier: '25.7',
    name: 'Bestick, verktyg och andra järnhandelsvaror',
    nameEng: 'Cutlery, tools and general hardware',
    parentId: '25',
    level: 3,
  },
  {
    identifier: '25.71',
    name: 'Bestick',
    nameEng: 'Cutlery',
    parentId: '25.7',
    level: 4,
  },
  {
    identifier: '25.72',
    name: 'Lås och gångjärn',
    nameEng: 'Locks and hinges',
    parentId: '25.7',
    level: 4,
  },
  {
    identifier: '25.73',
    name: 'Verktyg och redskap',
    nameEng: 'Tools',
    parentId: '25.7',
    level: 4,
  },
  {
    identifier: '25.9',
    name: 'Andra metallvaror',
    nameEng: 'Other fabricated metal products',
    parentId: '25',
    level: 3,
  },
  {
    identifier: '25.91',
    name: 'Stålfat och dylika behållare',
    nameEng: 'Steel drums and similar containers',
    parentId: '25.9',
    level: 4,
  },
  {
    identifier: '25.92',
    name: 'Lättmetallförpackningar',
    nameEng: 'Light metal packaging',
    parentId: '25.9',
    level: 4,
  },
  {
    identifier: '25.93',
    name: 'Metalltrådvaror, kedjor och fjädrar',
    nameEng: 'Wire products, chain and springs',
    parentId: '25.9',
    level: 4,
  },
  {
    identifier: '25.94',
    name: 'Nitar och skruvar',
    nameEng: 'Fasteners and screw machine products',
    parentId: '25.9',
    level: 4,
  },
  {
    identifier: '25.99',
    name: 'Övriga metallvaror',
    nameEng: 'Other fabricated metal products n.e.c.',
    parentId: '25.9',
    level: 4,
  },
  {
    identifier: '26',
    name: 'Datorer, elektronikvaror och optik',
    nameEng: 'Computer, electronic and optical products',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '26.1',
    name: 'Elektroniska komponenter och kretskort',
    nameEng: 'Electronic components and boards',
    parentId: '26',
    level: 3,
  },
  {
    identifier: '26.11',
    name: 'Elektroniska komponenter',
    nameEng: 'Electronic components',
    parentId: '26.1',
    level: 4,
  },
  {
    identifier: '26.12',
    name: 'Kretskort',
    nameEng: 'Loaded electronic boards',
    parentId: '26.1',
    level: 4,
  },
  {
    identifier: '26.2',
    name: 'Datorer och kringutrustning',
    nameEng: 'Computers and peripheral equipment',
    parentId: '26',
    level: 3,
  },
  {
    identifier: '26.20',
    name: 'Datorer och kringutrustning',
    nameEng: 'Computers and peripheral equipment',
    parentId: '26.2',
    level: 4,
  },
  {
    identifier: '26.3',
    name: 'Kommunikationsutrustning',
    nameEng: 'Communication equipment',
    parentId: '26',
    level: 3,
  },
  {
    identifier: '26.30',
    name: 'Kommunikationsutrustning',
    nameEng: 'Communication equipment',
    parentId: '26.3',
    level: 4,
  },
  {
    identifier: '26.4',
    name: 'Hemelektronik',
    nameEng: 'Consumer electronics',
    parentId: '26',
    level: 3,
  },
  {
    identifier: '26.40',
    name: 'Hemelektronik',
    nameEng: 'Consumer electronics',
    parentId: '26.4',
    level: 4,
  },
  {
    identifier: '26.5',
    name: 'Instrument och apparater för mätning, provning och navigering samt ur',
    nameEng: 'Measuring, testing and navigating equipment; watches and clocks',
    parentId: '26',
    level: 3,
  },
  {
    identifier: '26.51',
    name: 'Instrument och apparater för mätning, provning och navigering',
    nameEng: 'Measuring, testing and navigating equipment',
    parentId: '26.5',
    level: 4,
  },
  {
    identifier: '26.52',
    name: 'Ur',
    nameEng: 'Watches and clocks',
    parentId: '26.5',
    level: 4,
  },
  {
    identifier: '26.6',
    name: 'Strålningsutrustning samt elektromedicinsk och elektroterapeutisk utrustning',
    nameEng: 'Irradiation, electromedical and electrotherapeutic equipment',
    parentId: '26',
    level: 3,
  },
  {
    identifier: '26.60',
    name: 'Strålningsutrustning samt elektromedicinsk och elektroterapeutisk utrustning',
    nameEng: 'Irradiation, electromedical and electrotherapeutic equipment',
    parentId: '26.6',
    level: 4,
  },
  {
    identifier: '26.7',
    name: 'Optiska instrument och fotoutrustning',
    nameEng: 'Optical instruments and photographic equipment',
    parentId: '26',
    level: 3,
  },
  {
    identifier: '26.70',
    name: 'Optiska instrument och fotoutrustning',
    nameEng: 'Optical instruments and photographic equipment',
    parentId: '26.7',
    level: 4,
  },
  {
    identifier: '26.8',
    name: 'Magnetiska och optiska medier',
    nameEng: 'Magnetic and optical media',
    parentId: '26',
    level: 3,
  },
  {
    identifier: '26.80',
    name: 'Magnetiska och optiska medier',
    nameEng: 'Magnetic and optical media',
    parentId: '26.8',
    level: 4,
  },
  {
    identifier: '27',
    name: 'Elapparatur',
    nameEng: 'Electrical equipment',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '27.1',
    name: 'Elmotorer, generatorer och transformatorer samt eldistributions- och elkontrollapparater',
    nameEng:
      'Electric motors, generators, transformers and electricity distribution and control apparatus',
    parentId: '27',
    level: 3,
  },
  {
    identifier: '27.11',
    name: 'Elmotorer, generatorer och transformatorer',
    nameEng: 'Electric motors, generators and transformers',
    parentId: '27.1',
    level: 4,
  },
  {
    identifier: '27.12',
    name: 'Eldistributions- och elkontrollapparater',
    nameEng: 'Electricity distribution and control apparatus',
    parentId: '27.1',
    level: 4,
  },
  {
    identifier: '27.2',
    name: 'Batterier och ackumulatorer',
    nameEng: 'Batteries and accumulators',
    parentId: '27',
    level: 3,
  },
  {
    identifier: '27.20',
    name: 'Batterier och ackumulatorer',
    nameEng: 'Batteries and accumulators',
    parentId: '27.2',
    level: 4,
  },
  {
    identifier: '27.3',
    name: 'Kablar och kabeltillbehör',
    nameEng: 'Wiring and wiring devices',
    parentId: '27',
    level: 3,
  },
  {
    identifier: '27.31',
    name: 'Optiska fiberkablar',
    nameEng: 'Fibre optic cables',
    parentId: '27.3',
    level: 4,
  },
  {
    identifier: '27.32',
    name: 'Andra elektroniska och elektriska ledningar och kablar',
    nameEng: 'Other electronic and electric wires and cables',
    parentId: '27.3',
    level: 4,
  },
  {
    identifier: '27.33',
    name: 'Kabeltillbehör',
    nameEng: 'Wiring devices',
    parentId: '27.3',
    level: 4,
  },
  {
    identifier: '27.4',
    name: 'Belysningsarmatur',
    nameEng: 'Electric lighting equipment',
    parentId: '27',
    level: 3,
  },
  {
    identifier: '27.40',
    name: 'Belysningsarmatur',
    nameEng: 'Electric lighting equipment',
    parentId: '27.4',
    level: 4,
  },
  {
    identifier: '27.5',
    name: 'Hushållsmaskiner och hushållsapparater',
    nameEng: 'Domestic appliances',
    parentId: '27',
    level: 3,
  },
  {
    identifier: '27.51',
    name: 'Elektriska hushållsmaskiner och hushållsapparater',
    nameEng: 'Electric domestic appliances',
    parentId: '27.5',
    level: 4,
  },
  {
    identifier: '27.52',
    name: 'Icke-elektriska hushållsmaskiner och hushållsapparater',
    nameEng: 'Non-electric domestic appliances',
    parentId: '27.5',
    level: 4,
  },
  {
    identifier: '27.9',
    name: 'Annan elapparatur',
    nameEng: 'Other electrical equipment',
    parentId: '27',
    level: 3,
  },
  {
    identifier: '27.90',
    name: 'Annan elapparatur',
    nameEng: 'Other electrical equipment',
    parentId: '27.9',
    level: 4,
  },
  {
    identifier: '28',
    name: 'Övriga maskiner',
    nameEng: 'Machinery and equipment n.e.c.',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '28.1',
    name: 'Maskiner för allmänt ändamål',
    nameEng: 'General-purpose machinery',
    parentId: '28',
    level: 3,
  },
  {
    identifier: '28.11',
    name: 'Motorer och turbiner utom för luftfartyg och fordon',
    nameEng: 'Engines and turbines, except aircraft, vehicle and cycle engines',
    parentId: '28.1',
    level: 4,
  },
  {
    identifier: '28.12',
    name: 'Fluidteknisk utrustning',
    nameEng: 'Fluid power equipment',
    parentId: '28.1',
    level: 4,
  },
  {
    identifier: '28.13',
    name: 'Andra pumpar och kompressorer',
    nameEng: 'Other pumps and compressors',
    parentId: '28.1',
    level: 4,
  },
  {
    identifier: '28.14',
    name: 'Andra kranar och ventiler',
    nameEng: 'Other taps and valves',
    parentId: '28.1',
    level: 4,
  },
  {
    identifier: '28.15',
    name: 'Lager, kugghjul och andra delar för kraftöverföring',
    nameEng: 'Bearings, gears, gearing and driving elements',
    parentId: '28.1',
    level: 4,
  },
  {
    identifier: '28.2',
    name: 'Andra maskiner för allmänt ändamål',
    nameEng: 'Other general-purpose machinery',
    parentId: '28',
    level: 3,
  },
  {
    identifier: '28.21',
    name: 'Ugnar och brännare',
    nameEng: 'Ovens, furnaces and furnace burners',
    parentId: '28.2',
    level: 4,
  },
  {
    identifier: '28.22',
    name: 'Lyft- och godshanteringsanordningar',
    nameEng: 'Lifting and handling equipment',
    parentId: '28.2',
    level: 4,
  },
  {
    identifier: '28.23',
    name: 'Kontorsmaskiner och kontorsutrustning (utom datorer och kringutrustning)',
    nameEng:
      'Office machinery and equipment (except computers and peripheral equipment)',
    parentId: '28.2',
    level: 4,
  },
  {
    identifier: '28.24',
    name: 'Motordrivna handverktyg',
    nameEng: 'Power-driven hand tools',
    parentId: '28.2',
    level: 4,
  },
  {
    identifier: '28.25',
    name: 'Maskiner och apparater för kyla och ventilation utom för hushåll',
    nameEng: 'Non-domestic cooling and ventilation equipment',
    parentId: '28.2',
    level: 4,
  },
  {
    identifier: '28.29',
    name: 'Övriga maskiner för allmänt ändamål',
    nameEng: 'Other general-purpose machinery n.e.c.',
    parentId: '28.2',
    level: 4,
  },
  {
    identifier: '28.3',
    name: 'Jord- och skogsbruksmaskiner',
    nameEng: 'Agricultural and forestry machinery',
    parentId: '28',
    level: 3,
  },
  {
    identifier: '28.30',
    name: 'Jord- och skogsbruksmaskiner',
    nameEng: 'Agricultural and forestry machinery',
    parentId: '28.3',
    level: 4,
  },
  {
    identifier: '28.4',
    name: 'Maskiner för metallbearbetning och verktygsmaskiner',
    nameEng: 'Metal forming machinery and machine tools',
    parentId: '28',
    level: 3,
  },
  {
    identifier: '28.41',
    name: 'Maskiner för metallbearbetning',
    nameEng: 'Metal forming machinery',
    parentId: '28.4',
    level: 4,
  },
  {
    identifier: '28.49',
    name: 'Övriga verktygsmaskiner',
    nameEng: 'Other machine tools',
    parentId: '28.4',
    level: 4,
  },
  {
    identifier: '28.9',
    name: 'Andra specialmaskiner',
    nameEng: 'Other special-purpose machinery',
    parentId: '28',
    level: 3,
  },
  {
    identifier: '28.91',
    name: 'Maskiner för metallurgi',
    nameEng: 'Machinery for metallurgy',
    parentId: '28.9',
    level: 4,
  },
  {
    identifier: '28.92',
    name: 'Gruv-, bergbrytnings- och byggmaskiner',
    nameEng: 'Machinery for mining, quarrying and construction',
    parentId: '28.9',
    level: 4,
  },
  {
    identifier: '28.93',
    name: 'Maskiner för framställning av livsmedel, drycker och tobaksvaror',
    nameEng: 'Machinery for food, beverage and tobacco processing',
    parentId: '28.9',
    level: 4,
  },
  {
    identifier: '28.94',
    name: 'Maskiner för tillverkning av textil-, beklädnads- och lädervaror',
    nameEng: 'Machinery for textile, apparel and leather production',
    parentId: '28.9',
    level: 4,
  },
  {
    identifier: '28.95',
    name: 'Maskiner för tillverkning av massa, papper och papp',
    nameEng: 'Machinery for paper and paperboard production',
    parentId: '28.9',
    level: 4,
  },
  {
    identifier: '28.96',
    name: 'Plast- och gummibearbetningsmaskiner',
    nameEng: 'Plastics and rubber machinery',
    parentId: '28.9',
    level: 4,
  },
  {
    identifier: '28.99',
    name: 'Övriga specialmaskiner',
    nameEng: 'Other special-purpose machinery n.e.c.',
    parentId: '28.9',
    level: 4,
  },
  {
    identifier: '29',
    name: 'Motorfordon, släpfordon och påhängsvagnar',
    nameEng: 'Motor vehicles, trailers and semi-trailers',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '29.1',
    name: 'Motorfordon',
    nameEng: 'Motor vehicles',
    parentId: '29',
    level: 3,
  },
  {
    identifier: '29.10',
    name: 'Motorfordon',
    nameEng: 'Motor vehicles',
    parentId: '29.1',
    level: 4,
  },
  {
    identifier: '29.2',
    name: 'Karosserier för motorfordon; släpfordon och påhängsvagnar',
    nameEng:
      'Bodies (coachwork) for motor vehicles; trailers and semi-trailers',
    parentId: '29',
    level: 3,
  },
  {
    identifier: '29.20',
    name: 'Karosserier för motorfordon; släpfordon och påhängsvagnar',
    nameEng:
      'Bodies (coachwork) for motor vehicles; trailers and semi-trailers',
    parentId: '29.2',
    level: 4,
  },
  {
    identifier: '29.3',
    name: 'Delar och tillbehör till motorfordon',
    nameEng: 'Parts and accessories for motor vehicles',
    parentId: '29',
    level: 3,
  },
  {
    identifier: '29.31',
    name: 'Elektrisk och elektronisk utrustning för motorfordon',
    nameEng: 'Electrical and electronic equipment for motor vehicles',
    parentId: '29.3',
    level: 4,
  },
  {
    identifier: '29.32',
    name: 'Andra delar och tillbehör till motorfordon',
    nameEng: 'Other parts and accessories for motor vehicles',
    parentId: '29.3',
    level: 4,
  },
  {
    identifier: '30',
    name: 'Andra transportmedel',
    nameEng: 'Other transport equipment',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '30.1',
    name: 'Fartyg och båtar',
    nameEng: 'Ships and boats',
    parentId: '30',
    level: 3,
  },
  {
    identifier: '30.11',
    name: 'Fartyg och flytande materiel',
    nameEng: 'Ships and floating structures',
    parentId: '30.1',
    level: 4,
  },
  {
    identifier: '30.12',
    name: 'Fritidsbåtar',
    nameEng: 'Pleasure and sporting boats',
    parentId: '30.1',
    level: 4,
  },
  {
    identifier: '30.2',
    name: 'Rälsfordon',
    nameEng: 'Railway locomotives and rolling stock',
    parentId: '30',
    level: 3,
  },
  {
    identifier: '30.20',
    name: 'Rälsfordon',
    nameEng: 'Railway locomotives and rolling stock',
    parentId: '30.2',
    level: 4,
  },
  {
    identifier: '30.3',
    name: 'Luftfartyg, rymdfarkoster o.d.',
    nameEng: 'Air and spacecraft and related machinery',
    parentId: '30',
    level: 3,
  },
  {
    identifier: '30.30',
    name: 'Luftfartyg, rymdfarkoster o.d.',
    nameEng: 'Air and spacecraft and related machinery',
    parentId: '30.3',
    level: 4,
  },
  {
    identifier: '30.4',
    name: 'Militära stridsfordon',
    nameEng: 'Military fighting vehicles',
    parentId: '30',
    level: 3,
  },
  {
    identifier: '30.40',
    name: 'Militära stridsfordon',
    nameEng: 'Military fighting vehicles',
    parentId: '30.4',
    level: 4,
  },
  {
    identifier: '30.9',
    name: 'Övriga transportmedel',
    nameEng: 'Transport equipment n.e.c.',
    parentId: '30',
    level: 3,
  },
  {
    identifier: '30.91',
    name: 'Motorcyklar',
    nameEng: 'Motorcycles',
    parentId: '30.9',
    level: 4,
  },
  {
    identifier: '30.92',
    name: 'Cyklar och invalidfordon',
    nameEng: 'Bicycles and invalid carriages',
    parentId: '30.9',
    level: 4,
  },
  {
    identifier: '30.99',
    name: 'Diverse övriga transportmedel',
    nameEng: 'Other transport equipment n.e.c.',
    parentId: '30.9',
    level: 4,
  },
  {
    identifier: '31',
    name: 'Möbler',
    nameEng: 'Furniture',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '31.0',
    name: 'Möbler',
    nameEng: 'Furniture',
    parentId: '31',
    level: 3,
  },
  {
    identifier: '31.00',
    name: 'Sittmöbler och delar till sittmöbler; delar till möbler',
    nameEng: 'Seats and parts thereof; parts of furniture',
    parentId: '31.0',
    level: 4,
  },
  {
    identifier: '31.01',
    name: 'Kontors- och butiksmöbler samt kontors- och butiksinredningar',
    nameEng: 'Office and shop furniture',
    parentId: '31.0',
    level: 4,
  },
  {
    identifier: '31.02',
    name: 'Köksmöbler och köksinredningar',
    nameEng: 'Kitchen furniture',
    parentId: '31.0',
    level: 4,
  },
  {
    identifier: '31.03',
    name: 'Madrasser',
    nameEng: 'Mattresses',
    parentId: '31.0',
    level: 4,
  },
  {
    identifier: '31.09',
    name: 'Andra möbler',
    nameEng: 'Other furniture',
    parentId: '31.0',
    level: 4,
  },
  {
    identifier: '32',
    name: 'Andra tillverkade varor',
    nameEng: 'Other manufactured goods',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '32.1',
    name: 'Smycken, guld- och silversmedsvaror samt bijouterier',
    nameEng: 'Jewellery, bijouterie and related articles',
    parentId: '32',
    level: 3,
  },
  {
    identifier: '32.11',
    name: 'Mynt',
    nameEng: 'Coins',
    parentId: '32.1',
    level: 4,
  },
  {
    identifier: '32.12',
    name: 'Smycken, guld- och silversmedsvaror',
    nameEng: 'Jewellery and related articles',
    parentId: '32.1',
    level: 4,
  },
  {
    identifier: '32.13',
    name: 'Bijouterivaror av oädel metall',
    nameEng: 'Imitation jewellery and related articles',
    parentId: '32.1',
    level: 4,
  },
  {
    identifier: '32.2',
    name: 'Musikinstrument',
    nameEng: 'Musical instruments',
    parentId: '32',
    level: 3,
  },
  {
    identifier: '32.20',
    name: 'Musikinstrument',
    nameEng: 'Musical instruments',
    parentId: '32.2',
    level: 4,
  },
  {
    identifier: '32.3',
    name: 'Sportartiklar',
    nameEng: 'Sports goods',
    parentId: '32',
    level: 3,
  },
  {
    identifier: '32.30',
    name: 'Sportartiklar',
    nameEng: 'Sports goods',
    parentId: '32.3',
    level: 4,
  },
  {
    identifier: '32.4',
    name: 'Spel och leksaker',
    nameEng: 'Games and toys',
    parentId: '32',
    level: 3,
  },
  {
    identifier: '32.40',
    name: 'Spel och leksaker',
    nameEng: 'Games and toys',
    parentId: '32.4',
    level: 4,
  },
  {
    identifier: '32.5',
    name: 'Medicinsk och dental utrustning',
    nameEng: 'Medical and dental instruments and supplies',
    parentId: '32',
    level: 3,
  },
  {
    identifier: '32.50',
    name: 'Medicinsk och dental utrustning',
    nameEng: 'Medical and dental instruments and supplies',
    parentId: '32.5',
    level: 4,
  },
  {
    identifier: '32.9',
    name: 'Övriga tillverkade varor',
    nameEng: 'Manufactured goods n.e.c.',
    parentId: '32',
    level: 3,
  },
  {
    identifier: '32.91',
    name: 'Borstbinderiarbeten',
    nameEng: 'Brooms and brushes',
    parentId: '32.9',
    level: 4,
  },
  {
    identifier: '32.99',
    name: 'Diverse övriga tillverkade varor',
    nameEng: 'Other manufactured goods n.e.c.',
    parentId: '32.9',
    level: 4,
  },
  {
    identifier: '33',
    name: 'Tjänster avseende reparation och installation av maskiner och apparater',
    nameEng: 'Repair and installation services of machinery and equipment',
    parentId: 'C',
    level: 2,
  },
  {
    identifier: '33.1',
    name: 'Tjänster avseende reparation av metallvaror, maskiner och apparater',
    nameEng:
      'Repair services of fabricated metal products, machinery and equipment',
    parentId: '33',
    level: 3,
  },
  {
    identifier: '33.11',
    name: 'Tjänster avseende reparation av metallvaror',
    nameEng: 'Repair services of fabricated metal products',
    parentId: '33.1',
    level: 4,
  },
  {
    identifier: '33.12',
    name: 'Tjänster avseende reparation av maskiner',
    nameEng: 'Repair services of machinery',
    parentId: '33.1',
    level: 4,
  },
  {
    identifier: '33.13',
    name: 'Tjänster avseende reparation av elektronisk och optisk utrustning',
    nameEng: 'Repair services of electronic and optical equipment',
    parentId: '33.1',
    level: 4,
  },
  {
    identifier: '33.14',
    name: 'Tjänster avseende reparation av elapparatur',
    nameEng: 'Repair services of electrical equipment',
    parentId: '33.1',
    level: 4,
  },
  {
    identifier: '33.15',
    name: 'Tjänster avseende reparation och underhåll av fartyg och båtar',
    nameEng: 'Repair and maintenance services of ships and boats',
    parentId: '33.1',
    level: 4,
  },
  {
    identifier: '33.16',
    name: 'Tjänster avseende reparation och underhåll av luftfartyg och rymdfarkoster',
    nameEng: 'Repair and maintenance services of aircraft and spacecraft',
    parentId: '33.1',
    level: 4,
  },
  {
    identifier: '33.17',
    name: 'Tjänster avseende reparation och underhåll av andra transportmedel',
    nameEng: 'Repair and maintenance services of other transport equipment',
    parentId: '33.1',
    level: 4,
  },
  {
    identifier: '33.19',
    name: 'Tjänster avseende reparation av annan apparatur',
    nameEng: 'Repair services of other equipment',
    parentId: '33.1',
    level: 4,
  },
  {
    identifier: '33.2',
    name: 'Tjänster avseende installation av industrimaskiner och apparatur',
    nameEng: 'Installation services of industrial machinery and equipment',
    parentId: '33',
    level: 3,
  },
  {
    identifier: '33.20',
    name: 'Tjänster avseende installation av industrimaskiner och apparatur',
    nameEng: 'Installation services of industrial machinery and equipment',
    parentId: '33.2',
    level: 4,
  },
  {
    identifier: 'D',
    name: 'EL, GAS, VÄRME OCH KYLA',
    nameEng: 'Electricity, gas, steam and air conditioning',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '35',
    name: 'El, gas, värme och kyla',
    nameEng: 'Electricity, gas, steam and air conditioning',
    parentId: 'D',
    level: 2,
  },
  {
    identifier: '35.1',
    name: 'Elektricitet, överförings- och distributionstjänster avseende elkraft',
    nameEng: 'Electricity, transmission and distribution services',
    parentId: '35',
    level: 3,
  },
  {
    identifier: '35.11',
    name: 'Elektricitet',
    nameEng: 'Electricity',
    parentId: '35.1',
    level: 4,
  },
  {
    identifier: '35.12',
    name: 'Överföringstjänster avseende elektricitet',
    nameEng: 'Transmission services of electricity',
    parentId: '35.1',
    level: 4,
  },
  {
    identifier: '35.13',
    name: 'Distributionstjänster avseende elektricitet',
    nameEng: 'Distribution services of electricity',
    parentId: '35.1',
    level: 4,
  },
  {
    identifier: '35.14',
    name: 'Handel med elektricitet',
    nameEng: 'Trade services of electricity',
    parentId: '35.1',
    level: 4,
  },
  {
    identifier: '35.2',
    name: 'Framställd gas; distributionstjänster avseende gasformiga bränslen via rörnät',
    nameEng:
      'Manufactured gas; distribution services of gaseous fuels through mains',
    parentId: '35',
    level: 3,
  },
  {
    identifier: '35.21',
    name: 'Framställd gas',
    nameEng: 'Manufactured gas',
    parentId: '35.2',
    level: 4,
  },
  {
    identifier: '35.22',
    name: 'Distributionstjänster avseende gasformiga bränslen via rörnät',
    nameEng: 'Distribution services of gaseous fuels through mains',
    parentId: '35.2',
    level: 4,
  },
  {
    identifier: '35.23',
    name: 'Handel med gas via rörnät',
    nameEng: 'Trade services of gas through mains',
    parentId: '35.2',
    level: 4,
  },
  {
    identifier: '35.3',
    name: 'Försörjningstjänster avseende värme och kyla',
    nameEng: 'Steam and air conditioning supply services',
    parentId: '35',
    level: 3,
  },
  {
    identifier: '35.30',
    name: 'Försörjningstjänster avseende värme och kyla',
    nameEng: 'Steam and air conditioning supply services',
    parentId: '35.3',
    level: 4,
  },
  {
    identifier: 'E',
    name: 'VATTENFÖRSÖRJNINGSTJÄNSTER; AVLOPPSRENINGS-, AVFALLSHANTERINGS- OCH SANERINGSTJÄNSTER',
    nameEng:
      'Water supply; sewerage, waste management and remediation services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '36',
    name: 'Naturligt vatten; vattenförsörjningstjänster',
    nameEng: 'Natural water; water treatment and supply services',
    parentId: 'E',
    level: 2,
  },
  {
    identifier: '36.0',
    name: 'Naturligt vatten; vattenförsörjningstjänster',
    nameEng: 'Natural water; water treatment and supply services',
    parentId: '36',
    level: 3,
  },
  {
    identifier: '36.00',
    name: 'Naturligt vatten; vattenförsörjningstjänster',
    nameEng: 'Natural water; water treatment and supply services',
    parentId: '36.0',
    level: 4,
  },
  {
    identifier: '37',
    name: 'Avloppsreningstjänster; avloppsslam',
    nameEng: 'Sewerage services; sewage sludge',
    parentId: 'E',
    level: 2,
  },
  {
    identifier: '37.0',
    name: 'Avloppsreningstjänster; avloppsslam',
    nameEng: 'Sewerage services; sewage sludge',
    parentId: '37',
    level: 3,
  },
  {
    identifier: '37.00',
    name: 'Avloppsreningstjänster; avloppsslam',
    nameEng: 'Sewerage services; sewage sludge',
    parentId: '37.0',
    level: 4,
  },
  {
    identifier: '38',
    name: 'Avfallshanteringstjänster; återvinningstjänster',
    nameEng:
      'Waste collection, treatment and disposal services; materials recovery services',
    parentId: 'E',
    level: 2,
  },
  {
    identifier: '38.1',
    name: 'Avfall; insamlingstjänster avseende avfall',
    nameEng: 'Waste; waste collection services',
    parentId: '38',
    level: 3,
  },
  {
    identifier: '38.11',
    name: 'Icke-farligt avfall; insamlingstjänster avseende icke-farligt avfall',
    nameEng: 'Non-hazardous waste; collection services of non-hazardous waste',
    parentId: '38.1',
    level: 4,
  },
  {
    identifier: '38.12',
    name: 'Farligt avfall; insamlingstjänster avseende farligt avfall',
    nameEng: 'Hazardous waste; collection services of hazardous waste',
    parentId: '38.1',
    level: 4,
  },
  {
    identifier: '38.2',
    name: 'Tjänster avseende behandling och bortskaffande av avfall',
    nameEng: 'Waste treatment and disposal services',
    parentId: '38',
    level: 3,
  },
  {
    identifier: '38.21',
    name: 'Tjänster avseende behandling och bortskaffande av icke-farligt avfall',
    nameEng: 'Treatment and disposal services of non-hazardous waste',
    parentId: '38.2',
    level: 4,
  },
  {
    identifier: '38.22',
    name: 'Tjänster avseende behandling och bortskaffande av farligt avfall',
    nameEng: 'Treatment and disposal services of hazardous waste',
    parentId: '38.2',
    level: 4,
  },
  {
    identifier: '38.3',
    name: 'Återvinningstjänster; returråvara',
    nameEng: 'Materials recovery services; secondary raw materials',
    parentId: '38',
    level: 3,
  },
  {
    identifier: '38.31',
    name: 'Demonteringstjänster avseende uttjänta fartyg, fordon och maskiner',
    nameEng: 'Dismantling services of wrecks',
    parentId: '38.3',
    level: 4,
  },
  {
    identifier: '38.32',
    name: 'Återvinningstjänster avseende källsorterat material; returråvara',
    nameEng: 'Sorted materials recovery services; secondary raw materials',
    parentId: '38.3',
    level: 4,
  },
  {
    identifier: '39',
    name: 'Sanerings-, efterbehandlings- och andra tjänster för avfallshantering',
    nameEng: 'Remediation services and other waste management services',
    parentId: 'E',
    level: 2,
  },
  {
    identifier: '39.0',
    name: 'Sanerings-, efterbehandlings- och andra tjänster för avfallshantering',
    nameEng: 'Remediation services and other waste management services',
    parentId: '39',
    level: 3,
  },
  {
    identifier: '39.00',
    name: 'Sanerings-, efterbehandlings- och andra tjänster för avfallshantering',
    nameEng: 'Remediation services and other waste management services',
    parentId: '39.0',
    level: 4,
  },
  {
    identifier: 'F',
    name: 'BYGGNADSARBETEN, ANLÄGGNINGSARBETEN SAMT SPECIALISERADE BYGG- OCH ANLÄGGNINGSARBETEN',
    nameEng: 'Constructions and construction works',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '41',
    name: 'Byggnader och byggnadsarbeten',
    nameEng: 'Buildings and building construction works',
    parentId: 'F',
    level: 2,
  },
  {
    identifier: '41.0',
    name: 'Byggnader och byggnadsarbeten',
    nameEng: 'Buildings and building construction works',
    parentId: '41',
    level: 3,
  },
  {
    identifier: '41.00',
    name: 'Byggnader och byggnadsarbeten',
    nameEng: 'Buildings and building construction works',
    parentId: '41.0',
    level: 4,
  },
  {
    identifier: '42',
    name: 'Anläggningsarbeten',
    nameEng: 'Constructions and construction works for civil engineering',
    parentId: 'F',
    level: 2,
  },
  {
    identifier: '42.1',
    name: 'Vägar och järnvägar; anläggning av vägar och järnvägar',
    nameEng: 'Roads and railways; construction works for roads and railways',
    parentId: '42',
    level: 3,
  },
  {
    identifier: '42.11',
    name: 'Vägar och motorvägar; anläggning av vägar och motorvägar',
    nameEng: 'Roads and motorways; construction works for roads and motorways',
    parentId: '42.1',
    level: 4,
  },
  {
    identifier: '42.12',
    name: 'Järnvägar och tunnelbanor; anläggning av järnvägar och tunnelbanor',
    nameEng:
      'Railways and underground railways; construction works for railways and underground railways',
    parentId: '42.1',
    level: 4,
  },
  {
    identifier: '42.13',
    name: 'Broar och tunnlar; anläggning av broar och tunnlar',
    nameEng: 'Bridges and tunnels; construction works for bridges and tunnels',
    parentId: '42.1',
    level: 4,
  },
  {
    identifier: '42.2',
    name: 'Allmännyttiga anläggningar och anläggningsarbeten',
    nameEng: 'Constructions and construction works for utility projects',
    parentId: '42',
    level: 3,
  },
  {
    identifier: '42.21',
    name: 'Allmännyttiga anläggningar och anläggningsarbeten för värme, vatten och avlopp',
    nameEng:
      'Constructions and construction works for utility projects for fluids',
    parentId: '42.2',
    level: 4,
  },
  {
    identifier: '42.22',
    name: 'Allmännyttiga anläggningar och anläggningsarbeten för el och telekommunikation',
    nameEng:
      'Constructions and construction works for utility projects for electricity and telecommunications',
    parentId: '42.2',
    level: 4,
  },
  {
    identifier: '42.9',
    name: 'Andra bygg- och anläggningsarbeten',
    nameEng:
      'Constructions and construction works for other civil engineering projects',
    parentId: '42',
    level: 3,
  },
  {
    identifier: '42.91',
    name: 'Vattenanläggningar och vattenbyggnad',
    nameEng: 'Constructions and construction works for water projects',
    parentId: '42.9',
    level: 4,
  },
  {
    identifier: '42.99',
    name: 'Övriga anläggningar och bygg- och anläggningsarbeten',
    nameEng:
      'Constructions and construction works for other civil engineering projects n.e.c.',
    parentId: '42.9',
    level: 4,
  },
  {
    identifier: '43',
    name: 'Specialiserade bygg- och anläggningsarbeten',
    nameEng: 'Specialised construction works',
    parentId: 'F',
    level: 2,
  },
  {
    identifier: '43.1',
    name: 'Husrivningsarbeten samt mark- och grundarbeten',
    nameEng: 'Demolition and site preparation works',
    parentId: '43',
    level: 3,
  },
  {
    identifier: '43.11',
    name: 'Rivningsarbeten av hus och byggnader',
    nameEng: 'Demolition works',
    parentId: '43.1',
    level: 4,
  },
  {
    identifier: '43.12',
    name: 'Förberedande byggplatsarbeten',
    nameEng: 'Site preparation works',
    parentId: '43.1',
    level: 4,
  },
  {
    identifier: '43.13',
    name: 'Markundersökningsarbeten',
    nameEng: 'Test drilling and boring works',
    parentId: '43.1',
    level: 4,
  },
  {
    identifier: '43.2',
    name: 'Elinstallationer, VVS-arbeten och andra bygginstallationer',
    nameEng: 'Electrical, plumbing and other construction installation works',
    parentId: '43',
    level: 3,
  },
  {
    identifier: '43.21',
    name: 'Elinstallationsarbeten',
    nameEng: 'Electrical installation works',
    parentId: '43.2',
    level: 4,
  },
  {
    identifier: '43.22',
    name: 'VVS-arbeten',
    nameEng: 'Plumbing, heat and air conditioning installation works',
    parentId: '43.2',
    level: 4,
  },
  {
    identifier: '43.29',
    name: 'Andra bygginstallationsarbeten',
    nameEng: 'Other construction installation works',
    parentId: '43.2',
    level: 4,
  },
  {
    identifier: '43.3',
    name: 'Slutbehandlingsarbeten av byggnader',
    nameEng: 'Building completion and finishing works',
    parentId: '43',
    level: 3,
  },
  {
    identifier: '43.31',
    name: 'Puts-, fasad- och stuckatörsarbeten',
    nameEng: 'Plastering works',
    parentId: '43.3',
    level: 4,
  },
  {
    identifier: '43.32',
    name: 'Byggnadssnickeriarbeten',
    nameEng: 'Joinery installation works',
    parentId: '43.3',
    level: 4,
  },
  {
    identifier: '43.33',
    name: 'Golv- och väggbeläggningsarbeten',
    nameEng: 'Floor and wall covering works',
    parentId: '43.3',
    level: 4,
  },
  {
    identifier: '43.34',
    name: 'Måleri- och glasmästeriarbeten',
    nameEng: 'Painting and glazing works',
    parentId: '43.3',
    level: 4,
  },
  {
    identifier: '43.39',
    name: 'Andra slutbehandlingsarbeten av byggnader',
    nameEng: 'Other building completion and finishing works',
    parentId: '43.3',
    level: 4,
  },
  {
    identifier: '43.9',
    name: 'Andra specialiserade bygg- och anläggningsarbeten',
    nameEng: 'Other specialised construction works',
    parentId: '43',
    level: 3,
  },
  {
    identifier: '43.91',
    name: 'Takarbeten',
    nameEng: 'Roofing works',
    parentId: '43.9',
    level: 4,
  },
  {
    identifier: '43.99',
    name: 'Övriga specialiserade bygg- och anläggningsarbeten',
    nameEng: 'Other specialised construction works n.e.c.',
    parentId: '43.9',
    level: 4,
  },
  {
    identifier: 'G',
    name: 'HANDEL; REPARATION AV MOTORFORDON',
    nameEng:
      'Wholesale and retail trade services; repair services of motor vehicles and motorcycles',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '45',
    name: 'Handel samt reparation av motorfordon',
    nameEng:
      'Wholesale and retail trade and repair services of motor vehicles and motorcycles',
    parentId: 'G',
    level: 2,
  },
  {
    identifier: '45.1',
    name: 'Handel med motorfordon utom motorcyklar',
    nameEng: 'Trade services of motor vehicles',
    parentId: '45',
    level: 3,
  },
  {
    identifier: '45.11',
    name: 'Handel med personbilar och lätta motorfordon',
    nameEng: 'Trade services of cars and light motor vehicles',
    parentId: '45.1',
    level: 4,
  },
  {
    identifier: '45.19',
    name: 'Handel med andra motorfordon',
    nameEng: 'Trade services of other motor vehicles',
    parentId: '45.1',
    level: 4,
  },
  {
    identifier: '45.2',
    name: 'Underhåll och reparation av motorfordon utom motorcyklar',
    nameEng: 'Maintenance and repair services of motor vehicles',
    parentId: '45',
    level: 3,
  },
  {
    identifier: '45.20',
    name: 'Underhåll och reparation av motorfordon utom motorcyklar',
    nameEng: 'Maintenance and repair services of motor vehicles',
    parentId: '45.2',
    level: 4,
  },
  {
    identifier: '45.3',
    name: 'Handel med reservdelar och tillbehör till motorfordon utom motorcyklar',
    nameEng: 'Trade services of motor vehicle parts and accessories',
    parentId: '45',
    level: 3,
  },
  {
    identifier: '45.31',
    name: 'Parti- och provisionshandel med reservdelar och tillbehör till motorfordon utom motorcyklar',
    nameEng: 'Wholesale trade services of motor vehicle parts and accessories',
    parentId: '45.3',
    level: 4,
  },
  {
    identifier: '45.32',
    name: 'Detaljhandel med reservdelar och tillbehör till motorfordon utom motorcyklar',
    nameEng: 'Retail trade services of motor vehicle parts and accessories',
    parentId: '45.3',
    level: 4,
  },
  {
    identifier: '45.4',
    name: 'Handel med och service av motorcyklar inklusive reservdelar och tillbehör',
    nameEng:
      'Trade, maintenance and repair services of motorcycles and related parts and accessories',
    parentId: '45',
    level: 3,
  },
  {
    identifier: '45.40',
    name: 'Handel med och service av motorcyklar inklusive reservdelar och tillbehör',
    nameEng:
      'Trade, maintenance and repair services of motorcycles and related parts and accessories',
    parentId: '45.4',
    level: 4,
  },
  {
    identifier: '46',
    name: 'Parti- och provisionshandel utom med motorfordon',
    nameEng:
      'Wholesale trade services, except of motor vehicles and motorcycles',
    parentId: 'G',
    level: 2,
  },
  {
    identifier: '46.1',
    name: 'Provisionshandel utom med motorfordon',
    nameEng: 'Wholesale trade services on a fee or contract basis',
    parentId: '46',
    level: 3,
  },
  {
    identifier: '46.11',
    name: 'Provisionshandel med jordbruksråvaror, levande djur, textilråvaror och textilhalvfabrikat',
    nameEng:
      'Wholesale trade services on a fee or contract basis of agricultural raw materials, live animals, textile raw materials and semi-finished goods',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.12',
    name: 'Provisionshandel med bränsle, malm, metaller och industrikemikalier',
    nameEng:
      'Wholesale trade services on a fee or contract basis of fuels, ores, metals and industrial chemicals',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.13',
    name: 'Provisionshandel med virke och byggmaterial',
    nameEng:
      'Wholesale trade services on a fee or contract basis of timber and building materials',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.14',
    name: 'Provisionshandel med maskiner, industriell utrustning, fartyg och luftfartyg',
    nameEng:
      'Wholesale trade services on a fee or contract basis of machinery, industrial equipment, ships and aircraft',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.15',
    name: 'Provisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\nProvisionshandel med möbler, hushålls- och järnhandelsvaror\n',
    nameEng:
      'Wholesale trade services on a fee or contract basis of furniture, household goods, hardware and ironmongery',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.16',
    name: 'Provisionshandel med textilier, kläder, päls, skodon och lädervaror',
    nameEng:
      'Wholesale trade services on a fee or contract basis of textiles, clothing, fur, footwear and leather goods',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.17',
    name: 'Provisionshandel med livsmedel, drycker och tobak',
    nameEng:
      'Wholesale trade services on a fee or contract basis of food, beverages and tobacco',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.18',
    name: 'Provisionshandel med annat specialsortiment',
    nameEng:
      'Wholesale trade services on a fee or contract basis of other particular products',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.19',
    name: 'Provisionshandel med blandat sortiment',
    nameEng:
      'Wholesale trade services on a fee or contract basis of a variety of goods',
    parentId: '46.1',
    level: 4,
  },
  {
    identifier: '46.2',
    name: 'Partihandel med jordbruksråvaror och levande djur',
    nameEng:
      'Wholesale trade services of agricultural raw materials and live animals',
    parentId: '46',
    level: 3,
  },
  {
    identifier: '46.21',
    name: 'Partihandel med spannmål, råtobak, utsäde och djurfoder',
    nameEng:
      'Wholesale trade services of grain, unmanufactured tobacco, seeds and animal feeds',
    parentId: '46.2',
    level: 4,
  },
  {
    identifier: '46.22',
    name: 'Partihandel med blommor och växter',
    nameEng: 'Wholesale trade services of flowers and plants',
    parentId: '46.2',
    level: 4,
  },
  {
    identifier: '46.23',
    name: 'Partihandel med levande djur',
    nameEng: 'Wholesale trade services of live animals',
    parentId: '46.2',
    level: 4,
  },
  {
    identifier: '46.24',
    name: 'Partihandel med hudar, skinn och läder',
    nameEng: 'Wholesale trade services of hides, skins and leather',
    parentId: '46.2',
    level: 4,
  },
  {
    identifier: '46.3',
    name: 'Partihandel med livsmedel, drycker och tobak',
    nameEng: 'Wholesale trade services of food, beverages and tobacco',
    parentId: '46',
    level: 3,
  },
  {
    identifier: '46.31',
    name: 'Partihandel med frukt och grönsaker',
    nameEng: 'Wholesale trade services of fruit and vegetables',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.32',
    name: 'Partihandel med kött och köttvaror',
    nameEng: 'Wholesale trade services of meat and meat products',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.33',
    name: 'Partihandel med mejeriprodukter, ägg, matolja och matfett',
    nameEng:
      'Wholesale trade services of dairy products, eggs and edible oils and fats',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.34',
    name: 'Partihandel med drycker',
    nameEng: 'Wholesale trade services of beverages',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.35',
    name: 'Partihandel med tobak',
    nameEng: 'Wholesale trade services of tobacco products',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.36',
    name: 'Partihandel med socker, choklad och sockerkonfektyrer',
    nameEng:
      'Wholesale trade services of sugar and chocolate and sugar confectionery',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.37',
    name: 'Partihandel med kaffe, te, kakao och kryddor',
    nameEng: 'Wholesale trade services of coffee, tea, cocoa and spices',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.38',
    name: 'Partihandel med andra livsmedel, bl.a. fisk samt skal- och blötdjur',
    nameEng:
      'Wholesale trade services of other food, including fish, crustaceans and molluscs',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.39',
    name: 'Icke specialiserad partihandel med livsmedel, drycker och tobak',
    nameEng:
      'Non-specialised wholesale trade services of food, beverages and tobacco',
    parentId: '46.3',
    level: 4,
  },
  {
    identifier: '46.4',
    name: 'Partihandel med hushållsvaror',
    nameEng: 'Wholesale trade services of household goods',
    parentId: '46',
    level: 3,
  },
  {
    identifier: '46.41',
    name: 'Partihandel med textilier',
    nameEng: 'Wholesale trade services of textiles',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.42',
    name: 'Partihandel med kläder och skodon',
    nameEng: 'Wholesale trade services of clothing and footwear',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.43',
    name: 'Partihandel med elektriska hushållsapparater',
    nameEng: 'Wholesale trade services of electrical household appliances',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.44',
    name: 'Partihandel med glas och porslin, rengöringsmedel',
    nameEng:
      'Wholesale trade services of china and glassware and cleaning materials',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.45',
    name: 'Partihandel med parfym och kosmetika',
    nameEng: 'Wholesale trade services of perfume and cosmetics',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.46',
    name: 'Partihandel med apoteksvaror och medicinsk utrustning',
    nameEng: 'Wholesale trade services of pharmaceutical goods',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.47',
    name: 'Partihandel med möbler, mattor och belysningsartiklar',
    nameEng:
      'Wholesale trade services of furniture, carpets and lighting equipment',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.48',
    name: 'Partihandel med ur, guldsmedsvaror och smycken',
    nameEng: 'Wholesale trade services of watches and jewellery',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.49',
    name: 'Partihandel med andra hushållsvaror',
    nameEng: 'Wholesale trade services of other household goods',
    parentId: '46.4',
    level: 4,
  },
  {
    identifier: '46.5',
    name: 'Partihandel med informations- och kommunikationsutrustning',
    nameEng:
      'Wholesale trade services of information and communication equipment',
    parentId: '46',
    level: 3,
  },
  {
    identifier: '46.51',
    name: 'Partihandel med datorer och kringutrustning samt programvara',
    nameEng:
      'Wholesale trade services of computers, computer peripheral equipment and software',
    parentId: '46.5',
    level: 4,
  },
  {
    identifier: '46.52',
    name: 'Partihandel med elektronik- och telekommunikationsutrustning',
    nameEng:
      'Wholesale trade services of electronic and telecommunications equipment and parts',
    parentId: '46.5',
    level: 4,
  },
  {
    identifier: '46.6',
    name: 'Partihandel med övriga maskiner och övrig utrustning',
    nameEng:
      'Wholesale trade services of other machinery, equipment and supplies',
    parentId: '46',
    level: 3,
  },
  {
    identifier: '46.61',
    name: 'Partihandel med jordbruksmaskiner och -utrustning',
    nameEng:
      'Wholesale trade services of agricultural machinery, equipment and supplies',
    parentId: '46.6',
    level: 4,
  },
  {
    identifier: '46.62',
    name: 'Partihandel med verktygsmaskiner',
    nameEng: 'Wholesale trade services of machine tools',
    parentId: '46.6',
    level: 4,
  },
  {
    identifier: '46.63',
    name: 'Partihandel med gruv-, bygg- och anläggningsmaskiner',
    nameEng:
      'Wholesale trade services of mining, construction and civil engineering machinery',
    parentId: '46.6',
    level: 4,
  },
  {
    identifier: '46.64',
    name: 'Partihandel med textil-, sy- och stickmaskiner',
    nameEng:
      'Wholesale trade services of machinery for the textile industry and of sewing and knitting machines',
    parentId: '46.6',
    level: 4,
  },
  {
    identifier: '46.65',
    name: 'Partihandel med kontorsmöbler',
    nameEng: 'Wholesale trade services of office furniture',
    parentId: '46.6',
    level: 4,
  },
  {
    identifier: '46.66',
    name: 'Partihandel med andra kontorsmaskiner och kontorsutrustning',
    nameEng: 'Wholesale trade services of other office machinery and equipment',
    parentId: '46.6',
    level: 4,
  },
  {
    identifier: '46.69',
    name: 'Partihandel med andra maskiner och annan utrustning',
    nameEng: 'Wholesale trade services of other machinery and equipment',
    parentId: '46.6',
    level: 4,
  },
  {
    identifier: '46.7',
    name: 'Annan specialiserad partihandel',
    nameEng: 'Other specialised wholesale trade services',
    parentId: '46',
    level: 3,
  },
  {
    identifier: '46.71',
    name: 'Partihandel med bränslen',
    nameEng:
      'Wholesale trade services of solid, liquid and gaseous fuels and related products',
    parentId: '46.7',
    level: 4,
  },
  {
    identifier: '46.72',
    name: 'Partihandel med metaller och metallmalmer',
    nameEng: 'Wholesale trade services of metals and metal ores',
    parentId: '46.7',
    level: 4,
  },
  {
    identifier: '46.73',
    name: 'Partihandel med virke, andra byggmaterial och sanitetsgods',
    nameEng:
      'Wholesale trade services of wood, construction materials and sanitary equipment',
    parentId: '46.7',
    level: 4,
  },
  {
    identifier: '46.74',
    name: 'Partihandel med järnhandelsvaror och VVS-armatur',
    nameEng:
      'Wholesale trade services of hardware, plumbing and heating equipment and supplies',
    parentId: '46.7',
    level: 4,
  },
  {
    identifier: '46.75',
    name: 'Partihandel med kemiska produkter',
    nameEng: 'Wholesale trade services of chemical products',
    parentId: '46.7',
    level: 4,
  },
  {
    identifier: '46.76',
    name: 'Partihandel med andra insatsvaror',
    nameEng: 'Wholesale trade services of other intermediate products',
    parentId: '46.7',
    level: 4,
  },
  {
    identifier: '46.77',
    name: 'Partihandel med avfallsprodukter och skrot',
    nameEng: 'Wholesale trade services of waste and scrap',
    parentId: '46.7',
    level: 4,
  },
  {
    identifier: '46.9',
    name: 'Övrig partihandel',
    nameEng: 'Non-specialised wholesale trade services',
    parentId: '46',
    level: 3,
  },
  {
    identifier: '46.90',
    name: 'Övrig partihandel',
    nameEng: 'Non-specialised wholesale trade services',
    parentId: '46.9',
    level: 4,
  },
  {
    identifier: '47',
    name: 'Detaljhandel utom med motorfordon',
    nameEng: 'Retail trade services, except of motor vehicles and motorcycles',
    parentId: 'G',
    level: 2,
  },
  {
    identifier: '47.0',
    name: 'Detaljhandel utom med motorfordon',
    nameEng: 'Retail trade services, except of motor vehicles and motorcycles',
    parentId: '47',
    level: 3,
  },
  {
    identifier: '47.00',
    name: 'Detaljhandel utom med motorfordon',
    nameEng: 'Retail trade services, except of motor vehicles and motorcycles',
    parentId: '47.0',
    level: 4,
  },
  {
    identifier: 'H',
    name: 'TRANSPORT- OCH MAGASINERINGSTJÄNSTER',
    nameEng: 'Transportation and storage services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '49',
    name: 'Tjänster avseende landtransport; transport i rörsystem',
    nameEng: 'Land transport services and transport services via pipelines',
    parentId: 'H',
    level: 2,
  },
  {
    identifier: '49.1',
    name: 'Tjänster avseende järnvägstransport, passagerartrafik',
    nameEng: 'Passenger rail transport services, interurban',
    parentId: '49',
    level: 3,
  },
  {
    identifier: '49.10',
    name: 'Tjänster avseende järnvägstransport, passagerartrafik',
    nameEng: 'Passenger rail transport services, interurban',
    parentId: '49.1',
    level: 4,
  },
  {
    identifier: '49.2',
    name: 'Tjänster avseende järnvägstransport, godstrafik',
    nameEng: 'Freight rail transport services',
    parentId: '49',
    level: 3,
  },
  {
    identifier: '49.20',
    name: 'Tjänster avseende järnvägstransport, godstrafik',
    nameEng: 'Freight rail transport services',
    parentId: '49.2',
    level: 4,
  },
  {
    identifier: '49.3',
    name: 'Tjänster avseende annan landtransport, passagerartrafik',
    nameEng: 'Other passenger land transport services',
    parentId: '49',
    level: 3,
  },
  {
    identifier: '49.31',
    name: 'Tjänster avseende kollektivtrafik',
    nameEng: 'Urban and suburban passenger land transport services',
    parentId: '49.3',
    level: 4,
  },
  {
    identifier: '49.32',
    name: 'Tjänster avseende taxitrafik och uthyrning av personbil med förare',
    nameEng: 'Taxi operation services',
    parentId: '49.3',
    level: 4,
  },
  {
    identifier: '49.39',
    name: 'Tjänster avseende övrig landtransport av passagerare',
    nameEng: 'Other passenger land transport services n.e.c.',
    parentId: '49.3',
    level: 4,
  },
  {
    identifier: '49.4',
    name: 'Tjänster avseende vägtransport av gods och flyttjänster',
    nameEng: 'Freight transport services by road and removal services',
    parentId: '49',
    level: 3,
  },
  {
    identifier: '49.41',
    name: 'Tjänster avseende vägtransport av gods',
    nameEng: 'Freight transport services by road',
    parentId: '49.4',
    level: 4,
  },
  {
    identifier: '49.42',
    name: 'Flyttjänster',
    nameEng: 'Removal services',
    parentId: '49.4',
    level: 4,
  },
  {
    identifier: '49.5',
    name: 'Tjänster avseende transporter i rörsystem',
    nameEng: 'Transport services via pipeline',
    parentId: '49',
    level: 3,
  },
  {
    identifier: '49.50',
    name: 'Tjänster avseende transporter i rörsystem',
    nameEng: 'Transport services via pipeline',
    parentId: '49.5',
    level: 4,
  },
  {
    identifier: '50',
    name: 'Tjänster avseende sjötransport',
    nameEng: 'Water transport services',
    parentId: 'H',
    level: 2,
  },
  {
    identifier: '50.1',
    name: 'Tjänster avseende havs- och kustsjöfart, passagerartrafik',
    nameEng: 'Sea and coastal passenger water transport services',
    parentId: '50',
    level: 3,
  },
  {
    identifier: '50.10',
    name: 'Tjänster avseende havs- och kustsjöfart, passagerartrafik',
    nameEng: 'Sea and coastal passenger water transport services',
    parentId: '50.1',
    level: 4,
  },
  {
    identifier: '50.2',
    name: 'Tjänster avseende havs- och kustsjöfart, godstrafik',
    nameEng: 'Sea and coastal freight water transport services',
    parentId: '50',
    level: 3,
  },
  {
    identifier: '50.20',
    name: 'Tjänster avseende havs- och kustsjöfart, godstrafik',
    nameEng: 'Sea and coastal freight water transport services',
    parentId: '50.2',
    level: 4,
  },
  {
    identifier: '50.3',
    name: 'Tjänster avseende sjöfart på inre vattenvägar, passagerartrafik',
    nameEng: 'Inland passenger water transport services',
    parentId: '50',
    level: 3,
  },
  {
    identifier: '50.30',
    name: 'Tjänster avseende sjöfart på inre vattenvägar, passagerartrafik',
    nameEng: 'Inland passenger water transport services',
    parentId: '50.3',
    level: 4,
  },
  {
    identifier: '50.4',
    name: 'Tjänster avseende sjöfart på inre vattenvägar, godstrafik',
    nameEng: 'Inland freight water transport services',
    parentId: '50',
    level: 3,
  },
  {
    identifier: '50.40',
    name: 'Tjänster avseende sjöfart på inre vattenvägar, godstrafik',
    nameEng: 'Inland freight water transport services',
    parentId: '50.4',
    level: 4,
  },
  {
    identifier: '51',
    name: 'Tjänster avseende lufttransport',
    nameEng: 'Air transport services',
    parentId: 'H',
    level: 2,
  },
  {
    identifier: '51.1',
    name: 'Tjänster avseende lufttransport, passagerartrafik',
    nameEng: 'Passenger air transport services',
    parentId: '51',
    level: 3,
  },
  {
    identifier: '51.10',
    name: 'Tjänster avseende lufttransport, passagerartrafik',
    nameEng: 'Passenger air transport services',
    parentId: '51.1',
    level: 4,
  },
  {
    identifier: '51.2',
    name: 'Tjänster avseende lufttransport, godstrafik och rymdfart',
    nameEng: 'Freight air transport and space transport services',
    parentId: '51',
    level: 3,
  },
  {
    identifier: '51.21',
    name: 'Tjänster avseende lufttransport, godstrafik',
    nameEng: 'Freight air transport services',
    parentId: '51.2',
    level: 4,
  },
  {
    identifier: '51.22',
    name: 'Tjänster avseende rymdtransport',
    nameEng: 'Space transport services',
    parentId: '51.2',
    level: 4,
  },
  {
    identifier: '52',
    name: 'Tjänster avseende magasinering och stödtjänster till transport',
    nameEng: 'Warehousing and support services for transportation',
    parentId: 'H',
    level: 2,
  },
  {
    identifier: '52.1',
    name: 'Tjänster avseende magasinering och varulagring',
    nameEng: 'Warehousing and storage services',
    parentId: '52',
    level: 3,
  },
  {
    identifier: '52.10',
    name: 'Tjänster avseende magasinering och varulagring',
    nameEng: 'Warehousing and storage services',
    parentId: '52.1',
    level: 4,
  },
  {
    identifier: '52.2',
    name: 'Stödtjänster till transport',
    nameEng: 'Support services for transportation',
    parentId: '52',
    level: 3,
  },
  {
    identifier: '52.21',
    name: 'Tjänster i anslutning till landtransport',
    nameEng: 'Services incidental to land transportation',
    parentId: '52.2',
    level: 4,
  },
  {
    identifier: '52.22',
    name: 'Tjänster i anslutning till sjötransport',
    nameEng: 'Services incidental to water transportation',
    parentId: '52.2',
    level: 4,
  },
  {
    identifier: '52.23',
    name: 'Tjänster i anslutning till lufttransport',
    nameEng: 'Services incidental to air transportation',
    parentId: '52.2',
    level: 4,
  },
  {
    identifier: '52.24',
    name: 'Tjänster avseende godshantering',
    nameEng: 'Cargo handling services',
    parentId: '52.2',
    level: 4,
  },
  {
    identifier: '52.29',
    name: 'Andra stödtjänster till transport',
    nameEng: 'Other transportation support services',
    parentId: '52.2',
    level: 4,
  },
  {
    identifier: '53',
    name: 'Postbefordran och kurirtjänster',
    nameEng: 'Postal and courier services',
    parentId: 'H',
    level: 2,
  },
  {
    identifier: '53.1',
    name: 'Postbefordran via nationella posten',
    nameEng: 'Postal services under universal service obligation',
    parentId: '53',
    level: 3,
  },
  {
    identifier: '53.10',
    name: 'Postbefordran via nationella posten',
    nameEng: 'Postal services under universal service obligation',
    parentId: '53.1',
    level: 4,
  },
  {
    identifier: '53.2',
    name: 'Annan postbefordran samt kurirtjänster',
    nameEng: 'Other postal and courier services',
    parentId: '53',
    level: 3,
  },
  {
    identifier: '53.20',
    name: 'Annan postbefordran samt kurirtjänster',
    nameEng: 'Other postal and courier services',
    parentId: '53.2',
    level: 4,
  },
  {
    identifier: 'I',
    name: 'HOTELL- OCH RESTAURANGTJÄNSTER',
    nameEng: 'Accommodation and food services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '55',
    name: 'Hotell- och logitjänster',
    nameEng: 'Accommodation services',
    parentId: 'I',
    level: 2,
  },
  {
    identifier: '55.1',
    name: 'Hotelltjänster',
    nameEng: 'Hotel and similar accommodation services',
    parentId: '55',
    level: 3,
  },
  {
    identifier: '55.10',
    name: 'Hotelltjänster',
    nameEng: 'Hotel and similar accommodation services',
    parentId: '55.1',
    level: 4,
  },
  {
    identifier: '55.2',
    name: 'Tjänster för semesterbostäder och annat korttidsboende',
    nameEng: 'Holiday and other short stay accommodation services',
    parentId: '55',
    level: 3,
  },
  {
    identifier: '55.20',
    name: 'Tjänster för semesterbostäder och annat korttidsboende',
    nameEng: 'Holiday and other short stay accommodation services',
    parentId: '55.2',
    level: 4,
  },
  {
    identifier: '55.3',
    name: 'Campingplatstjänster och tjänster avseende uppställningsområden för husbilar och husvagnar',
    nameEng: 'Camping ground, recreational and vacation camp services',
    parentId: '55',
    level: 3,
  },
  {
    identifier: '55.30',
    name: 'Campingplatstjänster och tjänster avseende uppställningsområden för husbilar och husvagnar',
    nameEng: 'Camping ground, recreational and vacation camp services',
    parentId: '55.3',
    level: 4,
  },
  {
    identifier: '55.9',
    name: 'Andra logitjänster',
    nameEng: 'Other accommodation services',
    parentId: '55',
    level: 3,
  },
  {
    identifier: '55.90',
    name: 'Andra logitjänster',
    nameEng: 'Other accommodation services',
    parentId: '55.9',
    level: 4,
  },
  {
    identifier: '56',
    name: 'Bar- och restaurangtjänster',
    nameEng: 'Food and beverage serving services',
    parentId: 'I',
    level: 2,
  },
  {
    identifier: '56.1',
    name: 'Restauranger och mobila restaurangtjänster',
    nameEng: 'Restaurant and mobile food serving services',
    parentId: '56',
    level: 3,
  },
  {
    identifier: '56.10',
    name: 'Restauranger och mobila restaurangtjänster',
    nameEng: 'Restaurant and mobile food serving services',
    parentId: '56.1',
    level: 4,
  },
  {
    identifier: '56.2',
    name: 'Cateringtjänster',
    nameEng: 'Event catering services and other food serving services',
    parentId: '56',
    level: 3,
  },
  {
    identifier: '56.21',
    name: 'Cateringtjänster vid enskilda evenemang',
    nameEng: 'Event catering services',
    parentId: '56.2',
    level: 4,
  },
  {
    identifier: '56.29',
    name: 'Andra catering- och centralkökstjänster',
    nameEng: 'Other food serving services',
    parentId: '56.2',
    level: 4,
  },
  {
    identifier: '56.3',
    name: 'Bartjänster',
    nameEng: 'Beverage serving services',
    parentId: '56',
    level: 3,
  },
  {
    identifier: '56.30',
    name: 'Bartjänster',
    nameEng: 'Beverage serving services',
    parentId: '56.3',
    level: 4,
  },
  {
    identifier: 'J',
    name: 'INFORMATIONS- OCH KOMMUNIKATIONSTJÄNSTER',
    nameEng: 'Information and communication services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '58',
    name: 'Förlagstjänster',
    nameEng: 'Publishing services',
    parentId: 'J',
    level: 2,
  },
  {
    identifier: '58.1',
    name: 'Tjänster avseende utgivning av böcker och tidskrifter och annan förlagsverksamhet',
    nameEng:
      'Publishing services of books, periodicals and other publishing services',
    parentId: '58',
    level: 3,
  },
  {
    identifier: '58.11',
    name: 'Bokutgivningstjänster',
    nameEng: 'Book publishing services',
    parentId: '58.1',
    level: 4,
  },
  {
    identifier: '58.12',
    name: 'Publiceringstjänster avseende kataloger och sändlistor',
    nameEng: 'Publishing services of directories and mailing lists',
    parentId: '58.1',
    level: 4,
  },
  {
    identifier: '58.13',
    name: 'Tidningsutgivningstjänster',
    nameEng: 'Publishing services of newspapers',
    parentId: '58.1',
    level: 4,
  },
  {
    identifier: '58.14',
    name: 'Utgivningstjänster avseende tidskrifter',
    nameEng: 'Publishing services of journals and periodicals',
    parentId: '58.1',
    level: 4,
  },
  {
    identifier: '58.19',
    name: 'Andra förlagstjänster',
    nameEng: 'Other publishing services',
    parentId: '58.1',
    level: 4,
  },
  {
    identifier: '58.2',
    name: 'Utgivningstjänster avseende programvara',
    nameEng: 'Software publishing services',
    parentId: '58',
    level: 3,
  },
  {
    identifier: '58.21',
    name: 'Utgivningstjänster avseende dataspel',
    nameEng: 'Publishing services of computer games',
    parentId: '58.2',
    level: 4,
  },
  {
    identifier: '58.29',
    name: 'Utgivningstjänster avseende annan programvara',
    nameEng: 'Other software publishing services',
    parentId: '58.2',
    level: 4,
  },
  {
    identifier: '59',
    name: 'Tjänster avseende film-, video- och TV-program, ljudinspelningar och fonogramutgivning',
    nameEng:
      'Motion picture, video and television programme production services, sound recording and music publishing',
    parentId: 'J',
    level: 2,
  },
  {
    identifier: '59.1',
    name: 'Film-, video- och TV-programtjänster',
    nameEng: 'Motion picture, video and television programme services',
    parentId: '59',
    level: 3,
  },
  {
    identifier: '59.11',
    name: 'Film-, video- och TV-produktionstjänster',
    nameEng:
      'Motion picture, video and television programme production services',
    parentId: '59.1',
    level: 4,
  },
  {
    identifier: '59.12',
    name: 'Tjänster avseende efterproduktion av film, video och TV-program',
    nameEng:
      'Motion picture, video and television programme post-production services',
    parentId: '59.1',
    level: 4,
  },
  {
    identifier: '59.13',
    name: 'Film-, video- och TV-distributionstjänster',
    nameEng:
      'Motion picture, video and television programme distribution services',
    parentId: '59.1',
    level: 4,
  },
  {
    identifier: '59.14',
    name: 'Filmvisningstjänster',
    nameEng: 'Motion picture projection services',
    parentId: '59.1',
    level: 4,
  },
  {
    identifier: '59.2',
    name: 'Ljudinspelnings- och fonogramutgivningstjänster',
    nameEng: 'Sound recording and music publishing services',
    parentId: '59',
    level: 3,
  },
  {
    identifier: '59.20',
    name: 'Ljudinspelnings- och fonogramutgivningstjänster',
    nameEng: 'Sound recording and music publishing services',
    parentId: '59.2',
    level: 4,
  },
  {
    identifier: '60',
    name: 'Tjänster avseende planering och sändning av program',
    nameEng: 'Programming and broadcasting services',
    parentId: 'J',
    level: 2,
  },
  {
    identifier: '60.1',
    name: 'Tjänster avseende sändning av radioprogram',
    nameEng: 'Radio broadcasting services',
    parentId: '60',
    level: 3,
  },
  {
    identifier: '60.10',
    name: 'Tjänster avseende sändning av radioprogram',
    nameEng: 'Radio broadcasting services',
    parentId: '60.1',
    level: 4,
  },
  {
    identifier: '60.2',
    name: 'Tjänster avseende planering och sändning av TV-program; originalsändningar',
    nameEng:
      'Television programming and broadcasting services; broadcasting originals',
    parentId: '60',
    level: 3,
  },
  {
    identifier: '60.20',
    name: 'Tjänster avseende planering och sändning av TV-program; originalsändningar',
    nameEng:
      'Television programming and broadcasting services; broadcasting originals',
    parentId: '60.2',
    level: 4,
  },
  {
    identifier: '61',
    name: 'Telekommunikationstjänster',
    nameEng: 'Telecommunications services',
    parentId: 'J',
    level: 2,
  },
  {
    identifier: '61.1',
    name: 'Tjänster avseende trådbunden telekommunikation',
    nameEng: 'Wired telecommunications services',
    parentId: '61',
    level: 3,
  },
  {
    identifier: '61.10',
    name: 'Tjänster avseende trådbunden telekommunikation',
    nameEng: 'Wired telecommunications services',
    parentId: '61.1',
    level: 4,
  },
  {
    identifier: '61.2',
    name: 'Tjänster avseende trådlös telekommunikation',
    nameEng: 'Wireless telecommunications services',
    parentId: '61',
    level: 3,
  },
  {
    identifier: '61.20',
    name: 'Tjänster avseende trådlös telekommunikation',
    nameEng: 'Wireless telecommunications services',
    parentId: '61.2',
    level: 4,
  },
  {
    identifier: '61.3',
    name: 'Tjänster avseende telekommunikation via satellit',
    nameEng: 'Satellite telecommunications services',
    parentId: '61',
    level: 3,
  },
  {
    identifier: '61.30',
    name: 'Tjänster avseende telekommunikation via satellit',
    nameEng: 'Satellite telecommunications services',
    parentId: '61.3',
    level: 4,
  },
  {
    identifier: '61.9',
    name: 'Tjänster avseende annan telekommunikation',
    nameEng: 'Other telecommunications services',
    parentId: '61',
    level: 3,
  },
  {
    identifier: '61.90',
    name: 'Tjänster avseende annan telekommunikation',
    nameEng: 'Other telecommunications services',
    parentId: '61.9',
    level: 4,
  },
  {
    identifier: '62',
    name: 'Dataprogrammerings-, datakonsulttjänster o.d.',
    nameEng: 'Computer programming, consultancy and related services',
    parentId: 'J',
    level: 2,
  },
  {
    identifier: '62.0',
    name: 'Dataprogrammerings-, datakonsulttjänster o.d.',
    nameEng: 'Computer programming, consultancy and related services',
    parentId: '62',
    level: 3,
  },
  {
    identifier: '62.01',
    name: 'Dataprogrammeringstjänster',
    nameEng: 'Computer programming services',
    parentId: '62.0',
    level: 4,
  },
  {
    identifier: '62.02',
    name: 'Datakonsulttjänster',
    nameEng: 'Computer consultancy services',
    parentId: '62.0',
    level: 4,
  },
  {
    identifier: '62.03',
    name: 'Datordrifttjänster',
    nameEng: 'Computer facilities management services',
    parentId: '62.0',
    level: 4,
  },
  {
    identifier: '62.09',
    name: 'Andra IT-tjänster och datatjänster',
    nameEng: 'Other information technology and computer services',
    parentId: '62.0',
    level: 4,
  },
  {
    identifier: '63',
    name: 'Informationstjänster',
    nameEng: 'Information services',
    parentId: 'J',
    level: 2,
  },
  {
    identifier: '63.1',
    name: 'Databehandlingstjänster, webbhotell o.d.; webbportaler',
    nameEng: 'Data processing, hosting and related services; web portals',
    parentId: '63',
    level: 3,
  },
  {
    identifier: '63.11',
    name: 'Databehandlingstjänster, webbhotell o.d.',
    nameEng: 'Data processing, hosting and related services',
    parentId: '63.1',
    level: 4,
  },
  {
    identifier: '63.12',
    name: 'Webbportalinnehåll',
    nameEng: 'Web portal content',
    parentId: '63.1',
    level: 4,
  },
  {
    identifier: '63.9',
    name: 'Andra informationstjänster',
    nameEng: 'Other information services',
    parentId: '63',
    level: 3,
  },
  {
    identifier: '63.91',
    name: 'Nyhetsservicetjänster',
    nameEng: 'News agency services',
    parentId: '63.9',
    level: 4,
  },
  {
    identifier: '63.99',
    name: 'Övriga informationstjänster',
    nameEng: 'Other information services n.e.c.',
    parentId: '63.9',
    level: 4,
  },
  {
    identifier: 'K',
    name: 'FINANS- OCH FÖRSÄKRINGSTJÄNSTER',
    nameEng: 'Financial and insurance services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '64',
    name: 'Finansiella tjänster utom försäkring och pensionsfondstjänster',
    nameEng: 'Financial services, except insurance and pension funding',
    parentId: 'K',
    level: 2,
  },
  {
    identifier: '64.1',
    name: 'Banktjänster',
    nameEng: 'Monetary intermediation services',
    parentId: '64',
    level: 3,
  },
  {
    identifier: '64.11',
    name: 'Centralbankstjänster',
    nameEng: 'Central banking services',
    parentId: '64.1',
    level: 4,
  },
  {
    identifier: '64.19',
    name: 'Andra banktjänster',
    nameEng: 'Other monetary intermediation services',
    parentId: '64.1',
    level: 4,
  },
  {
    identifier: '64.2',
    name: 'Tjänster som tillhandahålls av holdingföretag',
    nameEng: 'Services of holding companies',
    parentId: '64',
    level: 3,
  },
  {
    identifier: '64.20',
    name: 'Tjänster som tillhandahålls av holdingföretag',
    nameEng: 'Services of holding companies',
    parentId: '64.2',
    level: 4,
  },
  {
    identifier: '64.3',
    name: 'Tjänster som tillhandahålls av fonder och liknande finansiella enheter',
    nameEng: 'Services of trusts, funds and similar financial entities',
    parentId: '64',
    level: 3,
  },
  {
    identifier: '64.30',
    name: 'Tjänster som tillhandahålls av fonder och liknande finansiella enheter',
    nameEng: 'Services of trusts, funds and similar financial entities',
    parentId: '64.3',
    level: 4,
  },
  {
    identifier: '64.9',
    name: 'Andra finansiella tjänster utom försäkring och pensionsfondstjänster',
    nameEng: 'Other financial services, except insurance and pension funding',
    parentId: '64',
    level: 3,
  },
  {
    identifier: '64.91',
    name: 'Tjänster avseende finansiell leasing',
    nameEng: 'Financial leasing services',
    parentId: '64.9',
    level: 4,
  },
  {
    identifier: '64.92',
    name: 'Andra kreditgivningstjänster',
    nameEng: 'Other credit granting services',
    parentId: '64.9',
    level: 4,
  },
  {
    identifier: '64.99',
    name: 'Diverse övriga finansiella tjänster, utom försäkring och pensionsfondstjänster',
    nameEng:
      'Other financial services, except insurance and pension funding, n.e.c.',
    parentId: '64.9',
    level: 4,
  },
  {
    identifier: '65',
    name: 'Tjänster avseende försäkring, återförsäkring och pensionsfonder utom obligatorisk socialförsäkring',
    nameEng:
      'Insurance, reinsurance and pension funding services, except compulsory social security',
    parentId: 'K',
    level: 2,
  },
  {
    identifier: '65.1',
    name: 'Tjänster avseende försäkringar',
    nameEng: 'Insurance services',
    parentId: '65',
    level: 3,
  },
  {
    identifier: '65.11',
    name: 'Tjänster avseende livförsäkring',
    nameEng: 'Life insurance services',
    parentId: '65.1',
    level: 4,
  },
  {
    identifier: '65.12',
    name: 'Tjänster avseende skadeförsäkring',
    nameEng: 'Non-life insurance services',
    parentId: '65.1',
    level: 4,
  },
  {
    identifier: '65.2',
    name: 'Tjänster avseende återförsäkring',
    nameEng: 'Reinsurance services',
    parentId: '65',
    level: 3,
  },
  {
    identifier: '65.20',
    name: 'Tjänster avseende återförsäkring',
    nameEng: 'Reinsurance services',
    parentId: '65.2',
    level: 4,
  },
  {
    identifier: '65.3',
    name: 'Pensionsfondstjänster',
    nameEng: 'Pension funding services',
    parentId: '65',
    level: 3,
  },
  {
    identifier: '65.30',
    name: 'Pensionsfondstjänster',
    nameEng: 'Pension funding services',
    parentId: '65.3',
    level: 4,
  },
  {
    identifier: '66',
    name: 'Stödtjänster till finansiella tjänster och försäkringstjänster',
    nameEng: 'Services auxiliary to financial services and insurance services',
    parentId: 'K',
    level: 2,
  },
  {
    identifier: '66.1',
    name: 'Stödtjänster till finansiella tjänster utom försäkring och pensionsfondstjänster',
    nameEng:
      'Services auxiliary to financial services, except insurance and pension funding',
    parentId: '66',
    level: 3,
  },
  {
    identifier: '66.11',
    name: 'Administrativa stödtjänster till finansiella marknader',
    nameEng: 'Services related to the administration of financial markets',
    parentId: '66.1',
    level: 4,
  },
  {
    identifier: '66.12',
    name: 'Värdepappers- och varumäklartjänster',
    nameEng: 'Security and commodity contracts brokerage services',
    parentId: '66.1',
    level: 4,
  },
  {
    identifier: '66.19',
    name: 'Andra stödtjänster till finansiella tjänster utom försäkring och pensionsfondstjänster',
    nameEng:
      'Other services auxiliary to financial services, except insurance and pension funding',
    parentId: '66.1',
    level: 4,
  },
  {
    identifier: '66.2',
    name: 'Stödtjänster till försäkring och pensionsfondstjänster',
    nameEng: 'Services auxiliary to insurance and pension funding',
    parentId: '66',
    level: 3,
  },
  {
    identifier: '66.21',
    name: 'Risk- och skadebedömningstjänster',
    nameEng: 'Risk and damage evaluation services',
    parentId: '66.2',
    level: 4,
  },
  {
    identifier: '66.22',
    name: 'Tjänster som utförs av försäkringsombud och försäkringsmäklare',
    nameEng: 'Services of insurance agents and brokers',
    parentId: '66.2',
    level: 4,
  },
  {
    identifier: '66.29',
    name: 'Andra stödtjänster till försäkring och pensionsfondstjänster',
    nameEng: 'Other services auxiliary to insurance and pension funding',
    parentId: '66.2',
    level: 4,
  },
  {
    identifier: '66.3',
    name: 'Fondförvaltningstjänster',
    nameEng: 'Fund management services',
    parentId: '66',
    level: 3,
  },
  {
    identifier: '66.30',
    name: 'Fondförvaltningstjänster',
    nameEng: 'Fund management services',
    parentId: '66.3',
    level: 4,
  },
  {
    identifier: 'L',
    name: 'FASTIGHETSTJÄNSTER',
    nameEng: 'Real estate services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '68',
    name: 'Fastighetstjänster',
    nameEng: 'Real estate services',
    parentId: 'L',
    level: 2,
  },
  {
    identifier: '68.1',
    name: 'Handel med egna fastigheter',
    nameEng: 'Buying and selling services of own real estate',
    parentId: '68',
    level: 3,
  },
  {
    identifier: '68.10',
    name: 'Handel med egna fastigheter',
    nameEng: 'Buying and selling services of own real estate',
    parentId: '68.1',
    level: 4,
  },
  {
    identifier: '68.2',
    name: 'Tjänster avseende uthyrning och förvaltning av egna eller arrenderade fastigheter',
    nameEng: 'Rental and operating services of own or leased real estate',
    parentId: '68',
    level: 3,
  },
  {
    identifier: '68.20',
    name: 'Tjänster avseende uthyrning och förvaltning av egna eller arrenderade fastigheter',
    nameEng: 'Rental and operating services of own or leased real estate',
    parentId: '68.2',
    level: 4,
  },
  {
    identifier: '68.3',
    name: 'Tjänster avseende fastighetsförmedling och fastighetsförvaltning på uppdrag',
    nameEng: 'Real estate services on a fee or contract basis',
    parentId: '68',
    level: 3,
  },
  {
    identifier: '68.31',
    name: 'Tjänster avseende fastighetsförmedling på uppdrag',
    nameEng: 'Real estate agency services on a fee or contract basis',
    parentId: '68.3',
    level: 4,
  },
  {
    identifier: '68.32',
    name: 'Tjänster avseende fastighetsförvaltning på uppdrag',
    nameEng: 'Management services of real estate on a fee or contract basis',
    parentId: '68.3',
    level: 4,
  },
  {
    identifier: 'M',
    name: 'TJÄNSTER INOM JURIDIK, EKONOMI, VETENSKAP OCH TEKNIK',
    nameEng: 'Professional, scientific and technical services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '69',
    name: 'Juridiska och ekonomiska konsulttjänster',
    nameEng: 'Legal and accounting services',
    parentId: 'M',
    level: 2,
  },
  {
    identifier: '69.1',
    name: 'Juridiska tjänster',
    nameEng: 'Legal services',
    parentId: '69',
    level: 3,
  },
  {
    identifier: '69.10',
    name: 'Juridiska tjänster',
    nameEng: 'Legal services',
    parentId: '69.1',
    level: 4,
  },
  {
    identifier: '69.2',
    name: 'Tjänster avseende redovisning, bokföring och revision, skatterådgivning',
    nameEng:
      'Accounting, bookkeeping and auditing services; tax consulting services',
    parentId: '69',
    level: 3,
  },
  {
    identifier: '69.20',
    name: 'Tjänster avseende redovisning, bokföring och revision, skatterådgivning',
    nameEng:
      'Accounting, bookkeeping and auditing services; tax consulting services',
    parentId: '69.2',
    level: 4,
  },
  {
    identifier: '70',
    name: 'Tjänster som tillhandahålls av huvudkontor; företagsrådgivningstjänster',
    nameEng: 'Services of head offices; management consulting services',
    parentId: 'M',
    level: 2,
  },
  {
    identifier: '70.1',
    name: 'Tjänster som tillhandahålls av huvudkontor',
    nameEng: 'Services of head offices',
    parentId: '70',
    level: 3,
  },
  {
    identifier: '70.10',
    name: 'Tjänster som tillhandahålls av huvudkontor',
    nameEng: 'Services of head offices',
    parentId: '70.1',
    level: 4,
  },
  {
    identifier: '70.2',
    name: 'Företagsrådgivningstjänster',
    nameEng: 'Management consulting services',
    parentId: '70',
    level: 3,
  },
  {
    identifier: '70.21',
    name: 'Tjänster avseende PR och kommunikation',
    nameEng: 'Public relations and communication services',
    parentId: '70.2',
    level: 4,
  },
  {
    identifier: '70.22',
    name: 'Konsulttjänster avseende företags organisation, information o.d.',
    nameEng: 'Business and other management consulting services',
    parentId: '70.2',
    level: 4,
  },
  {
    identifier: '71',
    name: 'Arkitekt- och tekniska konsulttjänster; teknisk provning och analys',
    nameEng:
      'Architectural and engineering services; technical testing and analysis services',
    parentId: 'M',
    level: 2,
  },
  {
    identifier: '71.1',
    name: 'Arkitekt- och tekniska konsulttjänster',
    nameEng:
      'Architectural and engineering services and related technical consulting services',
    parentId: '71',
    level: 3,
  },
  {
    identifier: '71.11',
    name: 'Arkitekttjänster',
    nameEng: 'Architectural services',
    parentId: '71.1',
    level: 4,
  },
  {
    identifier: '71.12',
    name: 'Tekniska konsulttjänster o.d.',
    nameEng: 'Engineering services and related technical consulting services',
    parentId: '71.1',
    level: 4,
  },
  {
    identifier: '71.2',
    name: 'Tjänster avseende teknisk provning och analys',
    nameEng: 'Technical testing and analysis services',
    parentId: '71',
    level: 3,
  },
  {
    identifier: '71.20',
    name: 'Tjänster avseende teknisk provning och analys',
    nameEng: 'Technical testing and analysis services',
    parentId: '71.2',
    level: 4,
  },
  {
    identifier: '72',
    name: 'Tjänster avseende vetenskaplig forskning och utveckling',
    nameEng: 'Scientific research and development services',
    parentId: 'M',
    level: 2,
  },
  {
    identifier: '72.0',
    name: 'Tjänster avseende tvärvetenskaplig forskning och utveckling',
    nameEng: 'Interdisciplinary research and experimental development services',
    parentId: '72',
    level: 3,
  },
  {
    identifier: '72.00',
    name: 'Tjänster avseende tvärvetenskaplig forskning och utveckling',
    nameEng: 'Interdisciplinary research and experimental development services',
    parentId: '72.0',
    level: 4,
  },
  {
    identifier: '72.1',
    name: 'Tjänster avseende naturvetenskaplig och teknisk forskning och utveckling',
    nameEng:
      'Research and experimental development services in natural sciences and engineering',
    parentId: '72',
    level: 3,
  },
  {
    identifier: '72.11',
    name: 'Tjänster avseende bioteknisk forskning och utveckling',
    nameEng: 'Research and experimental development services in biotechnology',
    parentId: '72.1',
    level: 4,
  },
  {
    identifier: '72.19',
    name: 'Tjänster avseende forskning och utveckling inom andra naturvetenskapliga och tekniska områden',
    nameEng:
      'Research and experimental development services in other natural sciences and engineering',
    parentId: '72.1',
    level: 4,
  },
  {
    identifier: '72.2',
    name: 'Tjänster avseende samhällsvetenskaplig och humanistisk forskning och utveckling',
    nameEng:
      'Research and experimental development services in social sciences and humanities',
    parentId: '72',
    level: 3,
  },
  {
    identifier: '72.20',
    name: 'Tjänster avseende samhällsvetenskaplig och humanistisk forskning och utveckling',
    nameEng:
      'Research and experimental development services in social sciences and humanities',
    parentId: '72.2',
    level: 4,
  },
  {
    identifier: '73',
    name: 'Reklam och marknadsundersökningstjänster',
    nameEng: 'Advertising and market research services',
    parentId: 'M',
    level: 2,
  },
  {
    identifier: '73.1',
    name: 'Reklamtjänster',
    nameEng: 'Advertising services',
    parentId: '73',
    level: 3,
  },
  {
    identifier: '73.11',
    name: 'Tjänster som tillhandahålls av reklambyråer o.d.',
    nameEng: 'Services provided by advertising agencies',
    parentId: '73.1',
    level: 4,
  },
  {
    identifier: '73.12',
    name: 'Mediebyråtjänster och annonsförsäljning',
    nameEng: 'Media representation services',
    parentId: '73.1',
    level: 4,
  },
  {
    identifier: '73.2',
    name: 'Tjänster avseende marknads- och opinionsundersökningar',
    nameEng: 'Market research and public opinion polling services',
    parentId: '73',
    level: 3,
  },
  {
    identifier: '73.20',
    name: 'Tjänster avseende marknads- och opinionsundersökningar',
    nameEng: 'Market research and public opinion polling services',
    parentId: '73.2',
    level: 4,
  },
  {
    identifier: '74',
    name: 'Tjänster från annan verksamhet inom juridik, ekonomi, vetenskap och teknik',
    nameEng: 'Other professional, scientific and technical services',
    parentId: 'M',
    level: 2,
  },
  {
    identifier: '74.1',
    name: 'Specialiserade designtjänster',
    nameEng: 'Specialised design services',
    parentId: '74',
    level: 3,
  },
  {
    identifier: '74.10',
    name: 'Specialiserade designtjänster',
    nameEng: 'Specialised design services',
    parentId: '74.1',
    level: 4,
  },
  {
    identifier: '74.2',
    name: 'Fototjänster',
    nameEng: 'Photographic services',
    parentId: '74',
    level: 3,
  },
  {
    identifier: '74.20',
    name: 'Fototjänster',
    nameEng: 'Photographic services',
    parentId: '74.2',
    level: 4,
  },
  {
    identifier: '74.3',
    name: 'Översättnings- och tolkningstjänster',
    nameEng: 'Translation and interpretation services',
    parentId: '74',
    level: 3,
  },
  {
    identifier: '74.30',
    name: 'Översättnings- och tolkningstjänster',
    nameEng: 'Translation and interpretation services',
    parentId: '74.3',
    level: 4,
  },
  {
    identifier: '74.9',
    name: 'Övriga tjänster inom juridik, ekonomi, vetenskap och teknik',
    nameEng: 'Other professional, scientific and technical services n.e.c.',
    parentId: '74',
    level: 3,
  },
  {
    identifier: '74.90',
    name: 'Övriga tjänster inom juridik, ekonomi, vetenskap och teknik',
    nameEng: 'Other professional, scientific and technical services n.e.c.',
    parentId: '74.9',
    level: 4,
  },
  {
    identifier: '75',
    name: 'Veterinärtjänster',
    nameEng: 'Veterinary services',
    parentId: 'M',
    level: 2,
  },
  {
    identifier: '75.0',
    name: 'Veterinärtjänster',
    nameEng: 'Veterinary services',
    parentId: '75',
    level: 3,
  },
  {
    identifier: '75.00',
    name: 'Veterinärtjänster',
    nameEng: 'Veterinary services',
    parentId: '75.0',
    level: 4,
  },
  {
    identifier: 'N',
    name: 'UTHYRNINGS-, FASTIGHETSSERVICE-, RESETJÄNSTER OCH ANDRA STÖDTJÄNSTER',
    nameEng: 'Administrative and support services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '77',
    name: 'Tjänster avseende uthyrning och leasing',
    nameEng: 'Rental and leasing services',
    parentId: 'N',
    level: 2,
  },
  {
    identifier: '77.1',
    name: 'Tjänster avseende uthyrning och leasing av motorfordon',
    nameEng: 'Rental and leasing services of motor vehicles',
    parentId: '77',
    level: 3,
  },
  {
    identifier: '77.11',
    name: 'Tjänster avseende uthyrning och leasing av personbilar och lätta motorfordon',
    nameEng: 'Rental and leasing services of cars and light motor vehicles',
    parentId: '77.1',
    level: 4,
  },
  {
    identifier: '77.12',
    name: 'Tjänster avseende uthyrning och leasing av lastbilar',
    nameEng: 'Rental and leasing services of trucks',
    parentId: '77.1',
    level: 4,
  },
  {
    identifier: '77.2',
    name: 'Tjänster avseende uthyrning och leasing av hushållsartiklar och varor för personligt bruk',
    nameEng: 'Rental and leasing services of personal and household goods',
    parentId: '77',
    level: 3,
  },
  {
    identifier: '77.21',
    name: 'Tjänster avseende uthyrning och leasing av fritids- och sportutrustning',
    nameEng: 'Rental and leasing services of recreational and sports goods',
    parentId: '77.2',
    level: 4,
  },
  {
    identifier: '77.22',
    name: 'Tjänster avseende uthyrning av videokassetter och dvd-skivor',
    nameEng: 'Rental services of video tapes and disks',
    parentId: '77.2',
    level: 4,
  },
  {
    identifier: '77.29',
    name: 'Tjänster avseende uthyrning och leasing av andra hushållsartiklar och varor för personligt bruk',
    nameEng:
      'Rental and leasing services of other personal and household goods',
    parentId: '77.2',
    level: 4,
  },
  {
    identifier: '77.3',
    name: 'Tjänster avseende uthyrning och leasing av annan utrustning och andra maskiner och materiella tillgångar',
    nameEng:
      'Rental and leasing services of other machinery, equipment and tangible goods',
    parentId: '77',
    level: 3,
  },
  {
    identifier: '77.31',
    name: 'Tjänster avseende uthyrning och leasing av jordbruksmaskiner och jordbruksredskap',
    nameEng:
      'Rental and leasing services of agricultural machinery and equipment',
    parentId: '77.3',
    level: 4,
  },
  {
    identifier: '77.32',
    name: 'Tjänster avseende uthyrning och leasing av bygg- och anläggningsmaskiner',
    nameEng:
      'Rental and leasing services of construction and civil engineering machinery and equipment',
    parentId: '77.3',
    level: 4,
  },
  {
    identifier: '77.33',
    name: 'Tjänster avseende uthyrning och leasing av kontorsmaskiner och kontorsutrustning (inklusive datorer)',
    nameEng:
      'Rental and leasing services of office machinery and equipment (including computers)',
    parentId: '77.3',
    level: 4,
  },
  {
    identifier: '77.34',
    name: 'Tjänster avseende uthyrning och leasing av fartyg',
    nameEng: 'Rental and leasing services of water transport equipment',
    parentId: '77.3',
    level: 4,
  },
  {
    identifier: '77.35',
    name: 'Tjänster avseende uthyrning och leasing av flygplan',
    nameEng: 'Rental and leasing services of air transport equipment',
    parentId: '77.3',
    level: 4,
  },
  {
    identifier: '77.39',
    name: 'Tjänster avseende uthyrning och leasing av övrig utrustning och övriga maskiner och materiella tillgångar',
    nameEng:
      'Rental and leasing services of other machinery, equipment and tangible goods n.e.c.',
    parentId: '77.3',
    level: 4,
  },
  {
    identifier: '77.4',
    name: 'Tjänster avseende licensiering för rätten att använda immateriella rättigheter och liknande produkter, utom verk som omfattas av copyright',
    nameEng:
      'Licensing services for the right to use intellectual property and similar products, except copyrighted works',
    parentId: '77',
    level: 3,
  },
  {
    identifier: '77.40',
    name: 'Tjänster avseende licensiering för rätten att använda immateriella rättigheter och liknande produkter, utom verk som omfattas av copyright',
    nameEng:
      'Licensing services for the right to use intellectual property and similar products, except copyrighted works',
    parentId: '77.4',
    level: 4,
  },
  {
    identifier: '78',
    name: 'Arbetsförmedlings-, bemannings- och andra personalrelaterade tjänster',
    nameEng: 'Employment services',
    parentId: 'N',
    level: 2,
  },
  {
    identifier: '78.1',
    name: 'Arbetsförmedlings- och rekryteringstjänster',
    nameEng: 'Services provided by employment placement agencies',
    parentId: '78',
    level: 3,
  },
  {
    identifier: '78.10',
    name: 'Arbetsförmedlings- och rekryteringstjänster',
    nameEng: 'Services provided by employment placement agencies',
    parentId: '78.1',
    level: 4,
  },
  {
    identifier: '78.2',
    name: 'Tjänster avseende personaluthyrning',
    nameEng: 'Temporary employment agency services',
    parentId: '78',
    level: 3,
  },
  {
    identifier: '78.20',
    name: 'Tjänster avseende personaluthyrning',
    nameEng: 'Temporary employment agency services',
    parentId: '78.2',
    level: 4,
  },
  {
    identifier: '78.3',
    name: 'Övriga personalfunktionstjänster',
    nameEng: 'Other human resources provision services',
    parentId: '78',
    level: 3,
  },
  {
    identifier: '78.30',
    name: 'Övriga personalfunktionstjänster',
    nameEng: 'Other human resources provision services',
    parentId: '78.3',
    level: 4,
  },
  {
    identifier: '79',
    name: 'Resetjänster och relaterade tjänster',
    nameEng:
      'Travel agency, tour operator and other reservation services and related services',
    parentId: 'N',
    level: 2,
  },
  {
    identifier: '79.1',
    name: 'Resetjänster',
    nameEng: 'Travel agency and tour operator services',
    parentId: '79',
    level: 3,
  },
  {
    identifier: '79.11',
    name: 'Tjänster avseende resebyråverksamhet',
    nameEng: 'Travel agency services',
    parentId: '79.1',
    level: 4,
  },
  {
    identifier: '79.12',
    name: 'Researrangörstjänster',
    nameEng: 'Tour operator services',
    parentId: '79.1',
    level: 4,
  },
  {
    identifier: '79.9',
    name: 'Andra reservationstjänster och därmed relaterade tjänster',
    nameEng: 'Other reservation services and related services',
    parentId: '79',
    level: 3,
  },
  {
    identifier: '79.90',
    name: 'Andra reservationstjänster och därmed relaterade tjänster',
    nameEng: 'Other reservation services and related services',
    parentId: '79.9',
    level: 4,
  },
  {
    identifier: '80',
    name: 'Säkerhets- och bevakningstjänster',
    nameEng: 'Security and investigation services',
    parentId: 'N',
    level: 2,
  },
  {
    identifier: '80.1',
    name: 'Säkerhetstjänster',
    nameEng: 'Private security services',
    parentId: '80',
    level: 3,
  },
  {
    identifier: '80.10',
    name: 'Säkerhetstjänster',
    nameEng: 'Private security services',
    parentId: '80.1',
    level: 4,
  },
  {
    identifier: '80.2',
    name: 'Säkerhetssystemtjänster',
    nameEng: 'Security systems services',
    parentId: '80',
    level: 3,
  },
  {
    identifier: '80.20',
    name: 'Säkerhetssystemtjänster',
    nameEng: 'Security systems services',
    parentId: '80.2',
    level: 4,
  },
  {
    identifier: '80.3',
    name: 'Spanings- och detektivtjänster',
    nameEng: 'Investigation services',
    parentId: '80',
    level: 3,
  },
  {
    identifier: '80.30',
    name: 'Spanings- och detektivtjänster',
    nameEng: 'Investigation services',
    parentId: '80.3',
    level: 4,
  },
  {
    identifier: '81',
    name: 'Fastighetstjänster till byggnader samt skötsel och underhåll av grönytor',
    nameEng: 'Services to buildings and landscape',
    parentId: 'N',
    level: 2,
  },
  {
    identifier: '81.1',
    name: 'Fastighetsrelaterade stödtjänster',
    nameEng: 'Combined facilities support services',
    parentId: '81',
    level: 3,
  },
  {
    identifier: '81.10',
    name: 'Fastighetsrelaterade stödtjänster',
    nameEng: 'Combined facilities support services',
    parentId: '81.1',
    level: 4,
  },
  {
    identifier: '81.2',
    name: 'Tjänster avseende rengöring och lokalvård',
    nameEng: 'Cleaning services',
    parentId: '81',
    level: 3,
  },
  {
    identifier: '81.21',
    name: 'Tjänster avseende lokalvård',
    nameEng: 'General cleaning services of buildings',
    parentId: '81.2',
    level: 4,
  },
  {
    identifier: '81.22',
    name: 'Tjänster avseende rengöring och sotning av byggnader',
    nameEng: 'Other building and industrial cleaning services',
    parentId: '81.2',
    level: 4,
  },
  {
    identifier: '81.29',
    name: 'Tjänster avseende annan rengöring',
    nameEng: 'Other cleaning services',
    parentId: '81.2',
    level: 4,
  },
  {
    identifier: '81.3',
    name: 'Tjänster avseende skötsel och underhåll av grönytor',
    nameEng: 'Landscape services',
    parentId: '81',
    level: 3,
  },
  {
    identifier: '81.30',
    name: 'Tjänster avseende skötsel och underhåll av grönytor',
    nameEng: 'Landscape services',
    parentId: '81.3',
    level: 4,
  },
  {
    identifier: '82',
    name: 'Kontorstjänster och andra företagstjänster',
    nameEng:
      'Office administrative, office support and other business support services',
    parentId: 'N',
    level: 2,
  },
  {
    identifier: '82.1',
    name: 'Kontorstjänster',
    nameEng: 'Office administrative and support services',
    parentId: '82',
    level: 3,
  },
  {
    identifier: '82.11',
    name: 'Kombinerade kontorstjänster',
    nameEng: 'Combined office administrative services',
    parentId: '82.1',
    level: 4,
  },
  {
    identifier: '82.19',
    name: 'Kopiering, dokumentsammanställning och andra specialiserade kontorstjänster',
    nameEng:
      'Photocopying, document preparation and other specialised office support services',
    parentId: '82.1',
    level: 4,
  },
  {
    identifier: '82.2',
    name: 'Callcentertjänster',
    nameEng: 'Call centre services',
    parentId: '82',
    level: 3,
  },
  {
    identifier: '82.20',
    name: 'Callcentertjänster',
    nameEng: 'Call centre services',
    parentId: '82.2',
    level: 4,
  },
  {
    identifier: '82.3',
    name: 'Tjänster avseende arrangemang av kongresser och mässor',
    nameEng: 'Convention and trade show organisation services',
    parentId: '82',
    level: 3,
  },
  {
    identifier: '82.30',
    name: 'Tjänster avseende arrangemang av kongresser och mässor',
    nameEng: 'Convention and trade show organisation services',
    parentId: '82.3',
    level: 4,
  },
  {
    identifier: '82.9',
    name: 'Diverse stödtjänster till företagen',
    nameEng: 'Business support services n.e.c.',
    parentId: '82',
    level: 3,
  },
  {
    identifier: '82.91',
    name: 'Inkasso- och kreditupplysningstjänster',
    nameEng: 'Collection agency and credit bureau services',
    parentId: '82.9',
    level: 4,
  },
  {
    identifier: '82.92',
    name: 'Förpackningstjänster',
    nameEng: 'Packaging services',
    parentId: '82.9',
    level: 4,
  },
  {
    identifier: '82.99',
    name: 'Övriga företagstjänster',
    nameEng: 'Other business support services n.e.c.',
    parentId: '82.9',
    level: 4,
  },
  {
    identifier: 'O',
    name: 'OFFENTLIG FÖRVALTNING OCH FÖRSVAR; OBLIGATORISK SOCIALFÖRSÄKRING',
    nameEng:
      'Public administration and defence services; compulsory social security services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '84',
    name: 'Tjänster avseende offentlig förvaltning och försvar; obligatorisk socialförsäkring',
    nameEng:
      'Public administration and defence services; compulsory social security services',
    parentId: 'O',
    level: 2,
  },
  {
    identifier: '84.1',
    name: 'Tjänster avseende offentlig förvaltning',
    nameEng:
      'Administration services of the State and the economic and social policy of the community',
    parentId: '84',
    level: 3,
  },
  {
    identifier: '84.11',
    name: 'Tjänster avseende övergripande offentlig förvaltning',
    nameEng: 'General public administration services',
    parentId: '84.1',
    level: 4,
  },
  {
    identifier: '84.12',
    name: 'Tjänster avseende administration rörande regleringen av vård-, utbildnings-, kulturinrättningar samt annan samhällsservice, utom social trygghet',
    nameEng:
      'Administrative services for the regulation of health care, education, cultural services and other social services, excluding social security',
    parentId: '84.1',
    level: 4,
  },
  {
    identifier: '84.13',
    name: 'Tjänster avseende administration av näringslivsprogram',
    nameEng:
      'Administrative services for more efficient operation of businesses',
    parentId: '84.1',
    level: 4,
  },
  {
    identifier: '84.2',
    name: 'Offentliga tjänster',
    nameEng: 'Provision of services to the community as a whole',
    parentId: '84',
    level: 3,
  },
  {
    identifier: '84.21',
    name: 'Tjänster avseende utrikesförvaltning',
    nameEng: 'Foreign affairs services',
    parentId: '84.2',
    level: 4,
  },
  {
    identifier: '84.22',
    name: 'Tjänster avseende totalförsvar',
    nameEng: 'Defence services',
    parentId: '84.2',
    level: 4,
  },
  {
    identifier: '84.23',
    name: 'Tjänster avseende rättskipning',
    nameEng: 'Justice and judicial services',
    parentId: '84.2',
    level: 4,
  },
  {
    identifier: '84.24',
    name: 'Polistjänster m.m.',
    nameEng: 'Public order and safety services',
    parentId: '84.2',
    level: 4,
  },
  {
    identifier: '84.25',
    name: 'Brand- och räddningskårstjänster',
    nameEng: 'Fire brigade services',
    parentId: '84.2',
    level: 4,
  },
  {
    identifier: '84.3',
    name: 'Tjänster avseende obligatorisk socialförsäkring',
    nameEng: 'Compulsory social security services',
    parentId: '84',
    level: 3,
  },
  {
    identifier: '84.30',
    name: 'Tjänster avseende obligatorisk socialförsäkring',
    nameEng: 'Compulsory social security services',
    parentId: '84.3',
    level: 4,
  },
  {
    identifier: 'P',
    name: 'TJÄNSTER AVSEENDE UTBILDNING',
    nameEng: 'Education services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '85',
    name: 'Tjänster avseende utbildning',
    nameEng: 'Education services',
    parentId: 'P',
    level: 2,
  },
  {
    identifier: '85.1',
    name: 'Förskoleutbildningstjänster',
    nameEng: 'Pre-primary education services',
    parentId: '85',
    level: 3,
  },
  {
    identifier: '85.10',
    name: 'Förskoleutbildningstjänster',
    nameEng: 'Pre-primary education services',
    parentId: '85.1',
    level: 4,
  },
  {
    identifier: '85.2',
    name: 'Grundskoleutbildningstjänster',
    nameEng: 'Primary education services',
    parentId: '85',
    level: 3,
  },
  {
    identifier: '85.20',
    name: 'Grundskoleutbildningstjänster',
    nameEng: 'Primary education services',
    parentId: '85.2',
    level: 4,
  },
  {
    identifier: '85.3',
    name: 'Gymnasiala utbildningstjänster',
    nameEng: 'Secondary education services',
    parentId: '85',
    level: 3,
  },
  {
    identifier: '85.31',
    name: 'Studieförberedande gymnasiala utbildningstjänster',
    nameEng: 'General secondary education services',
    parentId: '85.3',
    level: 4,
  },
  {
    identifier: '85.32',
    name: 'Tjänster avseende yrkesinriktad utbildning på högstadie- och gymnasienivå',
    nameEng: 'Technical and vocational secondary education services',
    parentId: '85.3',
    level: 4,
  },
  {
    identifier: '85.4',
    name: 'Eftergymnasiala utbildningstjänster',
    nameEng: 'Higher education services',
    parentId: '85',
    level: 3,
  },
  {
    identifier: '85.41',
    name: 'Tjänster avseende eftergymnasial utbildning som ej förlagts till universitet eller högskola',
    nameEng: 'Post-secondary non-tertiary education services',
    parentId: '85.4',
    level: 4,
  },
  {
    identifier: '85.42',
    name: 'Tjänster avseende högskoleutbildning',
    nameEng: 'Tertiary education services',
    parentId: '85.4',
    level: 4,
  },
  {
    identifier: '85.5',
    name: 'Övriga utbildningstjänster',
    nameEng: 'Other education services',
    parentId: '85',
    level: 3,
  },
  {
    identifier: '85.51',
    name: 'Tjänster avseende sport- och fritidsutbildning',
    nameEng: 'Sports and recreation education services',
    parentId: '85.5',
    level: 4,
  },
  {
    identifier: '85.52',
    name: 'Kulturella utbildningstjänster',
    nameEng: 'Cultural education services',
    parentId: '85.5',
    level: 4,
  },
  {
    identifier: '85.53',
    name: 'Trafikskoletjänster',
    nameEng: 'Driving school services',
    parentId: '85.5',
    level: 4,
  },
  {
    identifier: '85.59',
    name: 'Tjänster avseende övrig utbildning',
    nameEng: 'Other education services n.e.c.',
    parentId: '85.5',
    level: 4,
  },
  {
    identifier: '85.6',
    name: 'Stödtjänster för utbildningsväsendet',
    nameEng: 'Educational support services',
    parentId: '85',
    level: 3,
  },
  {
    identifier: '85.60',
    name: 'Stödtjänster för utbildningsväsendet',
    nameEng: 'Educational support services',
    parentId: '85.6',
    level: 4,
  },
  {
    identifier: 'Q',
    name: 'VÅRD OCH OMSORG; SOCIALA TJÄNSTER',
    nameEng: 'Human health and social work services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '86',
    name: 'Tjänster avseende hälso- och sjukvård',
    nameEng: 'Human health services',
    parentId: 'Q',
    level: 2,
  },
  {
    identifier: '86.1',
    name: 'Tjänster avseende sluten sjukvård',
    nameEng: 'Hospital services',
    parentId: '86',
    level: 3,
  },
  {
    identifier: '86.10',
    name: 'Tjänster avseende sluten sjukvård',
    nameEng: 'Hospital services',
    parentId: '86.1',
    level: 4,
  },
  {
    identifier: '86.2',
    name: 'Tjänster avseende öppen hälso- och sjukvård, tandvård',
    nameEng: 'Medical and dental practice services',
    parentId: '86',
    level: 3,
  },
  {
    identifier: '86.21',
    name: 'Allmänpraktiserande läkares tjänster',
    nameEng: 'General medical practice services',
    parentId: '86.2',
    level: 4,
  },
  {
    identifier: '86.22',
    name: 'Specialistläkartjänster inom öppenvård',
    nameEng: 'Specialist medical practice services',
    parentId: '86.2',
    level: 4,
  },
  {
    identifier: '86.23',
    name: 'Tandläkartjänster',
    nameEng: 'Dental practice services',
    parentId: '86.2',
    level: 4,
  },
  {
    identifier: '86.9',
    name: 'Tjänster avseende annan hälso- och sjukvård',
    nameEng: 'Other human health services',
    parentId: '86',
    level: 3,
  },
  {
    identifier: '86.90',
    name: 'Tjänster avseende annan hälso- och sjukvård',
    nameEng: 'Other human health services',
    parentId: '86.9',
    level: 4,
  },
  {
    identifier: '87',
    name: 'Tjänster avseende vård och omsorg med boende',
    nameEng: 'Residential care services',
    parentId: 'Q',
    level: 2,
  },
  {
    identifier: '87.1',
    name: 'Tjänster avseende boende med sjuksköterskevård',
    nameEng: 'Residential nursing care services',
    parentId: '87',
    level: 3,
  },
  {
    identifier: '87.10',
    name: 'Tjänster avseende boende med sjuksköterskevård',
    nameEng: 'Residential nursing care services',
    parentId: '87.1',
    level: 4,
  },
  {
    identifier: '87.2',
    name: 'Tjänster avseende boende med särskild service för personer med utvecklingsstörning, psykiska funktionshinder eller missbruksproblem',
    nameEng:
      'Residential care services for mental retardation, mental health and substance abuse',
    parentId: '87',
    level: 3,
  },
  {
    identifier: '87.20',
    name: 'Tjänster avseende boende med särskild service för personer med utvecklingsstörning, psykiska funktionshinder eller missbruksproblem',
    nameEng:
      'Residential care services for mental retardation, mental health and substance abuse',
    parentId: '87.2',
    level: 4,
  },
  {
    identifier: '87.3',
    name: 'Tjänster avseende vård och omsorg i särskilda boendeformer för äldre och funktionshindrade personer',
    nameEng: 'Residential care services for the elderly and disabled',
    parentId: '87',
    level: 3,
  },
  {
    identifier: '87.30',
    name: 'Tjänster avseende vård och omsorg i särskilda boendeformer för äldre och funktionshindrade personer',
    nameEng: 'Residential care services for the elderly and disabled',
    parentId: '87.3',
    level: 4,
  },
  {
    identifier: '87.9',
    name: 'Tjänster avseende annan vård och omsorg med boende',
    nameEng: 'Other residential care services',
    parentId: '87',
    level: 3,
  },
  {
    identifier: '87.90',
    name: 'Tjänster avseende annan vård och omsorg med boende',
    nameEng: 'Other residential care services',
    parentId: '87.9',
    level: 4,
  },
  {
    identifier: '88',
    name: 'Tjänster avseende öppna sociala insatser',
    nameEng: 'Social work services without accommodation',
    parentId: 'Q',
    level: 2,
  },
  {
    identifier: '88.1',
    name: 'Tjänster avseende öppna sociala insatser för äldre och funktionshindrade personer',
    nameEng:
      'Social work services without accommodation for the elderly and disabled',
    parentId: '88',
    level: 3,
  },
  {
    identifier: '88.10',
    name: 'Tjänster avseende öppna sociala insatser för äldre och funktionshindrade personer',
    nameEng:
      'Social work services without accommodation for the elderly and disabled',
    parentId: '88.1',
    level: 4,
  },
  {
    identifier: '88.9',
    name: 'Tjänster avseende andra öppna sociala insatser',
    nameEng: 'Other social work services without accommodation',
    parentId: '88',
    level: 3,
  },
  {
    identifier: '88.91',
    name: 'Tjänster avseende dagbarnvård',
    nameEng: 'Child day-care services',
    parentId: '88.9',
    level: 4,
  },
  {
    identifier: '88.99',
    name: 'Tjänster avseende övriga öppna sociala insatser',
    nameEng: 'Other social work services without accommodation n.e.c.',
    parentId: '88.9',
    level: 4,
  },
  {
    identifier: 'R',
    name: 'TJÄNSTER AVSEENDE KULTUR, NÖJE OCH FRITID',
    nameEng: 'Arts, entertainment and recreation services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '90',
    name: 'Konstnärliga och kulturella tjänster samt underhållningstjänster',
    nameEng: 'Creative, arts and entertainment services',
    parentId: 'R',
    level: 2,
  },
  {
    identifier: '90.0',
    name: 'Konstnärliga och kulturella tjänster samt underhållningstjänster',
    nameEng: 'Creative, arts and entertainment services',
    parentId: '90',
    level: 3,
  },
  {
    identifier: '90.01',
    name: 'Tjänster som tillhandahålls av artister',
    nameEng: 'Services of performing artists',
    parentId: '90.0',
    level: 4,
  },
  {
    identifier: '90.02',
    name: 'Stödtjänster till artistisk verksamhet',
    nameEng: 'Support services to performing arts',
    parentId: '90.0',
    level: 4,
  },
  {
    identifier: '90.03',
    name: 'Litterärt och konstnärligt skapande',
    nameEng: 'Artistic creation',
    parentId: '90.0',
    level: 4,
  },
  {
    identifier: '90.04',
    name: 'Operativa tjänster avseende teatrar, konserthus o.d.',
    nameEng: 'Arts facility operation services',
    parentId: '90.0',
    level: 4,
  },
  {
    identifier: '91',
    name: 'Biblioteks-, arkiv- och museitjänster m.m.',
    nameEng: 'Library, archive, museum and other cultural services',
    parentId: 'R',
    level: 2,
  },
  {
    identifier: '91.0',
    name: 'Biblioteks-, arkiv- och museitjänster m.m.',
    nameEng: 'Library, archive, museum and other cultural services',
    parentId: '91',
    level: 3,
  },
  {
    identifier: '91.01',
    name: 'Biblioteks- och arkivtjänster',
    nameEng: 'Library and archive services',
    parentId: '91.0',
    level: 4,
  },
  {
    identifier: '91.02',
    name: 'Museitjänster',
    nameEng: 'Museum services',
    parentId: '91.0',
    level: 4,
  },
  {
    identifier: '91.03',
    name: 'Tjänster avseende vård av historiska minnesmärken och byggnader och liknande sevärdheter',
    nameEng:
      'Operation services of historical sites and buildings and similar visitor attractions',
    parentId: '91.0',
    level: 4,
  },
  {
    identifier: '91.04',
    name: 'Botaniska trädgårdars, djurparkers och naturreservats tjänster',
    nameEng:
      'Botanical and zoological garden services and nature reserve services',
    parentId: '91.0',
    level: 4,
  },
  {
    identifier: '92',
    name: 'Spel- och vadhållningstjänster',
    nameEng: 'Gambling and betting services',
    parentId: 'R',
    level: 2,
  },
  {
    identifier: '92.0',
    name: 'Spel- och vadhållningstjänster',
    nameEng: 'Gambling and betting services',
    parentId: '92',
    level: 3,
  },
  {
    identifier: '92.00',
    name: 'Spel- och vadhållningstjänster',
    nameEng: 'Gambling and betting services',
    parentId: '92.0',
    level: 4,
  },
  {
    identifier: '93',
    name: 'Idrotts-, fritids- och nöjestjänster',
    nameEng: 'Sporting services and amusement and recreation services',
    parentId: 'R',
    level: 2,
  },
  {
    identifier: '93.1',
    name: 'Sporttjänster ',
    nameEng: 'Sporting services',
    parentId: '93',
    level: 3,
  },
  {
    identifier: '93.11',
    name: 'Operativa tjänster för idrottsanläggningar',
    nameEng: 'Sports facility operation services',
    parentId: '93.1',
    level: 4,
  },
  {
    identifier: '93.12',
    name: 'Sportklubbars och idrottsföreningars tjänster',
    nameEng: 'Services of sport clubs',
    parentId: '93.1',
    level: 4,
  },
  {
    identifier: '93.13',
    name: 'Gymtjänster',
    nameEng: 'Services of fitness facilities',
    parentId: '93.1',
    level: 4,
  },
  {
    identifier: '93.19',
    name: 'Andra sporttjänster',
    nameEng: 'Other sporting services',
    parentId: '93.1',
    level: 4,
  },
  {
    identifier: '93.2',
    name: 'Andra fritids- och nöjestjänster',
    nameEng: 'Amusement and recreation services',
    parentId: '93',
    level: 3,
  },
  {
    identifier: '93.21',
    name: 'Nöjes- och temaparkstjänster',
    nameEng: 'Amusement park and theme park services',
    parentId: '93.2',
    level: 4,
  },
  {
    identifier: '93.29',
    name: 'Övriga fritids- och nöjestjänster',
    nameEng: 'Other amusement and recreation services',
    parentId: '93.2',
    level: 4,
  },
  {
    identifier: 'S',
    name: 'ANDRA TJÄNSTER',
    nameEng: 'Other services',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '94',
    name: 'Tjänster som tillhandahålls av intresseorganisationer',
    nameEng: 'Services furnished by membership organisations',
    parentId: 'S',
    level: 2,
  },
  {
    identifier: '94.1',
    name: 'Tjänster avseende intressebevakning inom bransch-, arbetsgivar- och yrkesorganisationer',
    nameEng:
      'Services furnished by business, employers and professional membership organisations',
    parentId: '94',
    level: 3,
  },
  {
    identifier: '94.11',
    name: 'Tjänster avseende intressebevakning inom bransch- och arbetsgivarorganisationer',
    nameEng:
      'Services furnished by business and employers membership organisations',
    parentId: '94.1',
    level: 4,
  },
  {
    identifier: '94.12',
    name: 'Tjänster avseende intressebevakning inom yrkesorganisationer',
    nameEng: 'Services furnished by professional membership organisations',
    parentId: '94.1',
    level: 4,
  },
  {
    identifier: '94.2',
    name: 'Tjänster avseende intressebevakning inom arbetstagarorganisationer',
    nameEng: 'Services furnished by trade unions',
    parentId: '94',
    level: 3,
  },
  {
    identifier: '94.20',
    name: 'Tjänster avseende intressebevakning inom arbetstagarorganisationer',
    nameEng: 'Services furnished by trade unions',
    parentId: '94.2',
    level: 4,
  },
  {
    identifier: '94.9',
    name: 'Tjänster som tillhandahålls av andra intresseorganisationer',
    nameEng: 'Services furnished by other membership organisations',
    parentId: '94',
    level: 3,
  },
  {
    identifier: '94.91',
    name: 'Tjänster som tillhandahålls av religiösa organisationer',
    nameEng: 'Services furnished by religious organisations',
    parentId: '94.9',
    level: 4,
  },
  {
    identifier: '94.92',
    name: 'Tjänster som tillhandahålls av politiska organisationer',
    nameEng: 'Services furnished by political organisations',
    parentId: '94.9',
    level: 4,
  },
  {
    identifier: '94.99',
    name: 'Övriga tjänster som tillhandahålls av andra intresseorganisationer',
    nameEng: 'Services furnished by other membership organisations n.e.c.',
    parentId: '94.9',
    level: 4,
  },
  {
    identifier: '95',
    name: 'Tjänster avseende reparation av datorer, hushållsartiklar och personliga artiklar',
    nameEng: 'Repair services of computers and personal and household goods',
    parentId: 'S',
    level: 2,
  },
  {
    identifier: '95.1',
    name: 'Tjänster avseende reparation av datorer och kommunikationsutrustning',
    nameEng: 'Repair services of computers and communication equipment',
    parentId: '95',
    level: 3,
  },
  {
    identifier: '95.11',
    name: 'Tjänster avseende reparation av datorer och kringutrustning',
    nameEng: 'Repair services of computers and peripheral equipment',
    parentId: '95.1',
    level: 4,
  },
  {
    identifier: '95.12',
    name: 'Tjänster avseende reparation av kommunikationsutrustning',
    nameEng: 'Repair services of communication equipment',
    parentId: '95.1',
    level: 4,
  },
  {
    identifier: '95.2',
    name: 'Tjänster avseende reparation av hushållsartiklar och personliga artiklar',
    nameEng: 'Repair services of personal and household goods',
    parentId: '95',
    level: 3,
  },
  {
    identifier: '95.21',
    name: 'Tjänster avseende reparation av hemelektronik',
    nameEng: 'Repair services of consumer electronics',
    parentId: '95.2',
    level: 4,
  },
  {
    identifier: '95.22',
    name: 'Tjänster avseende reparation av hushållsapparater samt av utrustning för hem och trädgård',
    nameEng:
      'Repair services of household appliances and home and garden equipment',
    parentId: '95.2',
    level: 4,
  },
  {
    identifier: '95.23',
    name: 'Tjänster avseende lagning av skodon och lädervaror',
    nameEng: 'Repair services of footwear and leather goods',
    parentId: '95.2',
    level: 4,
  },
  {
    identifier: '95.24',
    name: 'Tjänster avseende reparation av möbler och heminredning',
    nameEng: 'Repair services of furniture and home furnishings',
    parentId: '95.2',
    level: 4,
  },
  {
    identifier: '95.25',
    name: 'Tjänster avseende reparation av ur och guldsmedsvaror',
    nameEng: 'Repair services of watches, clocks and jewellery',
    parentId: '95.2',
    level: 4,
  },
  {
    identifier: '95.29',
    name: 'Tjänster avseende reparation av andra hushållsartiklar och personliga artiklar',
    nameEng: 'Repair services of other personal and household goods',
    parentId: '95.2',
    level: 4,
  },
  {
    identifier: '96',
    name: 'Andra konsumenttjänster',
    nameEng: 'Other personal services',
    parentId: 'S',
    level: 2,
  },
  {
    identifier: '96.0',
    name: 'Andra konsumenttjänster',
    nameEng: 'Other personal services',
    parentId: '96',
    level: 3,
  },
  {
    identifier: '96.01',
    name: 'Tvätteritjänster',
    nameEng: 'Washing and (dry-)cleaning services of textile and fur products',
    parentId: '96.0',
    level: 4,
  },
  {
    identifier: '96.02',
    name: 'Tjänster avseende hår- och skönhetsvård',
    nameEng: 'Hairdressing and other beauty treatment services',
    parentId: '96.0',
    level: 4,
  },
  {
    identifier: '96.03',
    name: 'Begravningstjänster',
    nameEng: 'Funeral and related services',
    parentId: '96.0',
    level: 4,
  },
  {
    identifier: '96.04',
    name: 'Tjänster avseende kroppsvård',
    nameEng: 'Physical well-being services',
    parentId: '96.0',
    level: 4,
  },
  {
    identifier: '96.09',
    name: 'Övriga konsumenttjänster',
    nameEng: 'Other personal services n.e.c.',
    parentId: '96.0',
    level: 4,
  },
  {
    identifier: 'T',
    name: 'TJÄNSTER AVSEENDE FÖRVÄRVSARBETE I HUSHÅLL; HUSHÅLLENS PRODUKTION AV DIVERSE VAROR OCH TJÄNSTER FÖR EGET BRUK',
    nameEng:
      'Services of households as employers; undifferentiated goods and services produced by households for own use',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '97',
    name: 'Tjänster avseende förvärvsarbete i hushåll',
    nameEng: 'Services of households as employers of domestic personnel',
    parentId: 'T',
    level: 2,
  },
  {
    identifier: '97.0',
    name: 'Tjänster avseende förvärvsarbete i hushåll',
    nameEng: 'Services of households as employers of domestic personnel',
    parentId: '97',
    level: 3,
  },
  {
    identifier: '97.00',
    name: 'Tjänster avseende förvärvsarbete i hushåll',
    nameEng: 'Services of households as employers of domestic personnel',
    parentId: '97.0',
    level: 4,
  },
  {
    identifier: '98',
    name: 'Tjänster avseende hushållens produktion av diverse varor och tjänster för eget bruk',
    nameEng:
      'Undifferentiated goods and services produced by private households for own use',
    parentId: 'T',
    level: 2,
  },
  {
    identifier: '98.1',
    name: 'Tjänster avseende hushållens produktion av diverse varor för eget bruk',
    nameEng:
      'Undifferentiated goods produced by private households for own use',
    parentId: '98',
    level: 3,
  },
  {
    identifier: '98.10',
    name: 'Tjänster avseende hushållens produktion av diverse varor för eget bruk',
    nameEng:
      'Undifferentiated goods produced by private households for own use',
    parentId: '98.1',
    level: 4,
  },
  {
    identifier: '98.2',
    name: 'Tjänster avseende hushållens produktion av diverse tjänster för eget bruk',
    nameEng:
      'Undifferentiated services produced by private households for own use',
    parentId: '98',
    level: 3,
  },
  {
    identifier: '98.20',
    name: 'Tjänster avseende hushållens produktion av diverse tjänster för eget bruk',
    nameEng:
      'Undifferentiated services produced by private households for own use',
    parentId: '98.2',
    level: 4,
  },
  {
    identifier: 'U',
    name: 'INTERNATIONELLA ORGANISATIONERS, UTLÄNDSKA AMBASSADERS O.D. TJÄNSTER',
    nameEng: 'Services provided by extraterritorial organisations and bodies',
    // eslint-disable-next-line unicorn/no-null
    parentId: null,
    level: 1,
  },
  {
    identifier: '99',
    name: 'Internationella organisationers, utländska ambassaders o.d. tjänster',
    nameEng: 'Services provided by extraterritorial organisations and bodies',
    parentId: 'U',
    level: 2,
  },
  {
    identifier: '99.0',
    name: 'Internationella organisationers, utländska ambassaders o.d. tjänster',
    nameEng: 'Services provided by extraterritorial organisations and bodies',
    parentId: '99',
    level: 3,
  },
  {
    identifier: '99.00',
    name: 'Internationella organisationers, utländska ambassaders o.d. tjänster',
    nameEng: 'Services provided by extraterritorial organisations and bodies',
    parentId: '99.0',
    level: 4,
  },
];
